import type { AppMessages } from "./zh-CN";

/**
 * Deutscher Übersetzungskatalog. Die Schlüsselstruktur entspricht vollständig
 * dem englischen und chinesischen Katalog; Produktnamen und technische
 * Abkürzungen bleiben unverändert.
 */
export const deDE: AppMessages = {
  qaeCollection: {"startInstructions": "Öffnen Sie als Mandantenadministrator eine abgeschlossene Antwort in QAE und klicken Sie auf die grüne Synchronisationsschaltfläche. Prüfen Sie hier Frage, Antwort und Werkzeugaufrufe, bevor Sie speichern.", "openSource": "QAE öffnen ({host})", "backToBank": "Zurück zur Fragensammlung des Projekts", "unavailable": "Für dieses Konto oder Projekt ist die Fragensammlung aus QAE nicht verfügbar.", "sourcesFailed": "Die QAE-Quellen konnten nicht geladen werden. Bitte laden Sie die Seite neu.", "title": "Fragensammlung", "description": "Prüfen Sie die vollständige QAE-Antwort und Belege, bevor Sie sie in diesem Projekt speichern.", "expired": "Der Sammlungslink fehlt oder ist abgelaufen. Kehren Sie zu QAE zurück und klicken Sie erneut auf die grüne Aktion.", "saved": "Frage gespeichert", "savedDescription": "Die vollständige Frage, Antwort und Werkzeugbelege wurden mit einer neuen Testsuite gespeichert.", "viewQuestion": "Gespeicherte Frage anzeigen", "loading": "Vollständige Antwort und Werkzeugbelege werden geladen…", "context": "Wählen Sie die vorherigen Dialogrunden für diese Frage", "round": "Runde {round}", "contextRound": "Kontext-Runde {round}", "target": "Zielprojekt", "question": "Aktuelle Frage", "answer": "Vollständige Standardantwort", "files": "Anhänge und Dateiverweise", "baseSuite": "Fragen aus bestehender Testsuite übernehmen", "noBaseSuite": "Nur diese Frage verwenden", "suiteName": "Name der neuen Testsuite", "reviewed": "Ich habe Projekt, Frage, vollständige Antwort und Werkzeugbelege geprüft", "saving": "Wird gespeichert…", "save": "Bestätigen und im Fragenkatalog speichern", "tenant": "Quellmandant", "tools": "Vollständige Werkzeug- und Quellbelege"},
  qaeSync: { syncedSteps: "Ursprüngliche QAE-Werkzeugschritte", evidence: "Synchronisierte Quelldaten" },
  language: {
    label: "Sprache",
    switchAria: "Oberflächensprache wechseln",
    "zh-CN": "简体中文",
    "en-US": "English",
    "de-DE": "Deutsch",
  },
  common: {
    save: "Speichern",
    saving: "Wird gespeichert…",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    close: "Schließen",
    edit: "Bearbeiten",
    delete: "Löschen",
    remove: "Entfernen",
    create: "Erstellen",
    refresh: "Aktualisieren",
    refreshing: "Wird aktualisiert…",
    retryLater: "Bitte versuchen Sie es später erneut.",
    requestFailedRetry: "Die Anfrage ist fehlgeschlagen. Versuchen Sie es später erneut",
    project: "Projekt",
    suite: "Testsuite",
    type: "Typ",
    duration: "Dauer",
    status: "Status",
    createdAt: "Erstellt am",
    updatedTime: "Aktualisiert am",
    updatedAt: "Aktualisiert am {time}",
    sortCreatedDesc: "Erstellungszeit, neueste zuerst",
    reload: "Neu laden",
    actions: "Aktionen",
    retry: "Erneut versuchen",
    search: "Suchen",
    filter: "Filter",
    sort: "Sortierung",
    reset: "Zurücksetzen",
    back: "Zurück",
    copy: "Kopieren",
    copied: "Kopiert",
    copyFailed: "Kopieren fehlgeschlagen",
    loading: "Wird geladen…",
    empty: "Noch keine Daten",
    unknown: "Unbekannt",
    none: "Keine",
    all: "Alle",
    yes: "Ja",
    no: "Nein",
    enabled: "Aktiviert",
    disabled: "Deaktiviert",
    optional: "Optional",
    required: "Erforderlich",
    detail: "Details",
    more: "Mehr",
    apply: "Anwenden",
    submit: "Absenden",
    export: "Exportieren",
    import: "Importieren",
    upload: "Hochladen",
    download: "Herunterladen",
    view: "Anzeigen",
    open: "Öffnen",
    add: "Hinzufügen",
    ok: "OK",
    unnamed: "Ohne Titel",
    dash: "-",
    loadFailed: "Laden fehlgeschlagen",
    networkError: "Netzwerkfehler. Bitte versuchen Sie es später erneut",
    unknownError: "Unbekannter Fehler",
    errorPrefix: "Fehler: {message}",
    requestFailed: "Anfrage fehlgeschlagen ({status})",
    clearSearch: "Suche löschen",
    caseId: "Fragen-ID",
    caseIdRequired: "Fragen-ID *",
    case: "Frage",
    owner: "Verantwortliche Person",
    stage: "Umgebung",
    agent: "AI Engineer",
    connection: "Verbindung",
    conversation: "Unterhaltung",
    revision: "Revision",
    columnNumber: "Spalte {index}",
    resizeColumn: "Breite der Spalte {column} ändern",
    resizeColumnHint: "Ziehen zum Ändern; Pfeiltasten zum Anpassen; Enter, Pos1 oder Doppelklick zum Zurücksetzen",
  },
  format: {
    durationMinutes: "{value} Min.",
  },
  status: {
    unknown: "Unbekannt",
    unknownWithValue: "Unbekannt ({value})",
    run: {
      queued: "Nicht gestartet",
      validating: "Nicht gestartet",
      running: "In Bearbeitung",
      judging: "In Bearbeitung",
      completed_pending_sync: "In Bearbeitung",
      completed: "Abgeschlossen",
      failed: "Fehlgeschlagen",
      stopping: "In Bearbeitung",
      stopped: "Gestoppt",
      cancelled: "Gestoppt",
      validationFailed: "Validierung fehlgeschlagen",
      completedIncomplete: "Abgeschlossen",
    },
    runFilter: {
      running: "Wird ausgeführt",
      active: "In Bearbeitung",
    },
    cross: {
      queued: "Wartend", creating_task: "Sammelaufgabe wird erstellt", dispatched: "Gesendet", running: "Sammlung läuft", parsing: "Wird analysiert",
      captured: "Erfasst", captured_partial: "Teilweise erfasst", evaluating: "Wird bewertet", completed: "Abgeschlossen",
      completed_with_warnings: "Mit Warnungen abgeschlossen", partial_failed: "Teilweise fehlgeschlagen", retry_wait: "Wartet auf Wiederholung", failed: "Fehlgeschlagen", stopping: "Wird gestoppt", stopped: "Gestoppt",
    },
    governance: {
      draft: "Entwurf",
      active: "Aktiv",
      archived: "Archiviert",
      candidate: "Kandidat",
      blocked: "Blockiert",
      passed: "Bestanden",
      passed_with_warnings: "Bestanden (mit Warnungen)",
      released: "Freigegeben",
      pending: "Ausstehend",
      editing: "In Bearbeitung",
      promoted: "Übernommen",
      rejected: "Abgelehnt",
      duplicate: "Duplikat",
      succeeded: "Erfolgreich",
      partial_success: "Teilweise erfolgreich",
      available: "Verfügbar",
      unavailable: "Nicht verfügbar",
      unknown: "Unbekannt",
      error: "Fehler",
      delivered: "Zugestellt",
      retrying: "Erneuter Versuch",
      dead_letter: "Unzustellbar",
      disabled: "Deaktiviert",
      shadow: "Schattenmodus",
      enforcing: "Erzwingend",
    },
    candidate: {
      pending: "Zu bearbeiten",
      editing: "In Bearbeitung",
      promoted: "Übernommen",
      rejected: "Abgelehnt",
      duplicate: "Duplikat",
    },
    syncItem: {
      pending: "Ausstehend",
      running: "Wird verarbeitet",
      imported: "Importiert",
      skipped: "Übersprungen",
      failed: "Fehlgeschlagen",
      cancelled: "Abgebrochen",
    },
    suiteType: {
      release_smoke: "Release-Smoke-Test",
      capability_quick: "Schnellprüfung der Fähigkeiten",
      region_compatibility: "Regionale Kompatibilität",
      incident_regression: "Vorfallregression",
      security_regression: "Sicherheitsregression",
      full_regression: "Vollständige Regression",
      temporary: "Temporäre Testsuite",
    },
    skipReason: {
      question_disabled: "Frage deaktiviert",
      question_archived: "Frage archiviert",
      suite_item_disabled: "Testsuite-Frage deaktiviert",
    },
    projectType: {
      agent: "AI Engineer",
      workflow: "Workflow",
      api: "API",
      browser_agent: "Browser-AI Engineer",
    },
    evaluatorKind: {
      llm_judge: "LLM-Judge",
      rule_based: "Regelbasiert",
      hybrid: "Hybrid",
      manual: "Manuell",
    },
    logLevel: {
      debug: "Debug",
      info: "Info",
      warn: "Warnung",
      warning: "Warnung",
      error: "Fehler",
      critical: "Kritisch",
      fatal: "Kritisch",
    },
    stage: {
      dev: "Dev",
      qa: "QA",
      staging: "Staging",
      production: "Production",
      custom: "Benutzerdefiniert",
    },
  },
  nav: {
    overview: "Übersicht",
    projects: "Projekte",
    newRun: "Neue Testaufgabe",
    questionBank: "Alle Fragenkataloge",
    suites: "Alle Testsuites",
    queue: "Alle Testaufgaben",
    reports: "Alle Testberichte",
    crossEvaluations: "Quervergleich",
    logs: "Protokolle",
    settings: "Einstellungen",
  },
  route: {
    parent: {
      runs: "Ausführungen",
      tasks: "Testaufgaben",
      results: "Testergebnisse",
      reports: "Testberichte",
      queue: "Ausführungswarteschlange",
    },
  },
  shell: {
    documentTitle: "{page} · Agent Judge",
    brandSubtitle: "AI Engineer-Testplattform",
    brandAria: "Agent Judge-Testarbeitsbereich",
    primaryNavAria: "Hauptnavigation",
    breadcrumbAria: "Navigationspfad",
    navGroup: { workspace: "Arbeitsbereich", testAssets: "Testressourcen", crossProject: "Projektübergreifend" },
    skipToContent: "Zum Hauptinhalt springen",
    topbarContext: "Arbeitsbereich für AI Engineer-Tests",
    collapse: "Einklappen",
    collapseSidebar: "Seitenleiste einklappen",
    expandSidebar: "Seitenleiste ausklappen",
    accountSecurity: "Kontosicherheit",
    logout: "Abmelden",
    loggingOut: "Wird abgemeldet…",
    logoutFailed: "Abmeldung fehlgeschlagen. Sie sind weiterhin angemeldet: {message}",
    logoutFailedFallback: "Prüfen Sie die Netzwerkverbindung und versuchen Sie es erneut",
    routeLoading: "Seite wird geladen…",
    title: {
      overview: "Übersicht",
      evaluationProfiles: "Evaluierungsprofile",
      prompts: "Bewertungs-Prompts",
      targets: "Laufziele",
      projectQuestions: "Fragenkatalog",
      productionSamples: "Produktivkonversationen",
      dataSync: "Datensynchronisierung",
      projectContent: "Testsuites",
      projectRuns: "Läufe",
      projectTasks: "Testaufgaben",
      projectResults: "Testergebnisse",
      projectReports: "Testberichte",
      coverage: "Fähigkeitsabdeckung",
      gatePolicy: "Gate-Richtlinie",
      gateNotifications: "Gate-Benachrichtigungen",
      projectSettings: "Projekteinstellungen",
      projects: "Projekte",
      reports: "Alle Testberichte",
      questionBank: "Alle Fragenkataloge",
      suites: "Alle Testsuites",
      queue: "Alle Testaufgaben",
      logs: "Protokolle",
      security: "Kontosicherheit",
      migrated: "Einstellungen verschoben",
      settings: "Einstellungen",
      newRun: "Neue Testaufgabe",
      failures: "Fehlerprüfung",
      runDetail: "Ausführungsdetails",
      crossEvaluations: "Quervergleich",
      notFound: "Seite nicht gefunden",
    },
  },
  api: {
    networkFailed: "Netzwerkanfrage fehlgeschlagen",
    downloadNetworkFailed: "Netzwerkanfrage fehlgeschlagen. Die Datei kann nicht heruntergeladen werden",
  },
  auth: {
    workspaceLabel: "Arbeitsbereich für AI-Evaluierungen",
    kicker: "INDUSTRIALMIND EVALUIERUNG",
    poweredBy: "Bereitgestellt von der IndustrialMind AI-Evaluierungsplattform",
    headlineLead: "Jede AI Engineer-Änderung",
    headlineEmphasis: "auf den Prüfstand stellen",
    headlineDescription: "Vom Fragenkatalog und den Testsuites über die Ausführung bis zur Judge-Bewertung und Berichtsanalyse — ein Arbeitsbereich für einen reproduzierbaren Qualitätskreislauf.",
    flowAria: "Ablauf der AI Engineer-Auswertung",
    formPanelAria: "Anmeldung bei Agent Judge",
    eyebrow: "Sicherer Auswertungsarbeitsbereich",
    title: "Willkommen zurück",
    description: "Melden Sie sich an, um Ausführungen und Qualitätsberichte weiter zu verwalten.",
    bootstrapEyebrow: "Ersteinrichtung",
    bootstrapTitle: "Administrator initialisieren",
    bootstrapDescription: "Erstellen Sie das erste Administratorkonto in der lokalen Datenbank.",
    platformEyebrow: "Einheitliche Identität",
    platformTitle: "Mit IM Production anmelden",
    platformDescription: "Agent Judge verwendet Ihr aktuelles IM Production-Konto und Ihre Mandantenidentität.",
    platformGuidance: "Falls Sie noch nicht angemeldet sind, melden Sie sich im neuen Tab bei IM Production an. Diese Seite prüft den Status anschließend automatisch erneut.",
    platformOpenLogin: "IM Production-Anmeldung öffnen",
    platformRecheck: "Anmeldestatus erneut prüfen",
    platformTrustNote: "IM Production prüft Ihre Identität; Agent Judge speichert das Zugriffstoken nicht",
    platformSessionExpired: "Ihre IM Production-Sitzung ist abgelaufen. Bitte melden Sie sich erneut an",
    platformAccessDenied: "Der aktuelle IM Production-Mandant darf nicht auf Agent Judge zugreifen. Wechseln Sie zu einem autorisierten Mandanten",
    username: "Benutzername",
    password: "Passwort",
    showPassword: "Passwort anzeigen",
    hidePassword: "Passwort ausblenden",
    verifying: "Wird geprüft…",
    submit: "Bei Agent Judge anmelden",
    bootstrapSubmit: "Administrator erstellen und fortfahren",
    trustNote: "Anmeldedaten werden ausschließlich zur sicheren lokalen Sitzungsauthentifizierung verwendet",
    loginFailed: "Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut",
    sessionExpired: "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an",
    step: {
      questionBank: "Fragenkatalog",
      suites: "Testsuites",
      runs: "Ausführungen",
      reports: "Testberichte",
    },
    gate: {
      checking: "Anmeldestatus wird geprüft",
      pleaseWait: "Bitte warten…",
      unreachableTitle: "Das Agent Judge-Backend ist nicht erreichbar",
      unreachable: "Das Agent Judge-Backend ist vorübergehend nicht erreichbar.",
      offline: "Netzwerkverbindung unterbrochen. Prüfen Sie Ihr lokales Netzwerk oder ob das Agent Judge-Backend noch läuft.",
      reconnect: "Erneut verbinden",
    },
  },
  confirm: {
    pending: "Wird bearbeitet…",
  },
  guard: {
    discardTitle: "Ungespeicherte Änderungen verwerfen?",
    discardMessage: "Es gibt ungespeicherte Änderungen. Beim Verlassen geht dieser Entwurf verloren.",
    stayEditing: "Hier bleiben und weiter bearbeiten",
    discardAndLeave: "Verwerfen und verlassen",
  },
  pager: {
    aria: "Seitennavigation",
    summary: "Seite {page} von {totalPages} · {total} Einträge",
    total: "{total} Einträge",
    page: "{page} / {totalPages}",
    pageSize: "Zeilen",
    pageSizeAria: "Zeilen pro Seite",
    previous: "Zurück",
    next: "Weiter",
  },
  governance: {
    copyId: "ID kopieren",
    copyIdAria: "{label}: {value}",
    idCopied: "ID kopiert",
    copyIdFailed: "Kopieren fehlgeschlagen. Bitte manuell auswählen",
    readOnlyTitle: "Schreibgeschütztes Projekt",
    readOnlyDescription: "Dieses Projekt dient ausschließlich zur Prüfung historischer Assets und Ausführungen. Inhalte können nicht hinzugefügt oder bearbeitet werden.",
    metricAria: "{label}: {value}",
    tabsAria: "Projektnavigation",
    settingsNavAria: "Bereiche der Projekteinstellungen",
    unsavedMarker: "Ungespeicherte Änderungen",
    tab: {
      overview: "Projektübersicht",
      content: "Testsuites",
      productionSamples: "Produktivkonversationen",
      runs: "Läufe",
      tasks: "Testaufgaben",
      results: "Testergebnisse",
      reports: "Testberichte",
      settings: "Einstellungen",
    },
    settingsNav: {
      defaults: "Projektstandardwerte",
      env: "Laufziele",
      eval: "Evaluierungsprofile",
      prompts: "Bewertungs-Prompts",
      sync: "Datensynchronisierung",
    },
  },
  settingsReadiness: {
    env: {
      label: "Laufziel",
      ready: "{count} aktive Laufziele",
      missing: "Mindestens ein aktives Laufziel ist erforderlich",
    },
    defaultProfile: {
      label: "Standard-Auswertungsprofil",
      ready: "Festgelegt auf: {name}",
      missing: "Nicht festgelegt; bei neuen Auswertungen wird kein Profil vorausgewählt",
    },
    judgeKey: {
      label: "Anmeldedaten des Judge-Modells",
      needProfile: "Legen Sie zuerst ein Standard-Auswertungsprofil fest",
      ready: "Service-URL und Schlüssel sind konfiguriert",
      missingUrl: "Service-URL des Judge-Modells fehlt",
      missingKey: "Schlüssel des Judge-Modells fehlt",
    },
    prompt: {
      label: "Bewertungs-Prompts",
      referenced: "Standardprofil referenziert: {name}",
      referencedUnnamed: "Eine Prompt-Referenz ist festgelegt",
      optional: "System- oder Projekt-Prompts können verwendet werden (optional)",
      none: "Noch kein Projekt-Prompt; Ausführungen können den Systemstandard verwenden",
    },
  },
  importSteps: {
    aria: "Importschritte",
    parse: "Datei verarbeiten",
    conflicts: "Konflikte prüfen",
    commit: "Bestätigen und schreiben",
  },
  notFound: {
    title: "Seite nicht gefunden",
    description: "Für diese Adresse gibt es keine Seite — möglicherweise ist der Link abgelaufen oder die Adresse wurde falsch eingegeben.",
    goBack: "Zurück",
    goHome: "Zurück zur Auswertungsübersicht",
  },
  migrationPlaceholder: {
    description: "Diese Seite wird zu React migriert; Backend-APIs und Datenbankschema bleiben unverändert.",
  },
  logs: {
    redactedPlaceholder: "[geschwärzt]",
    circularPlaceholder: "[zirkuläre Referenz]",
  },
  runs: {
    sortAria: "{label}, {state}",
    sortAsc: "aufsteigend",
    sortDesc: "absteigend",
    sortIdle: "zum Sortieren klicken",
    duration: {
      seconds: "{value} s",
      minutes: "{value} Min.",
      hours: "{value} Std.",
    },
    progress: {
      aria: "Ausführungsfortschritt {percent}%",
      notStarted: "Nicht gestartet",
      notStartedAria: "Ausführung nicht gestartet, {total} Schritte geplant",
    },
    actions: {
      requestFailed: "Anfrage fehlgeschlagen. Bitte versuchen Sie es später erneut",
      stopped: "Ausführung gestoppt",
      stopFailed: "Ausführung konnte nicht gestoppt werden: {message}",
      resumed: "Fortsetzungsanfrage gesendet",
      resumeFailed: "Ausführung konnte nicht fortgesetzt werden: {message}",
      deleted: "Ausführung „{name}“ gelöscht",
      deleteFailed: "Ausführung konnte nicht gelöscht werden: {message}",
    },
  },
  runDetail: {
    knowledgeSourceFallback: "Wissensdatenbankquelle",
    sourceDocuments: "Quelldokumente ({count})",
    answerLoading: "Antwort wird vorbereitet…",
    turnCountSuffix: " ({count} Runden)",
    skipReasonFallback: "Beim Erstellen der Ausführung nicht ausführbar",
    judgePromptFallbackName: "Auswertungs-Prompt",
    alignment: {
      match: "Übereinstimmung",
      mismatch: "Abweichung",
    },
    integrity: {
      placeholderAnswer: "Unvollständiges Ergebnis: Die endgültige Antwort ist noch Platzhaltertext (z. B. „Antwort wird vorbereitet…“)",
      missingAnswer: "Unvollständiges Ergebnis: keine für Benutzer sichtbare endgültige Antwort",
      inconsistent: "Konsistenzwert {percent} %, unter dem Grenzwert dieses Laufs",
    },
    attention: {
      failed: "Fragen unter dem Gesamtschwellenwert",
      incomplete: "Unvollständige Ergebnisse",
      consistency: "Konsistenz {percent}%",
      consistencyPending: "Konsistenzprüfung ausstehend",
      skipped: "Übersprungene Fragen",
    },
    promptSource: {
      unknown: "Unbekannte Quelle",
      run_override: "Überschreibung auf Ausführungsebene",
      project_prompt: "Projekt-Prompt-Bibliothek",
      profile_recommended: "Empfehlung des Auswertungsprofils",
      agent_selected: "AI Engineer-Auswahl",
      agent_default: "AI Engineer-Standard",
      env_prompt_store: "Umgebungs-Prompt-Bibliothek",
      system_default: "Systemstandard",
    },
    table: {
      noResults: "Für diese Ausführung liegen noch keine Ergebnisdetails vor.",
      noFilteredResults: "Keine Ergebnisse entsprechen den aktuellen Filtern.",
      searchLabel: "Ergebnisse durchsuchen",
      filtersAria: "Werkzeugleiste für Ergebnisfilter",
      searchPlaceholder: "Fragen-ID oder Frage",
      statusLabel: "Ergebnisstatus",
      count: "{shown} / {total} Zeilen",
      defaultSort: "Standardsortierung: Fragen-ID aufsteigend · Wiederholungen innerhalb einer Frage",
      clearFilters: "Filter löschen",
      runIndex: "Wiederholung {index}",
      completion: "{done}/{total} abgeschlossen ({percent})",
      passed: "Bestanden",
      openDetail: "Details anzeigen",
      openDetailAria: "Details anzeigen: Frage {caseId}, Wiederholung {index}",
      retryCase: "Diese Frage erneut versuchen",
      retrying: "Erneuter Versuch",
      retriedTimes: "{count}-mal erneut versucht",
      turnLogs: "Rundenprotokolle",
      paginationAria: "Ergebnisseiten",
      range: "Zeilen {from}–{to} von {total}",
      status: {
        attention: "Prüfung erforderlich",
        failed: "Fehlgeschlagen",
        incomplete: "Unvollständiges Ergebnis",
        inconsistent: "Geringe Konsistenz",
        passed: "Bestanden",
      },
      column: {
        run: "Wiederholung",
        question: "Frage",
        executedAverage: "Durchschnitt ausgeführter Runden",
        completion: "Abschluss",
        result: "Ergebnis",
        duration: "Dauer",
        actions: "Aktionen",
      },
    },
    dialog: {
      title: "Frage {caseId} · Wiederholung {index}",
      description: "Durchschnitt ausgeführter Runden {average} · {done}/{total} Runden abgeschlossen · {result}",
      reportTitle: "Fragedetails · {question}", reportDescription: "Zeigt jede Antwort zusammen mit Judge-Fazit, Latenz, Tokens und Laufzeitbelegen.", repeatAnswersAria: "Auswahl wiederholter Antworten", repeatAnswers: "Antwort anzeigen", platformStability: "Plattformstabilität", answerStability: "Antwortstabilität", collectionTime: "Erfassungsdauer", completeAnswerTime: "Zeit bis zur vollständigen Antwort", tokenUsage: "Token-Nutzung", repeatAverageScore: "Qualitätswert der Frage", qualityDimensions: "Sieben Qualitätsdimensionen", successCount: "{completed} / {total} erfolgreich", questionAndEvidence: "Frage und Bewertungsgrundlage", questionAndGroundTruth: "Frage und Referenzantwort", question: "Frage", groundTruth: "Referenzantwort", answerContent: "Antwort", answerCardAria: "Details zu Antwort {index}", judgeConclusion: "Judge-Fazit", completeRepeatAnswers: "Details der wiederholten Antworten", bestScoreSuffix: " · höchste Bewertung im Bericht", qualityScoreShort: "Fragequalität", fullTimeShort: "Vollständig", firstResponseShort: "Erste Reaktion", toolTimeShort: "Tools", openTargetSession: "Zielsitzung öffnen", openTargetSessionAria: "Zielsitzung für Antwort {index} in einem neuen Fenster öffnen", citationEvidence: "Quellenbelege", evidenceItem: "Beleg", runtimeSnapshotAndPrompt: "Laufzeitversionen und Prompt des Berichts", report: "Bericht", platformAgentVersion: "Plattform- / AI Engineer-Version", targetPromptVersion: "Prompt-Version der bewerteten Plattform", repeatConfig: "Wiederholungskonfiguration", repeatConfigValue: "{count} Mal / Frage", targetPromptSnapshot: "Prompt-Snapshot der bewerteten Plattform",
      closeLabel: "Fragedetails schließen",
      turnLabel: "Runde {index}",
      previousCase: "Zurück",
      previousCaseAria: "Vorherige Frage",
      nextCase: "Weiter",
      nextCaseAria: "Nächste Frage",
      queuePosition: "Eintrag {position} von {total} in der Warteschlange",
      openQuestion: "Frage öffnen",
      openSuite: "Testsuite öffnen",
      openRun: "Quellausführung öffnen",
      tabsAria: "Abschnitte der Fragedetails",
      artifactCard: "Datenkarte",
      artifactPaginationAria: "Seitennavigation der Datenkarte",
      artifactPage: "Seite {page} / {pageCount} · {rows} Zeilen angezeigt",
      rowCount: "{count} Zeilen",
      columnSummary: "Spalten: {summary}",
      columnJoin: ", ",
      columnCount: " ({count} Spalten)",
      moreColumns: " und insgesamt {count} Spalten",
      noDeclaredColumns: "Keine deklarierten Spalten",
      noVisibleData: "Keine sichtbaren Daten",
      eventsLoadFailed: "Ereignisse konnten nicht geladen werden",
      eventsLoading: "Ereignisse werden geladen…",
      noEvents: "Noch keine Ereigniseinträge.",
      eventDiscarded: "Verworfen",
      eventTruncated: "Gekürzt",
      showFailedAttempts: "Fehlgeschlagene Versuche anzeigen",
      eventSummaryAria: "Ereignisübersicht",
      missingRunId: "Ausführungs-ID fehlt; Ereignisse können nicht geladen werden.",
      toolTrace: "Tool-Trace ({count} Einträge, von der Bewertung der endgültigen Antwort ausgeschlossen)",
      selectTurn: "Runde anzeigen",
      standardAnswer: "Referenzantwort",
      agentAnswer: "AI Engineer-Antwort",
      repeatDiffAria: "Unterschiede zwischen wiederholten Antworten",
      repeatDiffTitle: "Vergleich wiederholter Antworten",
      currentSuffix: " (aktuell)",
      scorePoints: "{score} Pkt.",
      notScored: "Nicht bewertet",
      blockedByPrevious: "Durch vorherige Runde blockiert",
      blockedByPreviousReason: "Die vorherige Runde hat den Bestehensschwellenwert nicht erreicht; daher wurde diese Runde nicht ausgeführt.",
      evidenceIncomplete: "Unvollständige Nachweise",
      userInputAndAnswer: "Benutzereingabe / Referenzantwort",
      visibleFinalAnswer: "Für Benutzer sichtbare endgültige Antwort",
      retryHistory: "Verlauf technischer Wiederholungen",
      retryHistoryItem: "Wiederholung {index} · {status} · Bewertung {score}",
      retryFixed: "Behoben",
      retryStillIncomplete: "Weiterhin unvollständig",
      incompleteReason: "Grund der Unvollständigkeit",
      issues: "Problemdetails",
      noIssues: "Noch keine Problemdetails.",
      noIssuesWorkbench: "Keine Judge-Mängel oder Auffälligkeiten bei Vollständigkeit oder Konsistenz.",
      nartAlignment: "NART-Abgleich",
      nartDimension: "Dimension",
      nartResult: "Ergebnis",
      tab: {
        answers: "Antwortvergleich",
        answersWithCount: "Antwortvergleich ({count} Wiederholungen)",
        turns: "Rundennachweise ({count})",
        artifacts: "Datenkarten ({count})",
        events: "Ereignis-Trace",
        issues: "Problemdetails ({count})",
      },
    },
  },
  productionTags: {
    groupAria: "Fragen-Tags",
    optionsAria: "Optionen für {label}",
    selectedAria: "Ausgewählte Tags",
    search: "Tags suchen",
    removeAria: "{label} entfernen",
    noneSelected: "Noch kein Tag ausgewählt",
    noMatch: "Kein passender Tag",
    disabledSuffix: " (deaktiviert)",
  },
  suites: {
    upload: {
      onlyXlsx: "Es werden nur Excel-Testsuites im Format .xlsx unterstützt",
      selectProject: "Wählen Sie das Projekt aus, zu dem diese Testsuite gehört",
      uploading: "Excel-Datei wird hochgeladen",
      parsed: "Verarbeitung abgeschlossen — bestätigen Sie das Schreiben in den Fragenkatalog und das Erstellen der Testsuite",
      parsedWithConflicts: "Verarbeitung mit {count} Konflikt(en) abgeschlossen; prüfen Sie diese im Fragenkatalog",
      failed: "Import der Testsuite fehlgeschlagen",
    },
    import: {
      panelAria: "Testsuite importieren",
      fileInputAria: "Excel-Testsuite-Datei auswählen",
      selectProjectFirst: "Wählen Sie zuerst das zugehörige Projekt aus",
      chooseFile: "Excel-Datei auswählen",
      start: "Import starten",
      parsing: "Wird verarbeitet…{elapsed}",
      parsingElapsed: "Datei wird verarbeitet, verstrichen: {elapsed}",
      parsedNote: "Verarbeitung abgeschlossen — prüfen Sie Konflikte im Projekt-Fragenkatalog und bestätigen Sie das Schreiben.",
      readyNote: "Nach der Verarbeitung prüfen Sie Konflikte im Fragenkatalog; die Testsuite wird erst nach Ihrer Bestätigung erstellt.",
      downloadTemplate: "Standard-Excel-Vorlage herunterladen",
      templateAfterProject: "Wählen Sie ein Projekt aus, um die Vorlage herunterzuladen",
      guideTemplateTitle: "Standardvorlage: ",
      guideTemplateBody: "enthält die Arbeitsblätter „Fragen“, „Runden“, „Verfügbare Tags“ und „Anweisungen“ und unterstützt Fragen mit einer oder mehreren Runden.",
      guideRequiredTitle: "Pflichtfelder: ",
      guideRequiredBody: "Das Arbeitsblatt „Fragen“ benötigt eine Fragen-ID; das Arbeitsblatt „Runden“ benötigt Fragen-ID, Rundenreihenfolge, Benutzereingabe und Referenzantwort. Eine Zeile pro Frage bedeutet eine Runde, zwei oder mehr Zeilen bedeuten mehrere Runden.",
      guideNote: "Tags werden nur im Arbeitsblatt „Fragen“ eingetragen. Unterstützt werden nur .xlsx-Dateien bis 50 MB; nach der Verarbeitung prüfen Sie Konflikte im Fragenkatalog, anschließend werden die Fragen geschrieben und die Testsuite erstellt.",
    },
    caseEditor: {
      createTitle: "Frage hinzufügen",
      editTitle: "Frage bearbeiten",
      description: "Verwalten Sie Frage, Referenzantwort und Tags einer Frage mit einer Runde. Bewertungsschwellenwerte werden beim Erstellen einer Ausführung festgelegt. Drücken Sie zum Speichern Strg/⌘ + Eingabetaste.",
      draftUnsaved: "Entwurf nicht gespeichert",
      save: "Frage speichern",
      saving: "Wird gespeichert",
      requiredError: "Fragen-ID und Benutzerfrage dürfen nicht leer sein",
      caseIdLabel: "Fragen-ID *",
      caseIdHelp: "Innerhalb der Testsuite eindeutig; kann nach dem Erstellen nicht geändert werden.",
      caseIdRequired: "Fragen-ID ist erforderlich.",
      questionLabel: "Benutzerfrage *",
      questionHelp: "Die an das zu prüfende System gesendete Eingabe.",
      questionRequired: "Benutzerfrage ist erforderlich.",
      answerLabel: "Referenzantwort",
      answerHelp: "Wird dem Judge als Referenzfakten bereitgestellt. Bei leerem Feld erfolgt die Bewertung weiterhin, jedoch nur anhand der Frage und des aktuellen Judge-Prompts oder der Standardregeln — das Ausfüllen verringert Mehrdeutigkeit.",
      tagsLabel: "Tags",
      tagsPlaceholder: "Mehrere Tags durch Kommas trennen",
      enableCase: "Diese Frage aktivieren",
      discardTitle: "Ungespeicherten Fragenentwurf verwerfen?",
      discardDescription: "Beim Schließen des Editors gehen die gerade eingegebene Frage, Referenzantwort und Tags verloren.",
      discardConfirm: "Entwurf verwerfen",
      discardCancel: "Weiter bearbeiten",
    },
  },
  settings: {
    discovery: {
      subjectTenants: "Mandanten abrufen",
      subjectAgents: "AI Engineers abrufen",
      offline: "Service nicht erreichbar; {subject} fehlgeschlagen. Prüfen Sie, ob das lokale Backend noch läuft",
      forbidden: "Anmeldung fehlgeschlagen oder dieses Konto darf nicht: {subject}",
      failed: "Fehlgeschlagen: {subject}",
    },
    field: {
      agentFrontendUrl: "URL der AI Engineer-Sitzungsseite",
      platformLoginUrl: "URL der Plattform-Anmeldeseite",
      loginUrl: "Anmelde-URL",
      agentTimeout: "AI Engineer-Zeitlimit",
      agentConcurrency: "AI Engineer-Parallelität",
      agentRetry: "Wiederholungen bei AI Engineer-Fehlern",
      judgeConcurrency: "Judge-Parallelität",
      judgeRetry: "Wiederholungen bei Judge-Fehlern",
      repeatRuns: "Standardanzahl Wiederholungen",
      repeatConcurrency: "Parallelität der Wiederholungen pro Frage",
      maxScore: "Maximale Punktzahl",
    },
    validation: {
      httpUrl: "{label} muss eine vollständige URL sein, die mit http:// oder https:// beginnt",
      integerAtLeast: "{label} muss eine Ganzzahl von mindestens {minimum} sein",
      integerBetween: "{label} muss eine Ganzzahl zwischen {minimum} und {maximum} sein",
      judgeModelRequired: "Judge-Modell darf nicht leer sein",
      tenantRequired: "Wählen Sie den Standardmandanten für diese Umgebung aus",
      repeatRunsMax: "Die Standardanzahl Wiederholungen darf 50 nicht überschreiten",
      repeatModeInvalid: "Ausführungsmodus für Wiederholungen ist ungültig",
      passThresholdRange: "Bestehensschwellenwert muss zwischen 0 und 100 liegen",
      consistencyRange: "Konsistenzschwellenwert muss zwischen 0 und 100 liegen",
      passThresholdAboveMax: "Bestehensschwellenwert darf die maximale Punktzahl nicht überschreiten",
      scoringRuleRequired: "Wählen Sie eine Bewertungsregel aus",
      platformLoginUrlRequired: "Geben Sie die vollständige URL der Plattform-Anmeldeseite ein",
      loginUsernameRequired: "Geben Sie den Anmeldebenutzernamen ein",
      loginPasswordRequired: "Geben Sie das Anmeldepasswort ein",
      environmentNamePattern: "Umgebungs-ID akzeptiert 1–50 Buchstaben, Ziffern, Unterstriche oder Bindestriche und muss mit einem Buchstaben oder einer Ziffer beginnen",
      environmentNameTaken: "Umgebung „{name}“ ist bereits vorhanden",
    },
  },
  agentEditor: {
    eyebrow: "AI Engineer-Konfiguration",
    title: "AI Engineer-Verbindungen für diese Umgebung",
    add: "AI Engineer hinzufügen",
    empty: "Diese Umgebung enthält noch keinen AI Engineer. Fügen Sie zuerst einen hinzu.",
    promptCustom: "Benutzerdefiniert",
    promptInherit: "Von Umgebung übernehmen",
    setDefaultAria: "{key} als Standard-AI Engineer festlegen",
    createTitle: "AI Engineer hinzufügen",
    editTitle: "AI Engineer bearbeiten",
    description: "Sie müssen die Umgebungseinstellungen noch absenden, damit die Änderungen wirksam werden.",
    dirtyDescription: "Entwurf nicht gespeichert; Sie müssen die Umgebungseinstellungen noch absenden, damit die Änderungen wirksam werden.",
    save: "AI Engineer speichern",
    noChanges: "Keine Änderungen",
    duplicateCode: "AI Engineer-Code „{code}“ ist bereits vorhanden. Verwenden Sie einen anderen Code.",
    discardTitle: "Ungespeicherten AI Engineer-Entwurf verwerfen?",
    discardDescription: "Beim Schließen des Editors werden der gerade eingegebene Name, die ID, der Code und der Prompt verworfen. Gespeicherte AI Engineers bleiben unverändert.",
    discardConfirm: "Entwurf verwerfen",
    removeTitle: "AI Engineer „{key}“ aus dem Entwurf entfernen?",
    removeTitleFallback: "AI Engineer entfernen?",
    removeDetails: "Dies ändert nur den aktuellen Entwurf. Er wird erst nach einem Klick auf „Einstellungen speichern“ in die Umgebung geschrieben; ein Neuladen der Seite davor macht die Änderung rückgängig.",
    removeConfirm: "Aus Entwurf entfernen",
    removeImpactNone: "Der aktuelle Standard-AI Engineer bleibt unverändert.",
    removeImpactSwitch: "Dies ist der aktuelle Standard-AI Engineer; nach dem Entfernen wechselt der Standard zu „{next}“.",
    removeImpactLast: "Dies ist der einzige und zugleich der Standard-AI Engineer; nach dem Entfernen kann keine neue Auswertung erstellt werden, bis wieder ein AI Engineer hinzugefügt wurde.",
    column: {
      name: "Name",
      id: "AI Engineer-ID",
      agentCode: "AI Engineer-Code",
      engineerCode: "Engineer-Code",
      judgePrompt: "Judge-Prompt",
      default: "Standard",
      actions: "Aktionen",
    },
    field: {
      name: "AI Engineer-Name",
      id: "AI Engineer-ID *",
      agentCode: "AI Engineer-Code *",
      engineerCode: "Engineer-Code",
      judgePrompt: "AI Engineer-spezifischer Judge-Prompt (leer lassen, um den Umgebungsstandard zu übernehmen)",
    },
  },
  connectionSetup: {
    stepperAria: "Schritte der AI Engineer-Verbindung",
    step1: "Konto verbinden",
    step2: "Mandantenbereich auswählen",
    urlInvalid: "Geben Sie eine vollständige Adresse ein, die mit http:// oder https:// beginnt.",
    credentialsTitle: "1. Plattformkonto verbinden",
    credentialsDescription: "Nach der Kontoprüfung werden zugängliche Mandanten automatisch gelesen; Anmeldedaten erscheinen nie in den Erkennungsergebnissen.",
    verified: "Verifiziert",
    saved: "Gespeichert",
    pendingConnect: "Nicht verbunden",
    platformLoginHelp: "Geben Sie die URL der Browser-Anmeldeseite ein; Token-URL und AI Engineer-API-Adresse werden nach dem Verbinden automatisch ausgefüllt.",
    loginUsername: "Anmeldebenutzername",
    loginPassword: "Anmeldepasswort",
    passwordSavedPlaceholder: "Gespeichert; leer lassen, um es weiterzuverwenden",
    passwordPlaceholder: "Passwort eingeben",
    passwordHelp: "Beim Ändern des Benutzernamens müssen Sie das Passwort erneut eingeben.",
    usingSavedPassword: "Das für diese Umgebung gespeicherte Passwort wird verwendet",
    ready: "Bereit",
    fetchTenants: "Verbinden und Mandanten abrufen",
    fetchingTenants: "Mandanten werden abgerufen…",
    tenantTitle: "2. Standardmandanten auswählen",
    tenantDescription: "Die Umgebung speichert die für das Konto zugänglichen Mandanten; der Standardmandant wird nur beim Erstellen einer Ausführung vorausgewählt.",
    selected: "Ausgewählt",
    pendingSelect: "Nicht ausgewählt",
    searchTenants: "Mandanten suchen",
    searchTenantsPlaceholder: "Nach Name, Schlüssel, ID oder Rolle suchen",
    availableTenants: "Verfügbare Mandanten",
    noTenantMatch: "Kein passender Mandant",
    tenantSummary: "Standardmandant: {name}; {count} zugängliche Mandanten gespeichert",
    selectTenantHint: "Wählen Sie vor dem Speichern der Umgebung einen Standardmandanten aus",
    savedTenant: "Gespeicherter Mandant: {name}. Stellen Sie erneut eine Verbindung her, um Mandanten anzuzeigen oder zu wechseln.",
    connectFirst: "Verbinden Sie zuerst das Konto; anschließend werden die Mandanten hier angezeigt.",
    agentUnbound: "AI Engineers sind nicht mehr an eine Umgebung gebunden. Beim Erstellen einer Auswertung lädt das System AI Engineers für den ausgewählten Mandanten; mehrere AI Engineers können gleichzeitig ausgewählt werden.",
    errorHint: "{message}. Ihre Eingaben und abgeschlossenen Auswahlen bleiben erhalten, sodass Sie es direkt erneut versuchen können.",
    readyTitle: "Umgebungsverbindung ist bereit",
    defaultTenant: "Standardmandant: {name}",
    tenantRecorded: "{count} zugängliche Mandanten erfasst; AI Engineers werden beim Erstellen einer Ausführung ausgewählt",
    saveConnection: "Umgebungsverbindung speichern",
    advanced: "Erweiterte Einstellungen und manuelle Einrichtung",
    advancedHint: "Nur verwenden, wenn die Plattform keine automatische Erkennung unterstützt oder Standardadressen überschrieben werden müssen. Sie müssen weiterhin auf „Speichern“ klicken.",
    tenantKey: "Mandantenschlüssel",
    tenantId: "Mandanten-ID",
    agentBaseUrlHelp: "Stammadresse des Ziel-Gateways der AI Engineer-API.",
    agentBaseUrlLabel: "Basis-URL der AI-Engineer-API",
    tokenUrlLabel: "Token-URL",
    agentTimeoutSeconds: "AI Engineer-Zeitlimit (Sekunden)",
    agentTimeoutHelp: "Maximale Wartezeit für einen einzelnen AI Engineer-Aufruf; Zeitüberschreitungen zählen im Ausführungsergebnis als Fehler.",
    tokenUrlHelp: "Endpunkt, der zur Laufzeit das Zugriffstoken ausgibt, nicht die Browser-Anmeldeseite.",
    agentFrontendUrlHelp: "Wird in Berichten für einen Link zurück zur ursprünglichen AI Engineer-Sitzung verwendet; leer lassen, um den Link auszulassen.",
  },
  promptSettings: {
    loading: "Prompt-Konfiguration wird geladen…",
    loadFailed: "Prompt-Konfiguration konnte nicht geladen werden: {message}",
    capsuleEyebrow: "Kapselkonfiguration",
    capsuleTitle: "Prompt-Sets",
    configNotApplied: "Konfiguration nicht angewendet",
    cancelConfigChanges: "Konfigurationsänderungen abbrechen",
    saveConfig: "Kapselkonfiguration speichern",
    configSaved: "Kapselkonfiguration gespeichert und angewendet",
    configSaveFailed: "Kapselkonfiguration konnte nicht gespeichert werden: {message}",
    configErrorHint: "{message}. Ihre Änderungen bleiben erhalten; versuchen Sie es erneut oder brechen Sie ab.",
    enableCapsule: "{name} aktivieren",
    editorEyebrow: "Editor",
    editorFallbackTitle: "Prompt-Editor",
    activeVersion: "Aktive Version",
    editingNewDraft: "Neuer Versionsentwurf wird bearbeitet",
    selectPrompt: "Prompt auswählen",
    versionHelp: "Speichern Sie nach einem Versionswechsel die Kapselkonfiguration, damit er wirksam wird.",
    name: "Name",
    description: "Beschreibung",
    body: "Prompt-Inhalt",
    insertVariable: "Klicken, um eine Variable einzufügen: ",
    undeclaredVariables: "Nicht deklarierte Variablen: {variables}. Entfernen Sie sie oder verwenden Sie die Variablen oben.",
    undeclaredVariablesToast: "Nicht deklarierte Variablen gefunden: {variables}",
    fixVariablesFirst: "Beheben Sie zuerst die nicht deklarierten Variablen",
    restoreDefault: "Standard wiederherstellen und speichern",
    cancelDraft: "Entwurf abbrechen",
    createPrompt: "Prompt erstellen",
    savePrompt: "Prompt speichern",
    promptCreated: "Prompt erstellt; speichern Sie die Kapselkonfiguration, um ihn anzuwenden",
    promptSaved: "Prompt gespeichert",
    promptDeleted: "Prompt gelöscht",
    promptRestored: "Standard-Prompt wiederhergestellt",
    copyName: "Kopie von {name}",
    newVersionName: "Neue Version von {name}",
    copyAnnouncement: "Ein Entwurf einer Prompt-Kopie wurde erstellt. Bestätigen Sie zuerst den Namen.",
    newVersionAnnouncement: "Ein Entwurf für eine neue Prompt-Version wurde erstellt. Geben Sie zuerst den Namen ein.",
    discardTitle: "Ungespeicherten Prompt-Entwurf verwerfen?",
    discardUrlChange: "Die Adressleiste verweist auf eine andere Kapsel oder Version. Beim Wechsel werden der ungespeicherte Name, die Beschreibung und der Inhalt im Editor verworfen; gespeicherte Versionen bleiben unverändert.",
    discardSwitchCapsule: "Beim Wechseln der Kapsel werden der ungespeicherte Name, die Beschreibung und der Inhalt im Editor verworfen; gespeicherte Versionen bleiben unverändert.",
    discardSwitchVersion: "Beim Wechseln der Version werden der ungespeicherte Name, die Beschreibung und der Inhalt im Editor verworfen; gespeicherte Versionen bleiben unverändert.",
    discardCreate: "Beim Erstellen einer Version werden der ungespeicherte Name, die Beschreibung und der Inhalt im Editor verworfen; gespeicherte Versionen bleiben unverändert.",
    keepDraft: "Beim Entwurf bleiben",
    discardAndContinue: "Entwurf verwerfen und fortfahren",
    currentCapsule: "die aktuelle Kapsel",
    restoreTitle: "Systemstandard-Prompt für „{name}“ wiederherstellen?",
    restoreDescription: "Die Wiederherstellung schreibt den Systemstandard-Prompt sofort und überschreibt die aktuelle Auswahl der Kapsel.",
    restoreDescriptionDirty: "Die Wiederherstellung schreibt den Systemstandard-Prompt sofort, überschreibt die aktuelle Auswahl der Kapsel und verwirft den ungespeicherten Entwurf im Editor.",
    restoreDetails: "Dies wird sofort wirksam und kann nicht rückgängig gemacht werden; historische Ausführungen behalten ihren verwendeten Prompt-Snapshot.",
    restoring: "Wird wiederhergestellt…",
    deleteTitle: "Prompt „{name}“ löschen?",
    deleteDescription: "Nach dem Löschen verschwindet die Version aus der Versionsliste; wenn sie aktiv ist, fällt die Kapsel auf eine andere Version zurück.",
    deleteDetails: "Dies kann nicht rückgängig gemacht werden; abgeschlossene Ausführungen behalten ihren verwendeten Prompt-Snapshot.",
    deletePrompt: "Prompt löschen",
    deleting: "Wird gelöscht…",
  },
  security: {
    managedByPlatformEyebrow: "Einheitliche Identität",
    managedByPlatformTitle: "Konto wird von IM Production verwaltet",
    managedByPlatformDescription: "Die einheitliche Anmeldung ist aktiv. Avatar, Passwort und Kontoprofil werden in IM Production verwaltet; Agent Judge speichert kein separates Passwort.",
    platformAccount: "Plattformkonto",
    platformTenant: "Mandant",
    accountProfile: "Kontoprofil",
    adminAvatar: "Administrator-Avatar",
    currentAvatarAlt: "Aktueller Avatar",
    chooseAvatar: "Avatarbild auswählen",
    avatarSaving: "Avatar wird gespeichert…",
    removeAvatar: "Avatar entfernen",
    avatarHelp: "PNG, JPG, WebP und GIF bis 10 MB; das Bild wird mittig zugeschnitten und sofort gespeichert.",
    avatarNotImage: "Wählen Sie eine Bilddatei aus",
    avatarTooLarge: "Das Bild darf höchstens 10 MB groß sein",
    avatarProcessFailed: "Avatar konnte nicht verarbeitet werden",
    avatarProcessUnsupported: "Dieser Browser kann das Avatarbild nicht verarbeiten",
    avatarUpdated: "Avatar aktualisiert",
    removeAvatarTitle: "Aktuellen Administrator-Avatar entfernen?",
    removeAvatarDescription: "Die Bestätigung schreibt die Änderung sofort auf den Server und löscht das gespeicherte Avatarbild; anschließend wird der Anfangsbuchstabe des Benutzernamens angezeigt. Dies kann nicht rückgängig gemacht werden; zur Wiederherstellung muss ein neues Bild hochgeladen werden.",
    removeAvatarDetails: "Kontopasswort und Anmeldesitzungen bleiben unverändert.",
    keepAvatar: "Avatar behalten",
    confirmRemoveAvatar: "Avatar entfernen",
    removingAvatar: "Wird entfernt…",
    passwordEyebrow: "Passwort",
    changePassword: "Passwort ändern",
    changing: "Wird geändert…",
    currentUsernameAria: "Benutzername des aktuellen Kontos",
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort (mindestens 8 Zeichen)",
    confirmPassword: "Neues Passwort bestätigen",
    strength: "Stärke: {level}",
    strengthEmpty: "Nicht eingegeben",
    strengthShort: "Zu kurz",
    strengthStrong: "Stark",
    strengthFair: "Mittel",
    passwordAdvice: "Verwenden Sie mindestens 12 Zeichen und kombinieren Sie Groß- und Kleinbuchstaben, Ziffern und Sonderzeichen.",
    passwordMismatch: "Die beiden neuen Passwörter stimmen nicht überein",
    passwordSameAsCurrent: "Das neue Passwort muss sich vom aktuellen unterscheiden",
    passwordChanged: "Passwort geändert. Alle Sitzungen wurden abgemeldet; melden Sie sich mit dem neuen Passwort erneut an",
    currentPasswordWrong: "Das aktuelle Passwort ist falsch. Versuchen Sie es erneut",
  },
  tags: {
    legend: "Tags",
    actionFailed: "Aktion fehlgeschlagen. Versuchen Sie es später erneut",
    loadingTags: "Tags werden geladen",
    facetLoadFailed: "Tag-Filter konnten nicht geladen werden",
    facetUnavailable: "Der aktuelle Tag-Filter ist nicht mehr verfügbar",
    noTags: "Diesen Fragen wurden noch keine Tags zugewiesen",
    clearFilter: "Tag-Filter löschen",
    searchFacetAria: "Filter-Tags suchen",
    searchPlaceholder: "Tags suchen",
    searchAvailableAria: "Verfügbare Tags suchen",
    searchTagOrDimension: "Tags oder Dimensionen suchen",
    groupFilterAria: "Filter für {name}",
    questionCount: "{count} Fragen",
    collapse: "Einklappen",
    expandAll: "Alle anzeigen ({count})",
    noMatch: "Kein passender Tag",
    selectedAria: "Ausgewählte Tags",
    noneSelected: "Noch kein Tag ausgewählt",
    disabled: "Deaktiviert",
    disabledSuffix: " (deaktiviert)",
    removeAria: "{label} entfernen",
    creating: "Wird erstellt…",
    createAndSelect: "Projekt-Tag „{label}“ erstellen und auswählen",
    sameNameDisabled: "Ein Tag mit demselben Namen ist deaktiviert. Aktivieren Sie ihn zuerst in der Tag-Verwaltung.",
    sameNameExists: "Ein Tag mit demselben Namen ist bereits vorhanden; wählen Sie ihn direkt aus.",
    reusedExisting: "Vorhandener Tag wiederverwendet",
    created: "Projekt-Tag erstellt",
    renamed: "Tag umbenannt; die Tag-ID bleibt unverändert",
    enabledToast: "Tag aktiviert",
    disabledToast: "Tag deaktiviert; vorhandene Referenzen bleiben unverändert",
    deleted: "Nicht verwendeter Tag gelöscht",
    managerTitle: "Projekt-Tag-Verwaltung",
    managerDescription: "Verwalten Sie die in diesem Projekt verfügbaren Tags; Standard-Tags des Arbeitsbereichs können hier nur aktiviert oder deaktiviert werden.",
    managerClose: "Tag-Verwaltung schließen",
    scopeFilterAria: "Nach Tag-Bereich filtern",
    scopeAll: "Alle Bereiche",
    scopeProject: "Projekt-Tags",
    scopeWorkspace: "Arbeitsbereichsstandard",
    scopeProjectShort: "Projekt",
    scopeWorkspaceShort: "Arbeitsbereich",
    statusFilterAria: "Nach Tag-Status filtern",
    statusAll: "Alle Status",
    statusActive: "Aktiviert",
    statusDisabled: "Deaktiviert",
    newProjectTag: "Neuer Projekt-Tag",
    newTagPlaceholder: "z. B. Schwerpunkt Bestand",
    readOnlyNote: "Dieses Projekt ist schreibgeschützt; Tags können nur angezeigt werden.",
    loadingProjectTags: "Projekt-Tags werden geladen",
    loadProjectTagsFailed: "Projekt-Tags konnten nicht geladen werden",
    rename: "Umbenennen",
    renameAria: "{label} umbenennen",
    disable: "Deaktivieren",
    reEnable: "Erneut aktivieren",
    noMatchingTags: "Kein Tag entspricht den Filtern",
    noProjectTags: "Noch kein Projekt-Tag",
    noVisibleTags: "In diesem Projekt gibt es keine Tags zum Anzeigen.",
    createFirstTag: "Sie können den ersten Projekt-Tag erstellen.",
    renameTitle: "Tag umbenennen",
    renameDescription: "Nur der Anzeigename ändert sich; historische Tag-IDs bleiben erhalten.",
    saveName: "Namen speichern",
    maxLengthHint: "Bis zu 80 Zeichen.",
    labelRequired: "Tag-Name ist erforderlich.",
    deleteTitle: "Diesen Tag löschen?",
    deleteDescription: "Keine Fragenversion referenziert diesen Tag; das Löschen kann nicht rückgängig gemacht werden.",
    deleteConfirm: "Tag löschen",
    disableTitle: "Diesen Tag deaktivieren?",
    disableDescription: "Historische Fragenversionen referenzieren diesen Tag weiterhin. Nach der Deaktivierung kann er nicht mehr zugewiesen werden; vorhandene Inhalte bleiben erhalten.",
    disableDescriptionUsed: "{count} aktive Fragen referenzieren diesen Tag. Nach der Deaktivierung kann er nicht mehr zugewiesen werden; vorhandene Inhalte bleiben erhalten.",
    disableConfirm: "Tag deaktivieren",
    discardTitle: "Noch nicht erstellten Tag-Namen verwerfen?",
    discardDescription: "„{label}“ wurde nicht erstellt und geht beim Schließen der Tag-Verwaltung verloren.",
    discardConfirm: "Verwerfen und schließen",
    column: {
      label: "Tag-Name",
      dimension: "Dimension",
      scope: "Bereich",
      questions: "Fragen",
      status: "Status",
    },
  },
  settingsPage: {
    title: "Einstellungen",
    description: "Hier befinden sich nur Kontosicherheit sowie Ausgabe und Speicher. Ausführungsparameter, Bewertungsregeln und Prompts werden in den einzelnen Projekten verwaltet.",
    unsaved: "Ungespeicherte Änderungen",
    navAria: "Einstellungsbereiche",
    migratedSection: "Konfiguration verschoben",
    securityGuard: "Das Passwortformular wurde nicht abgesendet. Beim Verlassen werden das eingegebene aktuelle und neue Passwort gelöscht und müssen erneut eingegeben werden.",
    backToRunDetail: "Zurück zu den Ausführungsdetails",
    backToNewRun: "Zurück zur neuen Ausführung",
    backToReports: "Zurück zu den Berichten",
    backToLogs: "Zurück zu den Protokollen",
    backToQueue: "Zurück zur Ausführungswarteschlange",
    bannerTitle: "Auswertungseinstellungen auf Projektebene wurden verschoben",
    bannerDescription: "Ausführungsparameter, Bewertungsregeln und Prompts wurden in die Auswertungsprofile und die Prompt-Bibliothek des Projekts verschoben; sie werden nicht mehr in den früheren Umgebungseinstellungen verwaltet.",
    migratedTitle: "Ausführungsparameter / Bewertungsregeln / Prompts wurden verschoben",
    migratedDescription: "Diese Einstellungen gehören jetzt zu den Auswertungsprofilen und der Prompt-Bibliothek jedes Projekts. Öffnen Sie das Projekt auf der Projektseite, um sie zu verwalten; der frühere Umgebungsschalter wurde entfernt.",
    goToProjects: "Zu den Projekten",
    offline: "Service nicht erreichbar. Prüfen Sie das Netzwerk oder ob das lokale Backend noch läuft",
    checkFailedStale: "Diese Prüfung ist fehlgeschlagen; die nachfolgenden Daten wurden um {time} erfolgreich abgerufen. {message}",
    checkFailed: "Speicherstatus kann nicht gelesen werden. {message}",
    rechecking: "Erneute Prüfung; angezeigt werden die um {time} abgerufenen Daten.",
    checkedAt: "{provider} · schreibgeschützte Prüfung um {time} abgeschlossen",
    loadingStatus: "Plattformstatus wird gelesen",
    checkingStorage: "Speicherverbindung wird geprüft",
    storageUnavailable: "Speicherstatus nicht verfügbar",
    recheckingStorage: "Speicherverbindung wird erneut geprüft",
    storageOk: "Speicherverbindung ist fehlerfrei",
    checking: "Wird geprüft…",
    recheck: "Erneut prüfen",
    awaitingCheck: "Prüfung ausstehend",
    lastSuccessfulCheck: "Letzte erfolgreiche Prüfung: {time}. ",
    storageService: "Speicherdienst",
    storageServiceNote: "Umgebungseinstellungen, Testsuites und Ausführungen verwenden denselben Remotespeicher.",
    currentData: "Aktuelle Daten",
    currentDataValue: "{suites} Testsuites · {runs} Ausführungen",
    currentDataNote: "Die Anzahlen stammen aus einer schreibgeschützten Abfrage der aktuellen Datenbank.",
    executor: "Ausführungsdienst",
    executorWorkers: "PostgreSQL-Warteschlange · {count} Worker online",
    executorInline: "Webprozess-Threads (Kompatibilitätsmodus)",
    executorQueue: "{queued} in Warteschlange, {active} aktiv; Ausführungen unterstützen Lease-/Heartbeat-Wiederherstellung.",
    executorHint: "Beim Deployment kann in den Production-Modus postgres_worker gewechselt werden.",
    export: "Ergebnisexport",
    exportFormats: "JSON, Excel",
    exportNote: "Unterstützt vollständige Ergebnisse und den Bereich fehlgeschlagener Fragen.",
    logQuery: "Protokollabfrage",
    logQueryValue: "Filter auf der Seite, JSONL-Export",
    logQueryNote: "Nach Ausführung, Frage, Wiederholungsindex, Typ und Datum filtern.",
    viewResults: "Ausführungsergebnisse anzeigen",
    viewLogs: "Protokolle abfragen",
    section: {
      security: "Kontosicherheit",
      output: "Ausgabe und Speicher",
    },
  },
  projectRuns: {
    title: "{name} · Ausführungen",
    description: "Verfolgen Sie die Auswertungen dieses Projekts; starten Sie mit „Neue Ausführung“ eine neue.",
    openQueue: "Ausführungswarteschlange öffnen",
    loadingTitle: "Projektausführungen werden geladen",
    loadingDescription: "Ausführungsstatus dieses Projekts wird gelesen.",
    errorTitle: "Projektausführungen konnten nicht geladen werden",
    emptyTitle: "Noch keine Projektausführung",
    emptyDescription: "Ausführungen werden hier angezeigt, sobald Sie eine Auswertung mit den Testsuites dieses Projekts erstellen.",
    tableLabel: "Projektausführungen",
    column: {
      run: "Ausführung",
      status: "Ausführungsstatus",
    },
  },
  projectSuites: {
    title: "{name} · Testsuites",
    description: "Die Testsuites hier können direkt ausgeführt werden; der Fragenkatalog enthält das Ausgangsmaterial, aus dem sie zusammengestellt werden.",
    questionBank: "Fragenkatalog",
    composeFromBank: "Aus dem Fragenkatalog zusammenstellen",
    loadingTitle: "Projekt-Testsuites werden geladen",
    loadingDescription: "Test-Assets dieses Projekts werden gelesen.",
    errorTitle: "Testsuites konnten nicht geladen werden",
    emptyTitle: "Noch keine Projekt-Testsuite",
    emptyDescription: "Verwalten Sie zuerst Fragen im Fragenkatalog und erstellen Sie anschließend aus den ausgewählten Fragen eine Testsuite.",
    emptyAction: "Zum Fragenkatalog",
    tableLabel: "Projekt-Testsuites",
    createRun: "Ausführung erstellen",
    tableMeta: "{count} Testsuites · sortiert nach {sort}",
    searchAria: "Testsuites durchsuchen",
    searchPlaceholder: "Name oder ID der Testsuite suchen",
    typeFilterAria: "Nach Testsuite-Typ filtern",
    allTypes: "Alle Typen",
    statusFilterAria: "Nach Testsuite-Status filtern",
    noMatchTitle: "Keine passenden Testsuites",
    noMatchDescription: "Passen Sie Suchbegriff, Typ oder Statusfilter an.",
    column: {
      cases: "Fragen",
    },
  },
  projectSettings: {
    title: "{name} · Einstellungen",
    description: "Prüfen Sie anhand der Bereitschaftscheckliste, ob alles für eine Ausführung vorhanden ist; nach Abschluss können Sie unter „Ausführungen“ starten.",
    dirty: "Ungespeicherte Änderungen",
    guard: "Die Projektstandardwerte enthalten ungespeicherte Änderungen, die beim Verlassen verloren gehen.",
    saved: "Projektstandardwerte gespeichert",
    saveFailed: "Speichern fehlgeschlagen: {message}",
    refreshed: "Einstellungsdaten aktualisiert",
    loadingTitle: "Projekteinstellungen werden geladen",
    loadingDescription: "Standard-Auswertungsprofil und Bereitschaftsstatus werden gelesen.",
    openFailed: "Dieses Projekt kann nicht geöffnet werden",
    backToProjects: "Zurück zu den Projekten",
    lastSync: "Letzte Synchronisierung {time}",
    readinessTitle: "Bereitschaftscheckliste für Ausführungen",
    readinessSummary: "{ready}/{total} bereit. Wenn eine Vorabprüfung fehlschlägt, können Sie von der Seite für neue Ausführungen direkt zur Lücke wechseln.",
    configure: "Konfigurieren",
    defaultsTitle: "Projektstandardwerte",
    defaultsDescription: "Verantwortliche Person und Standard-Auswertungsprofil entsprechen den gespeicherten API-Werten; wenn nichts festgelegt ist, wird nichts vorausgewählt.",
    cancelChanges: "Änderungen abbrechen",
    owner: "Verantwortliche Person",
    ownerAria: "Projektverantwortliche Person",
    ownerPlaceholder: "Name oder E-Mail",
    defaultProfile: "Standard-Auswertungsprofil",
    noProfiles: "Noch kein Profil",
    notSet: "Nicht festgelegt",
    profileSetHint: "Nach dem Speichern wird dieses Profil in der Übersicht und bei neuen Ausführungen vorausgewählt.",
    profileUnsetHint: "Derzeit nicht festgelegt: Die Bereitschaftscheckliste bleibt gelb, und für neue Ausführungen ist eine manuelle Auswahl oder das Ausweichprofil erforderlich.",
    createProfileHintPrefix: "Erstellen Sie zuerst eines unter ",
    createProfileHintSuffix: ".",
    profilesUnavailable: "API für Auswertungsprofile ist nicht verfügbar: {message}",
    agentContext: "AI Engineer-Kontext",
    agentContextNone: "Kein zusätzlicher Kontext",
    agentContextContract: "URL der IM-Production-Seite",
    agentContextHint: "Optional kann eine IM-Production-Seiten-URL angegeben werden. Agent Judge sendet nur die aktuelle Route einschließlich Abfrageparametern; IM Production löst den Geschäftskontext auf.",
  },
  projects: {
    description: "Ein Projekt bildet die eindeutige Verantwortungsgrenze für Fragen, Testsuites und Ausführungen.",
    create: "Neues Projekt",
    createDescription: "Nach dem Erstellen können Sie den eigenen Fragenkatalog, die Testsuites und Ausführungen verwalten.",
    createSubmit: "Projekt erstellen",
    createFirst: "Erstes Projekt erstellen",
    closeCreateForm: "Formular für neues Projekt schließen",
    created: "Projekt „{name}“ erstellt",
    createFailed: "Erstellen fehlgeschlagen: {message}",
    createFailedTitle: "Projekt konnte nicht erstellt werden",
    checkInput: "Prüfen Sie Ihre Eingabe",
    search: "Projekte suchen",
    searchPlaceholder: "Projektname, Schlüssel oder verantwortliche Person",
    loadingTitle: "Projekte werden geladen",
    loadingDescription: "Projekte und Status ihrer Fragenkataloge werden abgerufen.",
    errorTitle: "Projekte konnten nicht geladen werden",
    errorDescription: "Projekte sind vorübergehend nicht verfügbar.",
    emptyTitle: "Noch kein Projekt",
    emptyDescription: "Erstellen Sie ein Projekt, um Fragen hinzuzufügen und Testsuites zu organisieren.",
    noMatchTitle: "Kein passendes Projekt",
    noMatchDescription: "Passen Sie den Suchbegriff oder Statusfilter an.",
    tableLabel: "Projektliste",
    unassigned: "Nicht zugewiesen",
    open: "Projekt öffnen",
    status: {
      active: "Aktiv",
      draft: "Entwurf",
      archived: "Archiviert",
    },
    field: {
      name: "Projektname",
      key: "Eindeutiger Schlüssel",
      type: "Projekttyp",
      defaultEnvironment: "Standardumgebung",
      description: "Fachliche Beschreibung",
    },
    column: {
      questions: "Fragen",
      lastRun: "Letzte Ausführung",
    },
  },
  overview: {
    title: "Übersichtskonsole",
    description: "Prüfen Sie Projekte, Assets im Fragenkatalog und die neuesten Auswertungen.",
    loadingTitle: "Arbeitsbereich wird geladen",
    loadingDescription: "Projekte, Testsuites und Ausführungen werden zusammengeführt.",
    errorTitle: "Übersicht konnte nicht geladen werden",
    errorDescription: "Daten sind vorübergehend nicht verfügbar.",
    storageErrorTitle: "Problem mit der Speicherverbindung",
    storageErrorDetail: "Aktueller Speicher: {provider}. Stellen Sie die Verbindung wieder her, bevor Sie eine Ausführung erstellen.",
    checkSettings: "Systemeinstellungen prüfen",
    failedRunsTitle: "{count} fehlgeschlagene Ausführungen müssen geprüft werden",
    failedRunsDetail: "Letzter Fehler: {name}",
    viewFailedRuns: "Fehlgeschlagene Ausführungen anzeigen",
    noProjectsTitle: "Noch kein aktives Projekt",
    noProjectsDetail: "Ein Projekt umfasst Fragen und Testsuites; erstellen Sie eines, bevor Sie Testsuites vorbereiten.",
    noSuitesTitle: "Noch keine Testsuite; Ausführung nicht möglich",
    noSuitesDetail: "Auswertungen verwenden eine Testsuite als Eingabe; stellen Sie zuerst eine unter den Projekt-Testsuites zusammen.",
    prepareSuites: "Testsuites vorbereiten",
    activeRunsTitle: "{count} Ausführungen laufen",
    activeRunsDetail: "Öffnen Sie die Ausführungswarteschlange, um den Fortschritt zu verfolgen sowie Ausführungen zu stoppen oder fortzusetzen.",
    trackActiveRuns: "Laufende Aufträge verfolgen",
    readyTitle: "Assets sind bereit; Sie können eine Ausführung erstellen",
    readyDetail: "Projekte und Testsuites sind vorhanden; wählen Sie zum Starten ein Projekt aus.",
    statusStripAria: "Plattformstatus und nächster Schritt",
    failedRunsCount: "Fehlgeschlagene Ausführungen: {count}",
    activeRunsCount: "Aktiv: {count}",
    storageState: "Speicher: {state}",
    storageOk: "Fehlerfrei · {provider}",
    storageError: "Fehler",
    connected: "Verbunden",
    quickLinksAria: "Schnellzugriff",
    recentRuns: "Letzte Ausführungen",
    recentRunsHint: "Einheitliche Ansicht aller Auswertungen (die 8 neuesten nach Erstellungszeit)",
    viewAll: "Alle anzeigen",
    noRunsTitle: "Noch keine Ausführung",
    noRunsDescription: "Wählen Sie zuerst eine Testsuite aus und erstellen Sie eine Auswertung.",
    health: "Ausführungsstatus",
    healthHint: "Speicher- und Ausführungsstatus",
    running: "Aktiv",
    runningHint: "Wird validiert oder ausgeführt",
    queued: "In Warteschlange",
    queuedHint: "Wartet auf einen Worker",
    storage: "Speicher",
    statusChecking: "Status wird geprüft",
    metric: {
      activeProjects: "Aktive Projekte",
      activeProjectsHint: "Verantwortungsgrenze für Fragen und Test-Assets",
      questions: "Projektfragen",
      questionsHint: "Gesamtzahl aktiver Fragen in allen Projekten (ohne archivierte)",
      suitesHint: "An bestimmte Fragenversionen gebunden",
      active: "Aktiv",
      activeHint: "In Warteschlange, Validierung, Ausführung oder Abschluss",
    },
    link: {
      projects: "Projekt öffnen und dessen Fragen und Testsuites verwalten",
      questionBank: "Fragenkatalog eines Projekts zur Verwaltung auswählen",
      suites: "An Versionen gebundene Auswertungs-Assets prüfen",
    },
    column: {
      time: "Zeit",
    },
  },
  failures: {
    title: "Prüfung fehlgeschlagener Fragen",
    runMissing: "Die Ausführung ist nicht vorhanden oder wurde gelöscht",
    requestFailed: "Anfrage fehlgeschlagen",
    selectCase: "Wählen Sie eine fehlgeschlagene Frage aus, um deren Details anzuzeigen.",
    caseHeading: "Frage {caseId}",
    previousAria: "Vorherige fehlgeschlagene Frage",
    nextAria: "Nächste fehlgeschlagene Frage",
    viewInRun: "In der ursprünglichen Ausführung anzeigen",
    viewTurnLogs: "Protokolle dieser Runde anzeigen",
    retryIncomplete: "Unvollständiges Ergebnis erneut versuchen",
    userQuestion: "Benutzerfrage",
    belowThreshold: "Unter dem Bestehensschwellenwert; prüfen Sie die Antwort anhand der Referenz.",
    retryStarted: "Technischer Wiederholungsversuch für Frage {caseId}, Wiederholung {index}, gestartet",
    retryFailed: "Wiederholungsversuch fehlgeschlagen: {message}",
    downloadStarted: "Download der Fehlerdetails gestartet",
    downloadFailed: "Download fehlgeschlagen: {message}",
    downloading: "Wird heruntergeladen",
    downloadDetails: "Fehlerdetails herunterladen",
    loading: "Fehlgeschlagene Fragen werden geladen",
    loadFailed: "Fehlgeschlagene Fragen konnten nicht geladen werden",
    retryConfirmTitle: "Frage „{caseId}“, Wiederholung {index}, erneut versuchen?",
    retryConfirmDescription: "Dadurch wird das unvollständige Ergebnis innerhalb der aktuellen Ausführung repariert; der ursprüngliche Fehlereintrag bleibt archiviert.",
    retryConfirm: "Erneut versuchen",
    failedCount: "{count} fehlgeschlagene wiederholte Antworten",
    affectedCases: "{count} betroffene Fragen",
    runId: "Ausführungs-ID: {id}",
    minScore: "Min. Punktzahl",
    maxScore: "Max. Punktzahl",
    correctness: "Korrektheit",
    incorrect: "Falsch",
    correct: "Richtig",
    filterSummary: "{shown} / {total} fehlgeschlagene wiederholte Antworten aus {cases} Fragen werden angezeigt. Sortiert nach Fragen-ID aufsteigend und innerhalb jeder Frage nach der Nummer der wiederholten Antwort; der Punktebereich ist nur ein sekundärer Filter und entscheidet nicht über das Nichtbestehen.",
    tableLabel: "Liste fehlgeschlagener Fragen",
    rowAria: "Fehlgeschlagene Frage {caseId}, Wiederholung {index}, Durchschnitt ausgeführter Runden {average}, {done}/{total} abgeschlossen, anzeigen",
    noFiltered: "Keine fehlgeschlagene Frage entspricht den aktuellen Filtern.",
    paginationAria: "Seitennavigation fehlgeschlagener Fragen",
  },
  logsPage: {
    networkFailed: "Netzwerkverbindung fehlgeschlagen. Prüfen Sie, ob der Service erreichbar ist, und versuchen Sie es erneut.",
    loadFailed: "Protokolle konnten nicht geladen werden",
    loading: "Protokolle werden geladen",
    backToFailures: "Zurück zur Fehlerprüfung",
    backToRunList: "Zurück zur Ausführungsliste",
    copied: "Protokoll kopiert",
    copyFailed: "Kopieren fehlgeschlagen: {message}",
    exportStarted: "Protokollexport gestartet",
    exportFailed: "Protokollexport fehlgeschlagen: {message}",
    exportFiltered: "Aktuellen Filter exportieren ({count} Einträge) · JSONL",
    exportAll: "Alle Protokolle exportieren ({count} Einträge) · JSONL",
    exportBlockedError: "Protokolle konnten nicht geladen werden; laden Sie sie vor dem Export erneut",
    exportBlockedLoading: "Der Export ist verfügbar, sobald die Protokolle vollständig geladen sind",
    exportBlockedEmpty: "Kein Protokoll entspricht den aktuellen Filtern",
    exporting: "Wird exportiert",
    currentRun: "Aktuelle Ausführung: ",
    selectRunHint: "Wählen Sie eine Ausführung aus, um deren Protokolle abzufragen",
    confirmingRun: "Ausführungseintrag wird bestätigt",
    confirmRunFailed: "Ausführungseintrag kann nicht bestätigt werden",
    reloadRuns: "Ausführungsliste neu laden",
    linkExpired: "Dieser Protokolllink ist nicht mehr gültig. Kehren Sie zur Protokollübersicht zurück und wählen Sie eine vorhandene Ausführung aus.",
    viewAvailableLogs: "Verfügbare Protokolle anzeigen",
    runsLoadFailed: "Ausführungen konnten nicht geladen werden",
    noLogsTitle: "Noch kein Ausführungsprotokoll",
    noLogsDescription: "AI Engineer- und Judge-Protokolle werden hier nach Abschluss einer Auswertung angezeigt.",
    importSuite: "Testsuite importieren",
    runSelect: "Ausführung",
    noRuns: "Keine Ausführung verfügbar",
    caseIdPlaceholder: "z. B. FRAGE-0001",
    runIndex: "Wiederholungsindex",
    dateFrom: "Startdatum",
    dateTo: "Enddatum",
    query: "Abfragen",
    querying: "Wird abgefragt",
    filtersDirty: "Filter wurden geändert. Drücken Sie die Eingabetaste oder klicken Sie auf „Abfragen“, um sie anzuwenden.",
    content: "Protokollinhalt",
    contentPlaceholder: "Protokollinhalt durchsuchen",
    categoryGroup: "Protokolltyp",
    rawLevel: "Rohstufe: {label}",
    rawLevelLabel: "Rohstufe",
    rawLevelTitle: "Rohstufenwert {level}",
    clearRawLevel: "Rohstufenfilter löschen",
    resetFilters: "Filter zurücksetzen",
    dateRangeInvalid: "Das Enddatum darf nicht vor dem Startdatum liegen.",
    rowAria: "Protokolldetails anzeigen: {time}, {category}, {caseId}, {message}",
    noCaseId: "keine Fragen-ID",
    noMessage: "kein Inhalt",
    noFiltered: "Kein Protokoll entspricht den aktuellen Filtern.",
    noLogsForRun: "Für diese Ausführung gibt es noch keinen Protokolleintrag.",
    countRange: "Einträge {from}–{to} von {total} Protokollen · neueste zuerst, {pageSize} pro Seite",
    countEmpty: "0 Protokolle · neueste zuerst, {pageSize} pro Seite",
    detailTitle: "Protokolldetails",
    detailEmpty: "Wählen Sie einen Protokolleintrag aus, um den vollständigen Inhalt anzuzeigen.",
    businessType: "Geschäftstyp",
    runIdLabel: "Ausführungs-ID",
    redactNote: "Felder mit Anmeldedaten sind geschwärzt; „Protokoll kopieren“ kopiert ebenfalls den geschwärzten Inhalt.",
    copyLog: "Protokoll kopieren",
    viewRelatedCase: "Zugehörige Frage anzeigen",
    openRunResult: "Ausführungsergebnisse öffnen",
    category: {
      error: "Ausführungsfehler",
      finding: "Judge-Befund",
      warning: "Ausführungswarnung",
      info: "Ausführungsinformation",
    },
    column: {
      source: "Quelle",
      message: "Meldung",
    },
  },
  projectDetail: {
    loadingTitle: "Projekt wird geladen",
    loadingDescription: "Fragen, Testsuites und Ausführungen des Projekts werden abgerufen.",
    missing: "Das Projekt ist nicht vorhanden oder vorübergehend nicht verfügbar.",
    noProfileTitle: "Konfigurationslücke: Kein Standard-Auswertungsprofil gespeichert",
    noProfileDetail: "Übersicht und Seite für neue Ausführungen verwenden das gespeicherte Standardprofil; die API meldet derzeit keines.",
    saveDefaultProfile: "Standard-Auswertungsprofil speichern",
    noBindingTitle: "Keine Umgebungsbindung konfiguriert",
    noBindingDetail: "Konfigurieren Sie Umgebung × Endpunkt × Mandant, bevor AI Engineers für eine Ausführung geladen werden können.",
    noBindingHint: "Konfigurieren Sie Plattformadresse, Konto und Mandant pro Umgebung unter „Umgebungsbindungen“.",
    noBindingReadOnly: "Schreibgeschützte Projekte können keine Umgebungsbindungen hinzufügen.",
    configureFirstBinding: "Erste Bindung konfigurieren",
    addBinding: "Umgebungsbindung hinzufügen",
    addBindingShort: "Bindung hinzufügen",
    readyWithReportTitle: "Projekt ist ausführbar; ein aktueller Bericht ist vorhanden",
    latestReportDetail: "Neuester Bericht: {name}",
    viewLatestReport: "Neuesten Bericht anzeigen",
    readyTitle: "Projekt ist bereit; Sie können eine Ausführung erstellen",
    readyDetail: "Standard-Auswertungsprofil und Umgebungsbindung sind vorhanden.",
    statusStripAria: "Projektstatus und nächster Schritt",
    defaultProfileLabel: "Standard-Auswertungsprofil: ",
    profileConfigured: "Konfiguriert · {name}",
    notConfigured: "Nicht konfiguriert",
    latestReportLabel: "Neuester Bericht: ",
    none: "Keine",
    basicInfo: "Projektgrundlagen",
    basicInfoHint: "Maßgebliche Konfiguration und Governance-Felder; doppelte Einträge werden in Statusleiste und KPIs zusammengefasst.",
    ownerHint: "Für dieses Projekt verantwortliche Person",
    assignOwner: "Verantwortliche Person zuweisen",
    defaultProfileHint: "Entspricht dem gespeicherten API-Feld",
    projectKey: "Projektschlüssel",
    projectKeyHint: "Stabile eindeutige Kennung",
    bindingSummary: "Übersicht der Umgebungsbindungen",
    bindingSummaryHint: "Nur diese Übersicht bleibt auf dem ersten Bildschirm; Bindungen werden in den Einstellungen verwaltet und hinzugefügt.",
    manage: "Verwalten",
    bindingTableLabel: "Umgebungsbindungen des Projekts",
    metric: {
      questionsHint: "Aktivierte Fragen (entspricht dem Filter „Aktiviert“ im Fragenkatalog)",
      runs: "Ausführungen",
      runsHint: "Historische Auswertungen dieses Projekts",
      bindings: "Umgebungsbindungen",
      bindingsHint: "Umgebung × Endpunkt × Mandant",
    },
    link: {
      content: "Testsuites zuerst; der Fragenkatalog liefert das Material",
      runs: "Fortschritt und Verlauf von Ausführungen verfolgen",
      tasks: "Evaluierungen erstellen sowie Warteschlange, Ausführung und Fehler verfolgen",
      results: "Antworten je Frage, Vollständigkeit, Bewertung und Erfolg prüfen",
      reports: "Ergebnisse und Details abgeschlossener Auswertungen prüfen",
      production: "Reale Unterhaltungen filtern und mit der Referenzantwort synchronisieren",
      questions: "Hinzufügen, bearbeiten, Verlauf anzeigen und projektübergreifend kopieren",
      settings: "Umgebungen, Auswertungsprofile, Prompts und Projektstandardwerte",
    },
    column: {
      connection: "Verbindung",
      tenant: "Mandant",
      stage: "Umgebung",
    },
  },
  projectPrompts: {
    title: "{name} · Prompts",
    description: "Verwalten Sie Prompts zur Antwortbewertung für dieses Projekt; sie können beim Erstellen einer Ausführung ausgewählt und angepasst werden.",
    createTitle: "Neuer Prompt",
    createSubmit: "Prompt erstellen",
    editTitle: "„{name}“ bearbeiten",
    editorDescription: "Der zur Laufzeit ausgewählte Inhalt wird als Snapshot in der Ausführung gespeichert; diese Bibliothek enthält wiederverwendbare Inhalte, nicht die Bewertungsregel selbst.",
    unsaved: "Ungespeichert",
    clearDraft: "Entwurf löschen",
    namePlaceholder: "z. B. Strenger Bewertungs-Prompt",
    descriptionPlaceholder: "Verwendungszweck oder Wartungshinweis (optional)",
    body: "Prompt-Inhalt",
    bodyPlaceholder: "Vollständigen Judge-Prompt schreiben",
    guard: "Der Prompt enthält ungespeicherte Änderungen, die beim Verlassen verloren gehen.",
    created: "Prompt „{name}“ erstellt",
    updated: "Prompt „{name}“ aktualisiert",
    updateFailed: "Aktualisierung fehlgeschlagen: {message}",
    deleted: "Prompt gelöscht",
    deleteFailed: "Löschen fehlgeschlagen: {message}",
    refreshed: "Prompts aktualisiert",
    loadingProject: "Prompt-Bibliothek wird abgerufen.",
    loading: "Prompts werden geladen",
    loadingHint: "Wenn die Bibliothek beim ersten Öffnen leer ist, erzeugt das Backend einen Systemstandard-Inhalt.",
    unavailable: "Die Prompt-Bibliothek ist nicht verfügbar",
    emptyTitle: "Noch kein Prompt",
    emptyDescription: "Aktualisieren Sie, um den Systemstandard zu erzeugen, oder erstellen Sie direkt einen Prompt.",
    total: "{count} insgesamt",
    tableLabel: "Projekt-Prompt-Bibliothek",
    referencedByDefault: "Vom Standardprofil referenziert",
    notReferenced: "Von keinem Profil referenziert",
    noDescription: "Keine Beschreibung",
    readOnly: "Schreibgeschützt",
    discardTitle: "Ungespeicherte Prompt-Änderungen verwerfen?",
    discardDescription: "Beim Schließen des Editors werden der eingegebene Name, die Beschreibung und der Inhalt verworfen; gespeicherte Prompts bleiben unverändert.",
    discardConfirm: "Änderungen verwerfen",
    deleteTitle: "Prompt „{name}“ löschen?",
    deleteTitleFallback: "Prompt löschen?",
    deleteDescription: "Prompt-Snapshots in historischen Ausführungen werden nicht neu geschrieben. Falls ein Profil ihn noch referenziert, verwendet es den Systemstandard.",
    deleteReferences: "Derzeit referenziert von: {names}",
    deleteConfirm: "Löschen",
    column: {
      references: "Referenzen",
      preview: "Vorschau von Beschreibung / Inhalt",
      updated: "Aktualisiert",
    },
  },
  queue: {
    description: "Prüfen Sie projektübergreifend den Auswertungsstatus und filtern Sie nach Projekt. Verwenden Sie für die tägliche Arbeit vorzugsweise die Seite „Ausführungen“ des jeweiligen Projekts.",
    projectDescription: "Testaufgaben erstellen und Warteschlange, Ausführung, Fehler sowie Wiederholungen verfolgen.",
    dataUnavailable: "Ausführungsdaten sind nicht verfügbar",
    refreshing: "Wird aktualisiert",
    totalRuns: "Insgesamt {count} Ausführungen",
    totalTasks: "{count} Testaufgaben",
    updatedSuffix: " · Aktualisiert {time}",
    searchPlaceholder: "Ausführungsname, ID, AI Engineer oder Umgebung suchen",
    searchAria: "Ausführungen suchen",
    searchTaskPlaceholder: "Aufgabenname, ID, AI Engineer oder Umgebung suchen",
    searchTasksAria: "Testaufgaben durchsuchen",
    statusAll: "Alle Status",
    statusFilterAria: "Nach Ausführungsstatus filtern",
    projectFilterAria: "Ausführungen nach Projekt filtern",
    allProjects: "Alle Projekte",
    environmentFilterAria: "Testaufgaben nach Umgebung filtern",
    allEnvironments: "Alle Umgebungen",
    agentFilterAria: "Testaufgaben nach AI Engineer filtern",
    filterSummary: "{shown} / {total} Treffer",
    loadingTitle: "Ausführungswarteschlange wird geladen",
    loadingDescription: "Neuester Ausführungsstatus wird abgerufen. Bitte warten.",
    errorTitle: "Ausführungswarteschlange konnte nicht geladen werden",
    errorDescription: "Die Ausführungsliste ist vorübergehend nicht verfügbar.",
    emptyTitle: "Noch keine Auswertungen",
    emptyDescription: "Nach dem Erstellen der ersten Ausführung können Sie hier deren Fortschritt verfolgen und Ergebnisse öffnen.",
    emptyProjectDescription: "Dieses Projekt enthält noch keine Testaufgaben.",
    noMatchTitle: "Keine passenden Ausführungen",
    noMatchDescription: "Passen Sie den Suchbegriff oder Statusfilter an.",
    tableLabel: "Ausführungswarteschlange",
    projectTableLabel: "Testaufgaben des Projekts",
    batch: "Stapel {position}/{size} · {id}",
    progressAria: "Ausführungsfortschritt {name}",
    questionCompletedSummary: "{completed}/{total} Fragen regulär abgeschlossen; {incomplete} unvollständig",
    questionProcessedSummary: "{done}/{total} Fragen verarbeitet",
    questionCompletionUnknown: "Insgesamt {total} Fragen; Anzahl regulär abgeschlossener Fragen nicht verfügbar",
    viewDetail: "Details anzeigen",
    viewDetailAria: "Details von {name} anzeigen",
    actionAria: "{action} {name}",
    stop: "Stoppen",
    stopping: "Wird gestoppt",
    resume: "Fortsetzen",
    resuming: "Wird fortgesetzt",
    newRunDescription: "Wählen Sie zum Starten Umgebung, AI Engineer, Testsuite und Wiederholungsanzahl aus.",
    column: {
      run: "Testaufgabe",
      environment: "Umgebung",
      agentContext: "AI Engineer-Kontext",
      status: "Status",
      progress: "Fortschritt",
      cases: "Abgeschlossene Fragen",
      repeat: "Wiederholung",
    },
    confirm: {
      deleteTitle: "Diese Ausführung löschen?",
      deleteDescription: "Beim Löschen werden Ausführungsergebnisse, Berichte und Protokolle entfernt. Dies kann nicht rückgängig gemacht werden.",
      stopTitle: "Diese Ausführung stoppen?",
      stopDescription: "Die laufende Auswertung wird abgebrochen. Eine gestoppte Ausführung kann nicht fortgesetzt werden; öffnen Sie für eine erneute Ausführung die Details und wählen Sie „Erneut ausführen“.",
      resumeTitle: "Diese Ausführung fortsetzen?",
      resumeDescription: "Die Ausführung wird ab dem gespeicherten Fortschritt fortgesetzt und kann neue Modellaufrufe auslösen.",
      target: "Ausführung: {name}",
      stop: "Stoppen bestätigen",
      resume: "Fortsetzen bestätigen",
    },
  },
  connections: {
    title: "Verbindungen",
    description: "Konfigurieren Sie die URL der Zielplattform (z. B. https://tesaqaedev.tesa.cn/) und das Anmeldekonto. Prüfen Sie anschließend, ob Mandanten abgerufen werden können. Judge-Modelle werden in Evaluierungsprofilen konfiguriert.",
    create: "Neue Verbindung",
    createFirst: "Erste Verbindung erstellen",
    scope: "Geltungsbereich",
    scopeFilterAria: "Verbindungen nach Geltungsbereich filtern",
    scopeWorkspace: "Im Arbeitsbereich geteilt",
    scopeProject: "Projektintern",
    scopeProjectDefault: "Projektintern (Standard)",
    summary: "Insgesamt {count}",
    summaryTotal: " / {total} gesamt",
    loadingTitle: "Verbindungen werden geladen",
    loadingDescription: "Die Verbindungsliste wird gelesen.",
    errorTitle: "Verbindungsliste ist nicht verfügbar",
    emptyTitle: "Noch keine Verbindungen",
    emptyDescription: "Erstellen Sie zuerst eine Verbindung mit Plattform-URL und Konto, damit Projekte Mandanten / AI Engineers abrufen und Evaluierungen starten können.",
    noMatchTitle: "Keine Verbindungen entsprechen dem Filter",
    noMatchDescription: "Keine Verbindung unter dem aktuellen Filter „{scope}“; insgesamt {total} Verbindungen.",
    noPlatformUrl: "Keine Plattform-URL",
    passwordConfigured: "Passwort gespeichert",
    notConfigured: "Nicht konfiguriert",
    fetchTenants: "Mandanten abrufen",
    goToEnv: "Umgebung konfigurieren",
    legacyMappingTitle: "Zuordnung aus den bisherigen Umgebungseinstellungen",
    legacyMappingBody: "URL + Anmeldekonto → diese Seite „Verbindungen“; Mandanten- / AI Engineer-Bindung → Projektumgebung; Judge-Modell → Evaluierungsprofil.",
    createTitle: "Neue Verbindung",
    editTitle: "Verbindung bearbeiten · {name}",
    createDescription: "Plattform-URL und Konto eingeben → mit „Verbinden und Mandanten abrufen“ prüfen → speichern. Wählen Sie anschließend Mandant / AI Engineer auf der Seite „Projektumgebung“ aus.",
    editDescription: "Nach dem Aktualisieren von URL oder Konto können Sie zur Prüfung erneut Mandanten abrufen. Lassen Sie das Passwort leer, um es beizubehalten.",
    unsaved: "Nicht gespeichert",
    unsavedGuard: "Das Verbindungsformular enthält nicht gespeicherte Änderungen, die beim Verlassen verloren gehen.",
    revert: "Änderungen zurücksetzen",
    fetchingTenants: "Mandanten werden abgerufen…",
    connectAndFetch: "Verbinden und Mandanten abrufen",
    fetchWithSaved: "Mit gespeicherten Zugangsdaten abrufen",
    saveConnection: "Verbindung speichern",
    saveChanges: "Änderungen speichern",
    noChanges: "Keine Änderungen",
    connectorType: "Verbindungstyp",
    connectorTypeHelp: "Kennung des Zielplattformtyps; Standard ist im_production.",
    owningProject: "Zugehöriges Projekt",
    noProjects: "Kein verfügbares Projekt",
    platformUrl: "Plattform-URL / Anmeldeseite",
    platformUrlHelp: "Geben Sie die Stamm-URL der Website oder /login ein; Mandantenanmeldung und AI Engineer-API werden automatisch abgeleitet.",
    username: "Anmeldename",
    password: "Anmeldepasswort",
    passwordSavedPlaceholder: "Gespeichert; zum Beibehalten leer lassen",
    passwordPlaceholder: "Passwort eingeben",
    discardTitle: "Nicht gespeicherte Verbindungsänderungen verwerfen?",
    discardDescription: "Beim Schließen des Editors werden der eingegebene Name, die Plattform-URL, das Konto und das Passwort verworfen. Gespeicherte Verbindungen bleiben unverändert.",
    keepEditing: "Weiter bearbeiten",
    discardConfirm: "Änderungen verwerfen",
    createdToast: "Verbindung „{name}“ erstellt. Rufen Sie Mandanten / AI Engineers auf der Seite „Projektumgebung“ ab.",
    createFailed: "Verbindung konnte nicht erstellt werden: {message}",
    updatedToast: "Verbindung „{name}“ aktualisiert",
    updateFailed: "Verbindung konnte nicht aktualisiert werden: {message}",
    tenantsFetched: "{count} Mandanten abgerufen",
    fetchTenantsFailed: "Mandanten konnten nicht abgerufen werden: {message}",
    draftTenantsFetched: "Das Konto funktioniert; {count} Mandanten gefunden. Speichern Sie jetzt die Verbindung.",
    connectFailed: "Verbindung und Mandantenabruf fehlgeschlagen: {message}",
    tenantPreviewSaved: "Mandantenvorschau (gespeicherte Verbindung)",
    tenantPreviewDraft: "Mandantenvorschau (noch nicht gespeichert)",
    tenantPreviewHint: "Insgesamt {count}. Wählen Sie den konkreten Mandanten und AI Engineer beim Binden der Projektumgebung aus.",
    tenantPreviewLimit: "Nur die ersten {count} werden angezeigt…",
    column: {
      name: "Name",
      platform: "Plattform-URL",
      account: "Konto",
    },
  },
  targets: {
    pageTitle: "{name} · Umgebungen",
    pageDescription: "Binden Sie für jede Umgebungsstufe eine Plattform-URL und einen Mandanten. Wählen Sie beim Start einer Evaluierung den AI Engineer dieses Mandanten aus.",
    unsavedGuard: "Das Formular für die Umgebungsbindung enthält nicht gespeicherte Änderungen, die beim Verlassen verloren gehen.",
    formNotOpen: "Das Formular ist nicht geöffnet",
    passwordRequired: "Geben Sie nach dem Ändern der Plattform-URL oder des Kontos das Passwort ein, bevor Sie Mandanten abrufen; eine reine Umbenennung erfordert keinen erneuten Abruf",
    missingBinding: "Bindung fehlt",
    createdToast: "Umgebungsbindung „{name}“ erstellt",
    createFailed: "Erstellen fehlgeschlagen: {message}",
    updatedToast: "Umgebungsbindung „{name}“ aktualisiert",
    updateFailed: "Aktualisieren fehlgeschlagen: {message}",
    defaultSetToast: "„{name}“ ist jetzt die Standardumgebung",
    defaultFailed: "Standard konnte nicht festgelegt werden: {message}",
    disabledToast: "Umgebungsbindung deaktiviert",
    disableFailed: "Deaktivieren fehlgeschlagen: {message}",
    deletedToast: "Umgebungsbindung gelöscht",
    deletedDisabledToast: "Umgebungsbindung entfernt (wegen vorhandener historischer Durchläufe deaktiviert)",
    deleteFailed: "Löschen fehlgeschlagen: {message}",
    readConnectionFailed: "Verbindungseinstellungen konnten nicht gelesen werden: {message}",
    selectTenantFirst: "Rufen Sie zuerst einen Mandanten ab und wählen Sie ihn aus",
    loadingProject: "Projekt wird geladen",
    loadingProjectDescription: "Umgebungsbindungen werden abgerufen.",
    projectUnavailable: "Das Projekt kann nicht geöffnet werden",
    backToProjects: "Zurück zu den Projekten",
    lastSynced: "Zuletzt synchronisiert: {time}",
    refreshedToast: "Umgebungsbindungen aktualisiert",
    addBinding: "Bindung hinzufügen",
    loadingTitle: "Umgebungsbindungen werden geladen",
    loadingDescription: "Plattform-URLs und Mandanten, gruppiert nach Umgebungsstufe.",
    errorTitle: "Umgebungsbindungen konnten nicht geladen werden",
    emptyTitle: "Keine Umgebungsbindung konfiguriert",
    emptyReadOnly: "In schreibgeschützten Projekten können keine Bindungen hinzugefügt werden.",
    emptyDescription: "Fügen Sie diesem Projekt eine Umgebungsstufe + Plattform-URL + Mandant hinzu. Danach können AI Engineers beim Erstellen eines Durchlaufs abgerufen werden.",
    createFirst: "Erste Umgebung konfigurieren",
    stageCount: "{count} Umgebungsbindungen",
    stageCountPaged: "{shown} auf dieser Seite / {total} Umgebungsbindungen",
    tableLabel: "Umgebungsbindungen für {stage}",
    default: "Standard",
    setDefault: "Als Standard festlegen",
    disable: "Deaktivieren",
    disableHint: "Nach der Deaktivierung wird sie nicht mehr in den Durchlaufoptionen angezeigt",
    lastActiveDisableHint: "Dies ist die einzige aktivierte Bindung; ihre Deaktivierung blockiert neue Durchläufe. Fügen Sie zuerst eine weitere Bindung hinzu",
    lastActiveDeleteHint: "Dies ist die einzige aktivierte Bindung und kann nicht gelöscht werden; fügen Sie eine weitere Bindung hinzu, legen Sie sie als Standard fest und löschen Sie dann diese Bindung",
    lastActiveTitle: "Nur noch eine aktivierte Bindung",
    lastActiveBody: "Damit das Projekt ausführbar bleibt, kann die einzige aktivierte Bindung weder deaktiviert noch gelöscht werden. Fügen Sie zuerst eine weitere Bindung hinzu und legen Sie sie als Standard fest.",
    nextStepTitle: "Nächster Schritt",
    nextStepPrefix: "Gehen Sie zu",
    nextStepSuffix: ": Umgebung auswählen → AI Engineers für diesen Mandanten abrufen → auswählen und starten.",
    createTitle: "Umgebungsbindung hinzufügen",
    editTitle: "„{name}“ bearbeiten",
    bindingFallback: "Umgebungsbindung",
    createDescription: "Plattform-URL und Konto eingeben → Mandanten abrufen → auswählen und speichern. Pro Umgebungsstufe bleibt nur eine aktivierte Bindung erhalten.",
    editDescription: "Ändern Sie Plattform-URL und Zugangsdaten, ohne die Bindung zu löschen und neu zu erstellen. Lassen Sie das Passwort leer, um es beizubehalten.",
    saveBinding: "Umgebungsbindung speichern",
    stage: "Umgebungsstufe",
    displayName: "Anzeigename",
    displayNamePlaceholder: "Zum Beispiel: Dev · tesa",
    platformUrl: "Plattform-URL / Anmeldeseite",
    setDefaultEnv: "Als Standardumgebung festlegen",
    setDefaultEnvHelp: "Bei neuen Durchläufen wird diese Bindung vorausgewählt",
    fetching: "Wird abgerufen…",
    connectAndFetch: "Verbinden und Mandanten abrufen",
    selectTenant: "Mandant auswählen",
    chooseTenant: "Mandanten auswählen",
    keepTenant: "Aktuellen Mandanten beibehalten oder zuerst abrufen",
    fetchTenantsFirst: "Zuerst Mandanten abrufen",
    discardTitle: "Nicht gespeicherte Änderungen an der Umgebungsbindung verwerfen?",
    discardDescription: "Beim Schließen des Editors werden die eingegebene Plattform-URL, das Konto, das Passwort und die Mandantenauswahl verworfen. Gespeicherte Bindungen bleiben unverändert.",
    deleteTitle: "Umgebungsbindung „{name}“ löschen?",
    deleteTitleFallback: "Umgebungsbindung löschen?",
    deleteDescription: "Wenn keine historischen Durchläufe vorhanden sind, werden auch die Verbindungseinstellungen bereinigt; andernfalls wird die Bindung deaktiviert und die Datensätze bleiben erhalten.",
    deleteDetails: "Um ein Passwort zu ändern oder die URL anzupassen, verwenden Sie „Bearbeiten“ statt „Löschen“.",
    column: {
      connection: "Verbindung / Zugriffskonfiguration",
      tenant: "Mandant",
    },
  },
  suitesPage: {
    title: "Testsuite-Bibliothek",
    description: "Importieren oder wählen Sie eine Testsuite, um Frageninhalte, Quellen der Fragenversionen und Tag-Snapshots zu prüfen.",
    globalDescription: "Projektübergreifend Testsuites durchsuchen und Fragen, Versionen sowie Ausführbarkeit prüfen; Import und Zusammenstellung erfolgen im zugehörigen Projekt.",
    globalEmptyDescription: "Noch keine Testsuites verfügbar; erstellen oder importieren Sie eine auf der Testsuite-Seite eines Projekts.",
    actionFailed: "Aktion fehlgeschlagen. Versuchen Sie es später erneut",
    pickFile: ".xlsx-Testsuite-Datei auswählen",
    pickProject: "Projekt auswählen, zu dem die Testsuite gehört",
    parsed: "Die Testsuite wurde analysiert. Lösen Sie Konflikte und bestätigen Sie den Schreibvorgang.",
    imported: "Testsuite-Import abgeschlossen",
    uploadFailed: "Upload fehlgeschlagen: {message}",
    savedToast: "Testsuite-Details gespeichert",
    saveFailed: "Testsuite konnte nicht gespeichert werden: {message}",
    idCopied: "Testsuite-ID kopiert",
    copyFailed: "Kopieren fehlgeschlagen. Kopieren Sie die Testsuite-ID manuell",
    deletedToast: "Testsuite gelöscht",
    deleteFailed: "Testsuite konnte nicht gelöscht werden: {message}",
    rebuiltSuiteName: "{name} · aktuelle Versionen",
    rebuiltToast: "Testsuite „{name}“ aus den aktuellen Fragenkatalog-Versionen erstellt; die ursprüngliche Testsuite behält ihre Versionen",
    rebuildFailed: "Testsuite konnte nicht neu erstellt werden: {message}",
    loadingTitle: "Testsuites werden geladen",
    loadingDescription: "Testsuite-Liste und Fragendetails werden gelesen.",
    errorTitle: "Testsuites konnten nicht geladen werden",
    importDialogTitle: "Testsuite importieren",
    importDialogDescription: "Wählen und verarbeiten Sie eine Excel-Datei. Bei Konflikten prüfen Sie diese im Projekt-Fragenkatalog, bevor Sie den Import bestätigen.",
    importToProject: "In Projekt importieren",
    chooseProject: "Wählen Sie zuerst ein Projekt aus",
    globalImportHint: "Die globale Testsuite-Seite unterstützt nur Suche und Navigation. Wählen Sie vor dem Import das zugehörige Projekt aus oder wechseln Sie zur Testsuite-Seite des Projekts.",
    projectsLoadFailed: "Projekte konnten nicht geladen werden; der Import ist derzeit nicht verfügbar.",
    backToContent: "Zurück zu den Inhalten",
    backToSuites: "Zurück zur Testsuite-Bibliothek",
    downloadTemplate: "Einheitliche Excel-Vorlage herunterladen",
    closeImportStatus: "Importstatus schließen",
    missingTitle: "Die Testsuite ist nicht vorhanden oder wurde gelöscht",
    missingDescription: "Die Testsuite-ID „{id}“ im Link ist nicht mehr gültig. Wählen Sie eine vorhandene Testsuite aus oder importieren Sie eine neue Excel-Testsuite.",
    emptyTitle: "Noch keine Testsuites",
    emptyDescription: "Die einheitliche Vorlage unterstützt Fragen mit einer oder mehreren Runden. Füllen Sie Fragen und Runden aus, importieren Sie die Datei, prüfen Sie Konflikte und bestätigen Sie den Schreibvorgang, um eine Testsuite zu erstellen.",
    allSuites: "Alle Testsuites",
    listSummary: "{count} Testsuites · sortiert nach {sort}",
    searchSuites: "Testsuites durchsuchen",
    searchPlaceholder: "Name oder ID suchen",
    projectFilterAria: "Testsuites nach Projekt filtern",
    caseCountSource: "{count} Fragen · {source}",
    defaultProject: "Standardprojekt",
    temporarySuite: "Temporäre Testsuite",
    updatedAt: "Aktualisiert: {time}",
    noMatchingSuites: "Keine passenden Testsuites.",
    loadingCases: "Fragen werden geladen",
    detailErrorTitle: "Testsuite-Details konnten nicht geladen werden",
    suiteName: "Testsuite-Name",
    suiteNameRequired: "Der Testsuite-Name darf nicht leer sein",
    suiteType: "Testsuite-Typ",
    owningProject: "Zugehöriges Projekt",
    projectImmutable: "Die Projektzugehörigkeit kann nicht direkt geändert werden",
    detailsUnsaved: "Details noch nicht gespeichert",
    sourceLabel: "Quelle",
    cases: "Fragen",
    caseCount: "{count}",
    saveDetails: "Details speichern",
    createRun: "Durchlauf erstellen",
    editDetails: "Details bearbeiten",
    moreActions: "Weitere Aktionen",
    copySuiteId: "Testsuite-ID kopieren",
    deleteSuite: "Testsuite löschen",
    pinnedTitle: "Diese Testsuite verwendet die bei ihrer Erstellung ausgewählten Fragenversionen.",
    legacyTitle: "Frageninhalte älterer Testsuites sind schreibgeschützt.",
    staleHint: "Für {count} Fragen gibt es neuere Versionen im Katalog; bei Übernahme der aktuellen Versionen wird eine neue Testsuite erstellt, statt diese unbemerkt umzuschreiben.",
    pinnedHint: "Um Inhalte zu ändern, erstellen Sie im Fragenkatalog des Projekts eine neue Version und anschließend eine Testsuite, die diese verwendet.",
    legacyHint: "Um Fragenversionen und historische Evaluierungen reproduzierbar zu halten, importieren oder migrieren Sie die Inhalte in den Fragenkatalog des zugehörigen Projekts und erstellen Sie die Testsuite neu.",
    rebuildWithCurrent: "Mit aktuellen Versionen neu erstellen",
    goToBank: "Zum Projektkatalog",
    migrateToBank: "In Projektkatalog migrieren",
    caseSearchPlaceholder: "Fragen-ID oder Frage suchen",
    statusFilterAria: "Statusfilter",
    refreshingCases: "Fragen werden aktualisiert",
    caseSummary: "{shown} / {total} angezeigt · ausführbar {runnable} · übersprungen {skipped}",
    caseSummaryStale: " · neuere Version {count}",
    caseSummarySort: " · Sortierung: ursprüngliche Fragenreihenfolge in der Testsuite",
    notPinned: "Keine Version erfasst",
    upgradableSuffix: " · neuere Version verfügbar",
    pinnedSuffix: " · verwendet",
    viewQuestion: "Frage anzeigen",
    readOnlyCase: "Schreibgeschützte ältere Frage",
    noMatchingCases: "Keine passenden Fragen",
    noCases: "Diese Testsuite enthält noch keine Fragen",
    caseDetailTitle: "{id} · Fragendetails",
    caseDetailPosition: "{index} / {total} im aktuellen Filter",
    previousCase: "Zurück",
    nextCase: "Weiter",
    caseDetailMeta: "Verwendete Version: {version} · Status: {status}",
    source: {
      questionBank: "Aus Projektkatalog erstellt",
      excel: "Excel-Import",
      pinned: "Version aus dem Projektkatalog",
      manual: "Manuell gepflegt",
    },
    caseStatus: {
      runnable: "Ausführbar",
      questionDisabled: "Frage deaktiviert",
      questionArchived: "Frage archiviert",
      caseDisabled: "Frage deaktiviert",
      skipped: "Übersprungen",
    },
    column: {
      pinnedVersion: "Verwendete Version",
      question: "Frage",
      gtAnswer: "Referenzantwort",
    },
    confirm: {
      leaveTitle: "Nicht gespeicherte Änderungen verwerfen?",
      leaveDescription: "Die Testsuite enthält nicht gespeicherte Änderungen, die beim Verlassen verloren gehen.",
      leaveConfirm: "Verwerfen und verlassen",
      upgradeTitle: "Testsuite mit den aktuellen Katalogversionen neu erstellen?",
      upgradeDescription: "Aus „{name}“ wird eine neue Testsuite mit den aktuellen Katalogversionen von {count} Fragen erstellt. Die ursprüngliche Testsuite behält ihre bisherigen Versionen.",
      upgradeConfirm: "Neuerstellung bestätigen",
      rebuilding: "Wird neu erstellt…",
      deleteRunsTitle: "Historische Durchläufe ebenfalls löschen?",
      deleteRunsDescription: "„{name}“ hat {count}historische Durchlaufdatensätze. Wenn Sie fortfahren, werden diese Durchläufe und ihre Berichte unwiderruflich gelöscht.",
      deleteRunsConfirm: "Testsuite und Durchläufe löschen",
      runCount: "{count} ",
      deleteTitle: "Diese Testsuite löschen?",
      deleteDescription: "Beim Löschen von „{name}“ werden die Testsuite und ihre Fragen entfernt. Dies kann nicht rückgängig gemacht werden.",
    },
  },
  profiles: {
    pageTitle: "{name} · Evaluierung",
    pageDescription: "Konfigurieren Sie pro Projekt Evaluierungsframework, Modellzugangsdaten, Bewertungsregeln, Laufzeitstandards und empfohlene Prompts.",
    unsavedGuard: "Das Evaluierungsprofil enthält nicht gespeicherte Änderungen, die beim Verlassen verloren gehen.",
    noModel: "Kein Modell konfiguriert",
    baseConfigured: "Basis-URL konfiguriert",
    baseMissing: "Basis-URL fehlt",
    keyConfigured: "API-Schlüssel konfiguriert",
    keyMissing: "API-Schlüssel fehlt",
    promptNamed: "Prompt {name}",
    promptSpecified: "Prompt festgelegt",
    promptDefault: "Standard-Prompt",
    defaultRepeat: "Standardwiederholung {count}",
    createdToast: "Evaluierungsprofil „{name}“ erstellt",
    updatedToast: "Evaluierungsprofil auf v{version} aktualisiert",
    deletedToast: "Evaluierungsprofil gelöscht",
    disabledInsteadToast: "Das Profil wird referenziert und wurde daher stattdessen deaktiviert",
    noChangeToast: "Keine Änderungen; keine neue Version erstellt",
    blockDeleteReason: "„{name}“ ist das Standard-Evaluierungsprofil des Projekts. Wählen Sie ein anderes Profil oder entfernen Sie zuerst den Standard unter „Standard-Evaluierung“ und löschen Sie es anschließend.",
    blockDeleteTitle: "Das Standardprofil des Projekts kann nicht gelöscht werden",
    gotIt: "Verstanden",
    goChangeDefault: "Standard ändern",
    loadingProjectDescription: "Evaluierungsprofile werden abgerufen.",
    managePrompts: "Prompt-Bibliothek verwalten",
    refreshedToast: "Evaluierungsprofile aktualisiert",
    create: "Neues Profil",
    createFirst: "Erstes Profil erstellen",
    promptsUnavailable: "Die Prompt-Bibliothek des Projekts ist nicht verfügbar: {message}. Sie können dennoch ein Profil mit dem Systemstandard-Prompt erstellen.",
    loadingTitle: "Evaluierungsprofile werden geladen",
    loadingDescription: "Die Evaluierungsprofile dieses Projekts werden gelesen.",
    errorTitle: "Evaluierungsprofile sind nicht verfügbar",
    emptyTitle: "Noch kein Evaluierungsprofil",
    emptyReadOnly: "In schreibgeschützten Projekten können keine Profile hinzugefügt werden.",
    emptyDescription: "Nach der Erstellung kann das Profil für neue Durchläufe und Projekteinstellungen verwendet werden.",
    tableLabel: "Evaluierungsprofile",
    projectDefault: "Projektstandard",
    readOnlyShared: "Geteilt, schreibgeschützt",
    createTitle: "Neues Evaluierungsprofil",
    editTitle: "Evaluierungsprofil bearbeiten",
    createDescription: "Füllen Sie das Evaluierungsgerüst Abschnitt für Abschnitt aus; empfohlene Prompts stammen aus der Prompt-Bibliothek dieses Projekts.",
    editDescription: "„{name}“ wird bearbeitet. Speichern mit Änderungen erstellt v{version}; ohne Änderungen bleibt die Version unverändert. Snapshots historischer Durchläufe sind nicht betroffen.",
    saveAndBump: "Speichern und auf v{version} erhöhen",
    discardTitle: "Nicht gespeicherte Änderungen am Evaluierungsprofil verwerfen?",
    discardDescription: "Beim Schließen des Editors werden das eingegebene Modell, der Schlüssel, die Bewertungsregeln und Laufzeitstandards verworfen. Gespeicherte Versionen bleiben unverändert.",
    versionConfirmTitle: "Evaluierungsprofil v{version} erstellen?",
    versionConfirmDescription: "Nach dem Speichern verwenden neue Durchläufe die Standards der neuen Version; Snapshots historischer Durchläufe werden nicht umgeschrieben.",
    backToEdit: "Zurück zur Bearbeitung",
    confirmBump: "Erhöhung auf v{version} bestätigen",
    deleteTitle: "Evaluierungsprofil „{name}“ löschen?",
    deleteTitleFallback: "Evaluierungsprofil löschen?",
    deleteDescription: "Wenn Durchläufe darauf verweisen, wird es deaktiviert statt physisch gelöscht. Das Standardprofil des Projekts kann nicht direkt gelöscht werden.",
    deleteDetails: "Aktuelle Version v{version}. Stellen Sie vor dem Löschen sicher, dass kein Durchlaufpfad von diesem Profil abhängt.",
    namePlaceholder: "Standard-Judge-Profil",
    evaluatorKind: "Evaluierungsframework",
    judgeBaseUrl: "Basis-URL des Judge-Modells",
    judgeBaseUrlHelp: "API-Basis-URL für Judge-Aufrufe, zum Beispiel ein OpenAI-kompatibles Gateway.",
    judgeModel: "Judge-Modell",
    judgeModelPlaceholder: "Modell-ID",
    judgeApiKey: "API-Schlüssel des Judge-Modells",
    judgeApiKeyPlaceholder: "Kann nach dem Speichern nicht erneut angezeigt werden",
    judgeApiKeyHelp: "Zum Beibehalten des gespeicherten Schlüssels leer lassen.",
    scoringRule: "Bewertungsregel",
    scoringRuleSingleTurn: "Bewertung von Frage und Antwort mit einer Runde",
    passThreshold: "Bestehensschwelle (0–100)",
    passThresholdHelp: "Ein einzelner Wert ≥ der Schwelle gilt als bestanden. 60 bedeutet beispielsweise, dass zum Bestehen 60 Punkte erforderlich sind.",
    maxScore: "Höchstpunktzahl",
    maxScoreHelp: "Obergrenze der Bewertungsskala, üblicherweise 100.",
    consistencyThreshold: "Konsistenzschwelle (%)",
    consistencyThresholdHelp: "Untergrenze der Übereinstimmungsquote der Bewertungen über Wiederholungen hinweg; 100 erfordert vollständige Übereinstimmung.",
    agentConcurrency: "AI Engineer-Parallelität",
    agentConcurrencyHelp: "Anzahl gleichzeitiger Anfragen an den Ziel-AI Engineer, 1–50. Höhere Werte beschleunigen Stapel, erreichen aber früher Ratenbegrenzungen.",
    agentRetry: "AI Engineer-Wiederholungsversuche",
    agentRetryHelp: "Zusätzliche Versuche nach dem Fehlschlagen einer Frage, 0–10. 0 bedeutet keinen weiteren Versuch; die Frage wird als fehlgeschlagen markiert.",
    judgeConcurrency: "Judge-Parallelität",
    judgeConcurrencyHelp: "Anzahl gleichzeitiger Aufrufe des Judge-Modells, 1–100. Höhere Werte verbrauchen Kontingent und Kosten schneller.",
    judgeRetry: "Judge-Wiederholungsversuche",
    judgeRetryHelp: "Zusätzliche Versuche nach einem fehlgeschlagenen Judge-Aufruf, 0–10. Jeder Versuch verbraucht einen weiteren Modellaufruf.",
    repeatRuns: "Standardanzahl der Wiederholungen",
    repeatRunsHelp: "Wie oft jede Frage ausgeführt wird (N).",
    repeatMode: "Ausführungsmodus für Wiederholungen",
    repeatModeParallel: "Parallel (empfohlen)",
    repeatModeSequential: "Sequenziell",
    repeatConcurrency: "Wiederholungsparallelität je Frage",
    repeatConcurrencyHelp: "Wie viele der N Wiederholungen einer Frage gleichzeitig ausgeführt werden. Effektive Parallelität ≤ min(Wiederholungsanzahl, dieser Wert).",
    projectPrompt: "Projekt-Prompt",
    promptUnset: "Nicht festgelegt; zur Laufzeit den Systemstandard verwenden",
    promptsLoading: "Prompt-Bibliothek des Projekts wird geladen…",
    promptsHelp: "Die Liste stammt aus der Prompt-Bibliothek dieses Projekts. Pflegen Sie sie auf der Seite „Prompts“ und prüfen Sie, welche Profile auf die einzelnen Prompts verweisen.",
    evaluator: {
      toolCall: "Tool-Aufruf",
      llmJudgeCurrent: "LLM Judge (aktuell)",
      ragasPlanned: "RAGAS (geplant)",
      toolCallPlanned: "Korrektheit des Tool-Aufrufs (geplant)",
      plannedHint: "Geplant; noch nicht für Durchläufe nutzbar",
      help: "Geplante Frameworks können nicht ausgewählt werden; ihre Auswahl würde die Vorprüfung des Durchlaufs scheitern lassen.",
    },
    section: {
      basic: "Grundlagen + Evaluierungsframework",
      basicHint: "Das Profil definiert die Evaluierungsmethode; das derzeit produktionsreife Framework ist LLM Judge.",
      model: "Modell und Zugangsdaten (LLM Judge)",
      modelHint: "Nur für Aufrufe des Judge-Modells verwendet; der Schlüssel wird nach dem Speichern nie erneut angezeigt.",
      scoring: "Bewertungsregeln",
      scoringHint: "Legt fest, wann ein Einzelergebnis besteht und wie stabil wiederholte Durchläufe sein müssen.",
      runtime: "Laufzeitstandards",
      runtimeHint: "Die Seite für neue Durchläufe übernimmt diese Standards; hohe Parallelität und viele Wiederholungsversuche erhöhen den Druck auf externe Aufrufe.",
      prompt: "Empfohlener Standard-Prompt",
      promptHint: "Nur von LLM Judge verwendet; neue Durchläufe können weiterhin vorübergehend einen Prompt wählen oder bearbeiten, ohne ihn hier zurückzuschreiben.",
    },
    diff: {
      name: "Name: {before} → {after}",
      model: "Modell: {before} → {after}",
      apiKey: "Schlüssel des Judge-Modells: wird aktualisiert",
      passThreshold: "Bestehensschwelle: {before} → {after}",
      consistency: "Konsistenzschwelle: {before} → {after}",
      repeatRuns: "Standardanzahl der Wiederholungen: {before} → {after}",
      repeatConcurrency: "Wiederholungsparallelität je Frage: {before} → {after}",
      generic: "Feldänderungen erkannt (Basis-URL, Prompt oder Laufzeitstandards)",
    },
    column: {
      kind: "Framework",
      version: "Version",
      summary: "Zusammenfassung",
    },
  },
  runDetailPage: {
    singleReport: {
      modularTitle: "Modularer Bericht", modularHint: "Fünf Module werden unabhängig berechnet; nicht verfügbare Daten erscheinen als -.", viewAria: "Berichtsansichten", single: "Einzelbericht", history: "Datensatzverlauf", compare: "Berichtsvergleich",
      questionRepeat: "{questions} Fragen · je {repeats} Wiederholungen", snapshotTitle: "Versionen und Prompt dieses Durchlaufs", snapshotHint: "Der Bericht bewahrt den Laufzeitsnapshot der bewerteten Plattform und wird durch aktuelle Konfigurationsänderungen nicht umgeschrieben.", frozen: "Laufzeitsnapshot", agentVersion: "AI Engineer-Version", platformVersion: "Plattformversion", promptVersion: "Prompt-Version der bewerteten Plattform", repeatCount: "Wiederholungen", snapshotValue: "Zur Laufzeit erfasst", unrecorded: "Für diesen Durchlauf nicht erfasst", repeatUnit: "Mal / Frage", runPrompt: "Prompt-Snapshot der bewerteten Plattform", currentPrompt: "Aktueller Prompt der bewerteten Plattform", notInSnapshot: "Kein Laufzeitsnapshot", currentPromptHint: "Der aktuelle Prompt der bewerteten Plattform gehört nicht zum Snapshot dieses Durchlaufs; sein Inhalt wird nicht abgeleitet.", targetPromptVersionHint: "Vom Bewertungsziel zur Laufzeit erfasst", targetPromptMissingHint: "Dieser Durchlauf speicherte die Prompt-Version der bewerteten Plattform, aber nicht den Prompt-Inhalt.",
      moduleAria: "Berichtskennzahlen und Laufversionen", modulePickerTitle: "Kernkennzahlen", modulePickerHint: "Eine Kennzahl öffnet das zugehörige Analysemodul. Die Antwortqualität steht zuerst.", versions: "Versionen dieses Durchlaufs", versionsHint: "Zeigt Testsuite, Umgebung, AI Engineer, Plattform, Prompt und Wiederholungskonfiguration dieses Berichts.", viewDetails: "Details anzeigen", aiEngineer: "Bewerteter AI Engineer", environment: "Laufumgebung", runtimeConfiguration: "Laufkonfiguration", testSuite: "Testsuite", runId: "Lauf-ID", runtimeSnapshotId: "Kennung des Laufzeitsnapshots", questionConfiguration: "Fragenkonfiguration", overview: "Versionen dieses Durchlaufs", overviewHint: "Zeigt nur den Versions- und Konfigurationssnapshot dieses Durchlaufs.", notApplicable: "Nicht anwendbar", platform: "Plattformstabilität", stability: "Antwortstabilität", experience: "Nutzererlebnis", cost: "Kosten", quality: "Antwortqualität", module: { platform: "Rückgaben und gültige Bewertung", stability: "Konsistenz wiederholter Antworten", experience: "Antwortzeit", cost: "Token-Nutzung", quality: "Qualität gültiger Antworten" },
      platformHint: "Bewertet AI-Engineer-Ausführung, Antwortrückgabe und Judge-Bewertung, ohne technische Fehler als Qualitätswerte zu zählen.", failedQuestions: "{count} unvollständige Fragen", successRate: "Fragenabschlussquote", executionErrors: "AI-Engineer-Ausführungsfehler", timeouts: "Zeitüberschreitungen ohne Antwort", judgeValidRate: "Anteil gültiger Judge-Bewertungen", definition: "Definition", platformDefinition: "Regulär abgeschlossene Fragen / Gesamtfragen. Eine reguläre Antwort mit 0 Punkten zählt; ist eine Wiederholung unvollständig, gilt die Frage als unvollständig.", qualityExclusion: "{count} unvollständige Fragen werden vom Qualitätsmittel ausgeschlossen.", failureReasons: "Fehlerursachen", failure: { agentError: "AI-Engineer-Ausführungsfehler", timeout: "Zeitüberschreitung ohne endgültige Antwort", judgeFailure: "Judge-Dienstfehler" },
      stabilityHint: "Vergleicht Schlussfolgerungen und Inhalte wiederholter Durchläufe derselben Frage.", stabilityNotTestedHint: "Jede Frage wurde in diesem Bericht nur einmal beantwortet; es gibt keine wiederholten Antworten zum Vergleich.", stabilityMinimumRepeatHint: "Antwortstabilität erfordert mindestens 2 Antworten je Frage im selben Bericht; für Stabilitätsentscheidungen werden 3 Wiederholungen empfohlen.", notTested: "Nicht getestet", repeatBadge: "{count} Antwort(en) je Frage", overallConsistency: "Gesamtkonsistenz der Antworten", component: { conclusion: "Kernaussage", facts: "Schlüsselfakten", citations: "Quellenangaben", scoreVariance: "Bewertungsschwankung" }, fluctuatingQuestions: "Schwankende Fragen",
      experienceHint: "Trennt erste Reaktion, vollständige Antwort und Tool-Zeit; fehlende Telemetrie wird nicht abgeleitet.", firstResponseP50: "Erste Reaktion P50", firstResponseP95: "Erste Reaktion P95", fullResponseP50: "Vollständige Antwort P50", fullResponseP95: "Vollständige Antwort P95", toolDuration: "Tool-Dauer", answerDuration: "Aus erfasster Antwortdauer", experienceDefinition: "Die vollständige Antwortzeit nutzt nur die erfasste AI Engineer-Antwortzeit und schließt Warteschlange und Judge-Zeit aus.",
      costHint: "Zeigt erfasste oder deterministisch geschätzte Tokens; der Betrag nutzt den im Snapshot hinterlegten festen Schätzpreis.", totalTokens: "Token gesamt", runTotal: "Durchlauf gesamt", avgTokens: "Tokens im Mittel", perCompleteAnswer: "Je vollständiger Antwort", inputShare: "Eingabeanteil", outputShare: "Ausgabeanteil", estimatedCost: "Geschätzte Kosten", estimatedCostNote: "Fester Schätzpreis (USD)", tokenComposition: "Zusammensetzung der Ein- und Ausgabe-Tokens",
      qualityHint: "Jede Frage mittelt ihre nicht leeren Qualitätsdimensionen; der Bericht mittelt die Qualitätswerte aller 39 Fragen.", validQuestions: "{count} gültige Fragen", overallScore: "Mittlere Antwortqualität", completeOnly: "Nicht anwendbare Dimensionen sind ausgeschlossen", dimension: { correctness: "Richtigkeit von Schlussfolgerungen, Fakten und Berechnungen", depth: "Informationsvollständigkeit und Tiefe", conditions: "Bedingungen, Annahmen und Ausnahmen", scope: "Parteien, Rollen und Schnittstellenumfang", actionability: "Umsetzbarkeit und Risikohinweise", evidence: "Quellen, Belege und Nachvollziehbarkeit", synthesis: "Dokumentübergreifende Synthese und Konflikte" }, scoringGate: "Bewertungsmethode", scoringGateHint: "Je Frage werden nur nicht leere Dimensionen gemittelt. Nicht anwendbare Dimensionen erscheinen als - und zählen nicht im Nenner; Plattformfehler und unvollständige Antworten werden nicht automatisch als null bewertet.", viewRelatedResults: "Zugehörige Testergebnisse anzeigen", platformDrilldownHint: "Unvollständige Ergebnisse öffnen, um fehlgeschlagene Antworten und Laufzeitnachweise zu prüfen.", stabilityDrilldownHint: "Schwankende Fragen öffnen, um alle vollständigen Antworten zu vergleichen.", experienceDrilldownHint: "Die Dauer vollständiger Antworten je Frage in den Testergebnissen prüfen.", costDrilldownHint: "Die erfassten Token je Frage in den Testergebnissen prüfen.", qualityDrilldownHint: "Fragen unterhalb des Grenzwerts öffnen, um Standardantwort, Antwort und Judge-Fazit zu prüfen.", repeatAnswersCount: "{count} wiederholte Antworten", table: { consistency: "Konsistenzwert", responseTime: "Erste / vollständige Antwort", tokens: "Tokens", qualityScore: "Fragequalität", judgeConclusion: "Judge-Fazit", returned: "Zurückgegeben", stable: "Stabil", attention: "Zu prüfen", noIssues: "-" },
    },
    agentContextTitle: "AI Engineer-Kontext",
    agentContextContract: "Aktuelle Route: {route}",
    agentContextLegacy: "Historische Kontext-ID: {id}",
    agentContextSection: "Seitenabschnitt: {section}",
    notFound: "Der Durchlaufdatensatz ist nicht vorhanden oder wurde gelöscht",
    loadFailed: "Durchlaufdetails konnten nicht geladen werden",
    missingRunId: "Durchlauf-ID fehlt",
    backTo: "Zurück zu {target}",
    backToArrow: "← Zurück zu {target}",
    loadingReport: "Berichtsdetails werden geladen",
    loadingRun: "Durchlaufdetails werden geladen",
    openReportFailed: "Berichtsdetails können nicht geöffnet werden",
    openRunFailed: "Durchlaufdetails können nicht geöffnet werden",
    errorHint: "{message}. Versuchen Sie es erneut oder kehren Sie zu {target} zurück.",
    retryCreated: "Wiederholungsdurchlauf erstellt: {id}",
    retryFailed: "Erneuter Durchlauf fehlgeschlagen: {message}",
    agentRetryQueued: "AI Engineer-Sitzungen zur Wiederholung eingereiht",
    judgeRetryQueued: "Judge-Evaluierung zur Wiederholung eingereiht",
    stageRetryFailed: "Phasenwiederholung fehlgeschlagen: {message}",
    caseRetryStarted: "Technische Wiederholung für Frage {caseId}, Durchlauf {index}, gestartet",
    caseRetryFailed: "Fragenwiederholung fehlgeschlagen: {message}",
    downloadStarted: "{kind}-Download gestartet",
    downloadFailed: "Download fehlgeschlagen: {message}",
    downloadDisabledHint: "Der Durchlauf ist noch nicht abgeschlossen. Daher kann noch nichts heruntergeladen werden",
    downloading: "Wird heruntergeladen",
    downloadJson: "JSON herunterladen",
    downloadExcel: "Excel herunterladen",
    viewFailures: "Fehlgeschlagene Fragen anzeigen ({turns} Runden / {cases} Fragen)",
    viewLogs: "Protokolle anzeigen",
    openEvaluationResult: "Testergebnisse anzeigen",
    openEvaluationReport: "Testbericht anzeigen",
    checkEnvSettings: "Umgebungseinstellungen prüfen",
    creating: "Wird erstellt",
    rerun: "Erneut ausführen",
    reportDetail: "Details des Testberichts",
    runResult: "Durchlaufergebnisse",
    taskDetail: "Details der Testaufgabe",
    resultDetail: "Details des Testergebnisses",
    repeatBadge: "{count} Wiederholungen",
    needsAttention: "Handlungsbedarf",
    runIdLabel: "Durchlauf-ID: {id}",
    viewTechnicalInfo: "Technische Details anzeigen",
    archivedIncompleteTitle: "Archiviert, aber mit unvollständigen Ergebnissen",
    archivedIncompleteBody: "Unvollständige Ergebnisse werden von Durchschnittspunktzahl und Bestehensquote ausgeschlossen und als — angezeigt; nur diese Ergebnisse können technisch wiederholt werden.",
    caseRetryRunningTitle: "Unvollständige Ergebnisse werden wiederholt",
    caseRetryRunningBody: "Nach Abschluss der Wiederholung werden die wirksamen Ergebnisse, aggregierten Bewertungen und Download-Dateien dieses Durchlaufs automatisch aktualisiert; die ursprünglichen Fehlerdatensätze bleiben erhalten.",
    reportConclusion: "Berichtsfazit",
    resultSummary: "Ergebnisübersicht",
    resultAttentionHint: "Einige Ergebnisse liegen unter dem Grenzwert, sind unvollständig oder inkonsistent. Mit den Kennzahlen unten können Sie sie schnell filtern.",
    resultHealthyHint: "Derzeit besteht bei keinem Ergebnis Handlungsbedarf. Sie können dennoch jede Antwort und ihre Bewertungsnachweise prüfen.",
    attentionHint: "Bearbeiten Sie zuerst fehlgeschlagene, unvollständige und inkonsistente Ergebnisse. Entscheiden Sie anschließend, ob Fragen oder AI Engineer geändert oder der Durchlauf wiederholt werden soll.",
    noAttentionHint: "Derzeit besteht kein Handlungsbedarf; Sie können dennoch die Fragenwarteschlange öffnen, um Antworten zu prüfen.",
    viewCaseQueue: "Fragenwarteschlange anzeigen",
    clickSkipped: "Klicken, um übersprungene Fragen anzuzeigen",
    clickDrilldown: "Klicken, um Fragen aufzuschlüsseln",
    runProgress: "Durchlauffortschritt",
    stageLabel: "Phase: {stage}",
    elapsed: "Vergangen: {duration}",
    stepsDone: "{done} / {total} Ausführungsschritte abgeschlossen",
    currentCase: " · aktuelle Frage {caseId}",
    notStartedTitle: "Der Durchlauf wurde noch nicht gestartet",
    notStartedBody: "Die Konfigurationsvorprüfung ist fehlgeschlagen. Daher hat keiner der geplanten {total} Ausführungsschritte den AI Engineer oder Judge aufgerufen. Korrigieren Sie die Umgebungseinstellungen und erstellen Sie den Durchlauf erneut.",
    noResultTitle: "Noch kein Testergebnis",
    noResultBody: "Die Aufgabe hat die Vorprüfung nicht bestanden. Daher liegen keine Fragenergebnisse zur Analyse vor. Kehren Sie zur Testaufgabe zurück, korrigieren Sie die Konfiguration und führen Sie sie erneut aus.",
    resultMetrics: "Kennzahlen des Testergebnisses",
    reportMetrics: "Berichtskennzahlen",
    runMetrics: "Durchlaufkennzahlen",
    reportViews: "Berichtsdetailansichten",
    runViews: "Durchlaufdetailansichten",
    sourceLinks: "Quellen und Links",
    runInfo: "Durchlaufinformationen",
    taskExecutionInfo: "Laufkonfiguration",
    taskExecutionHint: "Zeigt Bewertungsziel, Fragenumfang, Ausführungssnapshot und Bewertungskonfiguration dieser Aufgabe.",
    taskConfigTarget: "Bewertungsziel",
    taskConfigExecution: "Ausführungssnapshot",
    taskConfigEvaluation: "Bewertungskonfiguration",
    taskCompletedTitle: "Testaufgabe abgeschlossen",
    taskCompletedHint: "Die Ausführungsüberwachung ist beendet. Prüfen Sie nun die Ergebnisse je Frage oder die aggregierte Analyse.",
    viewSkipped: "Die {count} übersprungenen Fragen anzeigen",
    sourceDeepLinks: "Direktlinks zu Berichtsquellen",
    openSuite: "Testsuite öffnen",
    openBank: "Fragenkatalog öffnen",
    openRun: "Ursprünglichen Durchlauf anzeigen",
    openAttentionQueue: "Warteschlange mit auffälligen Fragen öffnen",
    judgePromptBody: "Text des Judge-Prompts",
    judgePromptTitle: "Verwendeter Judge-Prompt",
    promptBody: "Prompt-Text",
    viewPromptBody: "Prompt-Text anzeigen",
    opsSecondary: "Betriebsaktionen (sekundär)",
    stageRetry: "Phase wiederholen",
    multiTurnRetryTitle: "Durchläufe mit mehreren Runden müssen vollständig wiederholt werden",
    multiTurnRetryBody: "Damit der vollständige Konversationszustand in einer Sitzung erhalten bleibt, können AI Engineer und Judge nicht getrennt wiederholt werden. Verwenden Sie oben auf der Seite „Erneut ausführen“ oder wiederholen Sie die gesamte Frage aus der Ergebnistabelle.",
    retryAgent: "AI Engineer-Sitzungen wiederholen",
    retryJudge: "Judge-Evaluierung wiederholen",
    skippedTitle: "In diesem Durchlauf übersprungene Fragen",
    skippedDescription: "Die Ausführungsliste wurde bei Erstellung des Durchlaufs eingefroren; {count} Fragen wurden nicht ausgeführt und erscheinen daher nicht in der Fragenwarteschlange.",
    skippedCloseLabel: "Liste der übersprungenen Fragen schließen",
    skippedNoDetail: "Dieser Snapshot enthält keine Überspringungsdetails pro Element; die Anzahl finden Sie in der Übersicht.",
    confirmRetry: "Wiederholung bestätigen",
    validation: {
      judgeTitle: "Der Judge-Dienst ist nicht verfügbar",
      judgeDescription: "Prüfen Sie Judge-Basis-URL, Modell und Zugangsdaten der aktuellen Umgebung. Erstellen Sie den Durchlauf nach erfolgreicher Prüfung erneut.",
      agentTitle: "AI Engineer-Verbindungsprüfung fehlgeschlagen",
      agentDescription: "Prüfen Sie AI Engineer-URL, Anmeldedaten und Mandantenkonfiguration der aktuellen Umgebung. Erstellen Sie den Durchlauf nach erfolgreicher Verbindung erneut.",
      genericTitle: "Konfigurationsvorprüfung fehlgeschlagen",
      genericDescription: "Prüfen Sie die aktuelle Umgebungskonfiguration und erstellen Sie den Durchlauf nach erfolgreicher Prüfung erneut.",
    },
    confirm: {
      fullTitle: "Diesen Durchlauf erneut ausführen?",
      fullDescription: "Aus der aktuellen Testsuite wird ein vollständiger Durchlauf mit {count} Wiederholungen neu erstellt. Dies kann neue Modellaufrufe auslösen.",
      agentTitle: "AI Engineer-Sitzungen wiederholen?",
      judgeTitle: "Judge-Evaluierung wiederholen?",
      stageDescription: "Durchlauf: {name}. Die aktuelle Phase wird erneut aufgerufen und kann neue Modellaufrufe auslösen.",
      caseTitle: "Frage „{caseId}“, Durchlauf {index}, wiederholen?",
      caseDescription: "Dieses unvollständige Ergebnis wird innerhalb des aktuellen Durchlaufs repariert und die Zusammenfassung neu berechnet; der ursprüngliche Fehlerdatensatz bleibt archiviert.",
    },
    tab: {
      conclusion: "Fazit",
      overview: "Übersicht",
      caseQueue: "Fragenwarteschlange",
      results: "Ergebnisdetails",
    },
    metric: {
      avgScore: "Durchschnittliche Fragenbewertung",
      scoreValue: "{score} Pkt.",
      avgScoreHint: "Berücksichtigt nur vollständige Fragenausführungen; unvollständige Ergebnisse sind vom Durchschnitt ausgeschlossen",
      passRate: "Bestehensquote",
      passThreshold: "Bestehensschwelle {threshold} Pkt.",
      failedCases: "Aggregierte fehlgeschlagene Fragen",
      failedCasesHint: "Insgesamt {count} Fragen · zum Filtern klicken",
      completionRate: "Fragenabschlussquote",
      completionHint: "{done} / {total} Fragen regulär abgeschlossen · unvollständige filtern",
      consistency: "Konsistenz",
      consistencyHint: "Mittelwert der Konsistenzwerte je Frage · zum Filtern klicken",
    },
    fact: {
      envAgent: "Umgebung / AI Engineer",
      environment: "Umgebung",
      aiEngineer: "AI Engineer",
      agentContext: "AI Engineer-Kontext",
      noAgentContext: "Kein zusätzlicher Kontext",
      elapsedActive: "Vergangene Durchlaufzeit",
      elapsedDone: "Gesamte Durchlaufzeit",
      elapsedActiveHint: "Vom Durchlaufstart bis jetzt; wird während der Ausführung weitergezählt",
      elapsedDoneHint: "Vom Durchlaufstart bis zum Abschluss der Ergebnisse",
      completedQuestions: "Abgeschlossene Fragen",
      completedQuestionsHint: "Eine reguläre Antwort mit 0 Punkten zählt; nur unvollständige Ausführungen werden abgezogen",
      repeatCount: "Wiederholungskonfiguration",
      repeatCountValue: "{count}-mal pro Frage",
      repeatCountHint: "Bei Erstellung der Aufgabe eingefroren",
      currentStage: "Aktuelle Phase",
      currentStageHint: "Aus dem Ausführungsstatus der Aufgabe; fehlende Phasen werden nicht abgeleitet",
      agentTotal: "Gesamte AI Engineer-Ausführungszeit",
      agentSamples: "Über {count} gültige Ausführungen summiert",
      agentAvg: "Durchschnittliche AI Engineer-Ausführungszeit",
      agentAvgHint: "Über gültige Ausführungen berechnet",
      tokenUsage: "Token-Nutzung",
      noRecord: "Kein Datensatz",
      tokens: "{value} Token",
      tokenMissingHint: "Dieser Durchlauf hat keine Modellnutzung gemeldet; das Backend muss sie in der Durchlaufzusammenfassung erfassen",
      tokenSplit: "Eingabe {prompt} · Ausgabe {completion}",
      tokenCombined: "Judge- und AI Engineer-Aufrufe kombiniert",
      estimatedCost: "Geschätzte Kosten",
      costMissingHint: "Das Backend hat keine Kostenschätzung gemeldet",
      costHint: "Anhand der Modellstückpreise geschätzt, nur als Referenz",
      runnableQuestions: "Enthaltene Fragen",
      runnableCount: "{runnable} / {total}",
      frozenHint: "Bei Erstellung des Durchlaufs eingefroren; spätere Änderungen am Fragenkatalog gelten nicht",
      skippedByQuestion: "Übersprungen: Frage deaktiviert",
      archivedExtra: "{count} weitere Fragen sind archiviert",
      questionDisabled: "Frage deaktiviert",
      skippedBySuite: "Übersprungen: Testsuite-Frage deaktiviert",
      suiteItemDisabled: "Die Testsuite-Frage war bereits bei Erstellung des Durchlaufs deaktiviert",
      judgePrompt: "Judge-Prompt",
    },
    dimension: {
      title: "Genauigkeit nach Kategorie",
      description: "Bestehensquote ausgeführter Runden, gruppiert nach primärer Fragenkategorie und zusammen mit der Fragenanzahl angezeigt, um irreführende Prozentwerte bei kleinen Stichproben zu vermeiden.",
      count: "{count} Kategorien",
      empty: "Diese Testsuite enthält keine Tags für primäre Kategorien",
      emptyHint: "Kennzeichnen Sie Fragen im Katalog mit Typen wie Datenabfrage, Wissensabfrage oder gemischte Szenarien; spätere Durchläufe erzeugen dann automatisch Kategoriemetriken.",
      questions: "Fragen",
      passed: "Bestanden",
      failed: "Fehlgeschlagen",
      avgScore: "Durchschnittspunktzahl",
    },
    issues: {
      title: "AI Engineer-Problemsignale",
      caseCount: "{count} Fragen",
      pendingReview: "Prüfung ausstehend",
      empty: "Kein AI Engineer-Problem ist direkt mit Benutzerfragen verknüpft.",
    },
    skipped: {
      index: "#",
      reason: "Grund für das Überspringen",
      question: "Frage",
    },
  },
  results: {
    title: "Testergebnisse",
    description: "Antworten je Frage, Vollständigkeit, Bewertungen und Erfolgsquoten prüfen. Interpretierte Erkenntnisse stehen unter Berichte.",
    total: "{count} Ergebnisse",
    searchAria: "Testergebnisse durchsuchen",
    searchPlaceholder: "Aufgabe, ID, AI Engineer oder Testsuite suchen",
    filterSummary: "{count} gefilterte Ergebnisse",
    completenessFilterAria: "Nach Ergebnisvollständigkeit filtern",
    allCompleteness: "Alle Vollständigkeitsstufen",
    complete: "Vollständige Ergebnisse",
    incomplete: "Unvollständige Ergebnisse",
    suiteFilterAria: "Testergebnisse nach Testsuite filtern",
    agentFilterAria: "Testergebnisse nach AI Engineer filtern",
    loadingTitle: "Testergebnisse werden geladen",
    loadingDescription: "Aufgaben mit bereits erzeugten Ergebnissen werden gelesen.",
    errorTitle: "Testergebnisse konnten nicht geladen werden",
    errorDescription: "Die Ergebnisse sind vorübergehend nicht verfügbar. Bitte erneut versuchen.",
    noMatchTitle: "Keine passenden Testergebnisse",
    noMatchDescription: "Passen Sie die Suchbegriffe an.",
    emptyTitle: "Noch keine Testergebnisse",
    emptyDescription: "Erstellen und starten Sie eine Testaufgabe, damit Ergebnisse hier erscheinen.",
    tableLabel: "Testergebnisse des Projekts",
    column: { task: "Testaufgabe", status: "Status", score: "Durchschnitt", passRate: "Erfolgsquote", questions: "Fragen / Wiederholungen", finished: "Abgeschlossen" },
    questionCount: "{count} / {repeats}",
    viewResult: "Ergebnis anzeigen",
  },
  reports: {
    title: "Alle Testberichte",
    projectTitle: "Testberichte",
    description: "Globaler Sucheinstieg. Für die tägliche Prüfung ist die Berichtsseite innerhalb eines Projekts vorzuziehen; diese Seite dient projektübergreifenden Abfragen.",
    projectDescription: "Bewerten Sie die Evaluierungsqualität, finden Sie problematische Fragen und entscheiden Sie, ob Fragen überarbeitet oder Durchläufe wiederholt werden sollen.",
    dataUnavailable: "Berichtsdaten sind nicht verfügbar",
    total: "Insgesamt {count} Berichte",
    goToProjects: "Zu den Projekten",
    exportFiltered: "Aktuellen Filter exportieren",
    exportEmpty: "Der aktuelle Filter enthält keinen Bericht zum Exportieren",
    exported: "{count} Berichte aus dem aktuellen Filter exportiert",
    viewReport: "Bericht anzeigen",
    closeCompareNotice: "Hinweis zum Vergleichslink schließen",
    compareNotice: "{count} Durchläufe aus dem Link sind nicht mehr vorhanden oder haben noch keinen nutzbaren Bericht und wurden aus dem Vergleich entfernt.",
    searchPlaceholder: "Berichtsname oder Durchlauf-ID suchen",
    searchAria: "Berichte durchsuchen",
    projectFilterAria: "Berichte nach Projekt filtern",
    agentFilterAria: "Nach AI Engineer filtern",
    allAgents: "Alle AI Engineers",
    suiteFilterAria: "Nach Testsuite filtern",
    allSuites: "Alle Testsuites",
    qualityFilterAria: "Nach Qualitätsergebnis filtern",
    allQuality: "Alle Qualitätsergebnisse",
    qualityAttentionOption: "Mit Fehlschlägen, unvollständigen Ergebnissen oder geringer Konsistenz",
    sortAria: "Berichtssortierung",
    filterSummary: "{shown} / {total} Treffer",
    compareGuideAria: "Anleitung zum Berichtsvergleich",
    compareUnavailable: "Vergleich ist nicht verfügbar",
    compareUnavailableHint: "Bisher ist nur 1 Bericht vorhanden. Führen Sie eine weitere Evaluierung zum Vergleichen durch; alternativ können Sie die Details öffnen, um Fragen zu prüfen.",
    runAgain: "Erneut ausführen",
    compareAria: "Berichtsvergleich",
    compareTitle: "Vergleich ({count}/4)",
    compareNeedMore: "Wählen Sie einen weiteren Bericht zum Vergleichen aus; bei weniger als 2 führen Sie zuerst eine weitere Evaluierung durch.",
    compareVerifying: "Snapshots von Fragen, Referenzantworten und Prompts werden geprüft…",
    compareIncomparable: "Nicht direkt vergleichbare Konfigurationen: {fields}",
    compareSnapshotUnknown: "Bei einigen historischen Berichten fehlen Fragen- oder Prompt-Snapshots; mit Vorsicht interpretieren",
    compareComparable: "Fragen, Referenzantworten, Judge-Prompt und zentrale Evaluierungseinstellungen stimmen überein. Die Berichte sind daher direkt vergleichbar",
    compareSummaryOnly: "Es sind mehr als 2 Berichte ausgewählt. Daher wird nur die horizontale Zusammenfassung angezeigt. Wählen Sie genau 2 für ein belastbares Versionsurteil und Fragenänderungen aus.",
    compareAnalyzeFailed: "Die Vergleichsanalyse ist derzeit fehlgeschlagen. Es wird kein Optimierungsurteil erstellt.",
    listSeparator: ", ",
    swapBaseline: "Ausgangslauf und Kandidat tauschen",
    clearSelection: "Auswahl aufheben",
    metricColumn: "Kennzahl",
    envJudge: "Umgebung / Judge",
    turnPassRate: "Bestehensquote der Runden",
    turnPassRateValue: "Bestehensquote der Runden {value}",
    repeatDuration: "Wiederholungen / Dauer",
    repeatTimes: "{count}-mal",
    scoringBasis: "Bewertungsgrundlage",
    passThresholdValue: "Bestehensschwelle {value}",
    maxScoreValue: "Höchstpunktzahl {value}",
    caseImproved: "verbesserte Fragen",
    caseRegressed: "verschlechterte Fragen",
    caseSame: "unveränderte Fragen",
    caseStatusChanged: "Änderungen des Bestehensstatus",
    caseLevelChanges: "Änderungen auf Fragenebene",
    caseLevelHint: "Der erste Bericht ist der Ausgangslauf und der zweite der Kandidat; Verschlechterungen werden standardmäßig zuerst angezeigt.",
    onlyRegressed: "Nur Verschlechterungen",
    allChanges: "Alle Änderungen",
    columnCase: "Frage",
    baseline: "Ausgangslauf",
    candidate: "Kandidat",
    change: "Änderung",
    statusChangedHint: "Bestehensstatus geändert",
    noRegressed: "Keine verschlechterten Fragen.",
    caseReview: "Fragenprüfung",
    caseReviewHint: "Direkter Vergleich der neuesten Antworten",
    judgeConclusion: "Judge-Fazit",
    comparisonVerdictLabel: "Optimierungsurteil",
    scoreDelta: "Änderung der Durchschnittspunktzahl",
    passRateDelta: "Änderung der Bestehensquote",
    stablePassDelta: "Änderung der stabilen Bestehensquote",
    evidenceStrength: "Belegstärke",
    percentagePoint: " Pp.",
    comparisonVerdict: {
      stable_improvement: "Stabile Verbesserung: Durchschnittspunktzahl {score}, Bestehensquote {passRate} Pp.",
      observed_improvement: "Beobachtete Verbesserung: Durchschnittspunktzahl {score}, Bestehensquote {passRate} Pp.",
      no_clear_change: "Keine eindeutige Änderung festgestellt",
      mixed_with_regressions: "Verbesserung insgesamt mit verschlechterten Fragen",
      regressed: "Der Kandidat hat sich verschlechtert; prüfen Sie zuerst die verschlechterten Fragen",
      incomparable: "Diese Durchläufe eignen sich nicht für einen formalen Vergleich",
    },
    comparisonVerdictName: {
      stable_improvement: "Stabile Verbesserung",
      observed_improvement: "Beobachtete Verbesserung",
      no_clear_change: "Keine eindeutige Änderung",
      mixed_with_regressions: "Verbessert mit Verschlechterungen",
      regressed: "Verschlechtert",
      incomparable: "Nicht formal vergleichbar",
    },
    evidence: {
      low: "Niedrig",
      medium: "Mittel",
      high: "Hoch",
    },
    comparisonDifference: {
      different_project: "unterschiedliche Projekte",
      different_logical_agent: "unterschiedliche logische AI Engineers",
      different_suite: "unterschiedliche Testsuites",
      different_suite_snapshot: "unterschiedliche Fragen- oder Referenzantwort-Snapshots",
      different_judge_model: "unterschiedliche Judge-Modelle",
      different_judge_prompt: "unterschiedliche Judge-Prompts",
      different_evaluation_profile: "unterschiedliche Snapshots des Evaluierungsprofils",
      different_pass_threshold: "unterschiedliche Bestehensschwellen",
      different_max_score: "unterschiedliche Höchstpunktzahlen",
      different_scoring_rule: "unterschiedliche Bewertungsregeln",
      different_stage_code: "unterschiedliche Umgebungen",
      different_target_id: "unterschiedliche Durchlaufziele",
      different_repeat_runs: "unterschiedliche Wiederholungsanzahlen",
      different_repeat_execution_mode: "unterschiedliche Ausführungsstrategien für Wiederholungen",
      different_case_coverage: "unterschiedliche Fragenabdeckung",
      incomplete_case_coverage: "unvollständige Abdeckung der Fragenausführung",
      run_ineligible: "ein unvollständiger oder nicht beendeter Durchlauf",
      same_environment: "für den Umgebungsvergleich wurde dieselbe Umgebung ausgewählt",
    },
    transition: {
      fixed: "von fehlgeschlagen zu stabil bestanden",
      regressed: "von stabil bestanden zu fehlgeschlagen",
      improved: "Bewertung verbessert",
      regressed_score: "Bewertung gesunken",
      same: "unverändert",
      stabilized: "von instabil zu stabil",
      destabilized: "von stabil zu instabil",
      incomparable: "unvollständiges Ergebnis",
      baseline_only: "nur Ausgangslauf",
      candidate_only: "nur Kandidat",
    },
    loadingTitle: "Berichte werden geladen",
    loadingDescription: "Abgeschlossene Testergebnisse werden abgerufen. Bitte warten.",
    errorTitle: "Berichte konnten nicht geladen werden",
    errorDescription: "Die Berichtsliste ist vorübergehend nicht verfügbar.",
    emptyTitle: "Noch kein Bericht verfügbar",
    emptyPending: "{count} Durchläufe werden noch ausgeführt oder synchronisiert; nach Abschluss erscheinen sie hier.",
    emptyDescription: "Berichte erscheinen hier automatisch nach Abschluss der Evaluierungsdurchläufe.",
    viewActiveRuns: "Aktive Durchläufe anzeigen",
    importSuite: "Testsuite importieren",
    noMatchTitle: "Keine passenden Berichte",
    noMatchDescription: "Passen Sie Suchbegriff oder Filter an.",
    clearAllFilters: "Alle Filter löschen",
    selectCompare: "Für Vergleich auswählen",
    selectCompareAria: "{title} für Vergleich auswählen",
    compareNeedTwo: "Zum Vergleichen sind mindestens 2 Berichte erforderlich",
    runIdMeta: "Durchlauf-ID · {id}",
    finishedMeta: "Beendet · {time}",
    filterByAgentTitle: "Nur Berichte von AI Engineer {agent} anzeigen",
    consistencyMeta: "Konsistenz {value}%",
    durationTitle: "Dauer {duration}",
    incomplete: {
      cases: "Unvollständige Ergebnisse · {count} Fragen",
      runError: "Unvollständige Ergebnisse · Durchlauffehler",
      systemErrors: "Unvollständige Ergebnisse · {count} Ausführungsfehler",
      executed: "Unvollständige Ergebnisse · {executed}/{expected} Wiederholungen ausgeführt",
      missingScore: "Unvollständige Ergebnisse · fehlende Bewertungen",
    },
    quality: {
      unknown: "Kein eindeutiges Ergebnis",
      gateFailed: "Qualitätsprüfung fehlgeschlagen",
      failedCases: "{count} aggregierte Fragen unter der Schwelle",
      incompleteTitle: "{label} (gleiche Definition wie „unvollständige Ergebnisse“ in den Berichtsdetails)",
      consistencyLow: "Konsistenz nur {value}%",
      attention: "Mit Elementen, die Aufmerksamkeit erfordern",
      attentionTitle: "Mit Elementen, die Aufmerksamkeit erfordern (Konsistenz / Ergebnisvollständigkeit)",
      passed: "Alle bestanden",
      passedTitle: "Alle aggregierten Fragen bestanden",
    },
    cases: {
      executedSkipped: "{executed} ausgeführt · {skipped} übersprungen",
      executedSkippedTitle: "{executed} ausführbar, {skipped} übersprungen{repeats}. Gründe finden Sie in den Berichtsdetails.",
      runnable: "{executed} / {source}",
      runnableTitle: "Dieser Bericht enthält {executed} / {source} Fragen{repeats}",
      aggregate: "{count} Fragen · {repeats} Wiederholungen",
      aggregateTitle: "{count} aggregierte Fragen; {repeats} Wiederholungen",
      repeatSuffix: "; {count} Wiederholungen",
    },
    compareField: {
      suite: "Testsuite",
      judgeModel: "Judge-Modell",
      passThreshold: "Bestehensschwelle",
      maxScore: "Höchstpunktzahl",
      scoringRule: "Bewertungsregel",
      contentSnapshot: "Fragen- / Referenzantwort-Snapshot",
      promptSnapshot: "Judge-Prompt-Snapshot",
    },
    sort: {
      finished: "Nach Endzeit, neueste zuerst (Standard)",
      score: "Nach durchschnittlicher Fragenbewertung (absteigend)",
      passRate: "Nach Bestehensquote der Runden (absteigend)",
      failedCases: "Nach wenigsten fehlgeschlagenen Fragen",
      duration: "Nach Dauer (absteigend)",
    },
    csv: {
      title: "Berichtstitel",
      runId: "Durchlauf-ID",
      passRate: "Bestehensquote der Runden",
      cases: "Fragenzusammenfassung",
      finishedAt: "Beendet am",
    },
    column: {
      report: "Bericht",
      quality: "Qualitätsergebnis",
      score: "Durchschnitt / Bestehensquote",
      completedQuestions: "Abgeschlossene Fragen",
      finished: "Beendet / Dauer",
    },
  },
  newRun: {
    pickerDescription: "Bleiben Sie auf der aktuellen Seite und konfigurieren Sie Projekt → Umgebung → AI Engineer → Testsuite → Evaluierungsprofil.",
    loadingProjects: "Projekte werden geladen…",
    projectsLoadFailed: "Projekte konnten nicht geladen werden: {message}",
    noRunnableProjects: "Kein Projekt kann eine Evaluierung starten. Der bisherige Container „default“ kann keine Durchläufe erstellen.",
    goToProjectAdmin: "Zur Projektverwaltung",
    selectProject: "Projekt auswählen",
    selectProjectFirst: "Wählen Sie zum Fortfahren ein Projekt aus",
    projectStepHint: "Nach der Projektauswahl werden nur dessen Umgebungen und Testressourcen geladen.",
    projectLockedHint: "Die weitere Konfiguration wurde bereits ausgefüllt. Brechen Sie diesen Entwurf ab und öffnen Sie ihn erneut, um das Projekt zu wechseln.",
    pageTitle: "{name} · Neue Testaufgabe",
    pageDescription: "Wählen Sie Umgebung, AI Engineers, Testsuite und Wiederholungsanzahl zum Start aus; bei einem vollständigen Profil wird nur eine Zusammenfassung angezeigt.",
    unnamedEnv: "Unbenannte Umgebung",
    defaultProjectNotice: "Das bisherige Containerprojekt „default“ kann keine neuen Durchläufe starten; wählen Sie ein anderes Projekt.",
    defaultProjectBlocked: "Das Standardprojekt ist nur ein Container für historische Daten und kann keine neuen Durchläufe starten.",
    suiteMissingNotice: "Die Testsuite im Link ist nicht mehr vorhanden oder gehört nicht zu diesem Projekt; wählen Sie eine andere aus.",
    missing: {
      model: "Modell",
      baseUrl: "Dienst-URL",
      apiKey: "API-Schlüssel",
      scoringRule: "Bewertungsregel",
      passThreshold: "Bestehensschwelle",
      maxScore: "Höchstpunktzahl",
      template: "Im Evaluierungsprofil fehlt {field}",
    },
    blocker: {
      selectProfile: "Evaluierungsprofil auswählen",
      defaultProject: "Das Standardprojekt kann keine Evaluierungen erstellen",
      selectBinding: "Umgebungsbindung auswählen",
      loadingAgents: "AI Engineers der aktuellen Umgebung werden geladen…",
      agentsFailed: "AI Engineers konnten nicht geladen werden: {message}",
      selectAgent: "Wählen Sie mindestens einen AI Engineer aus",
      noAgents: "In dieser Umgebung wurde kein verfügbarer AI Engineer gefunden",
      suiteAllSkipped: "Diese Testsuite enthält keine ausführbare Frage ({count} werden übersprungen)",
      selectSuite: "Wählen Sie eine Testsuite dieses Projekts mit mindestens einer ausführbaren Frage aus",
      profileIncomplete: "{issues}. Vervollständigen Sie zuerst das Evaluierungsprofil",
      customPrompt: "Geben Sie den benutzerdefinierten Judge-Prompt für diesen Durchlauf ein",
      libraryPrompt: "Wählen Sie einen Projekt-Prompt aus oder geben Sie einen temporären Prompt-Text ein",
      repeatRange: "Die Wiederholungsanzahl muss eine Ganzzahl zwischen 1 und {max} sein",
      nameRequired: "Durchläufe mit hohem Volumen erfordern einen Namen",
      storageUnknown: "Die Verbindung zum Datenspeicher kann derzeit nicht bestätigt werden",
      settingsUnavailable: "Umgebungsbindungen oder Evaluierungsprofile sind nicht verfügbar",
      validateAgentContext: "Validieren Sie vor dem Start die URL der AI Engineer-Seite",
    },
    fix: {
      configureBinding: "Umgebungsbindung konfigurieren",
      checkBinding: "Umgebungsbindung prüfen",
      prepareSuite: "Testsuite vorbereiten",
      goToProfiles: "Zu den Evaluierungsprofilen",
      completeProfile: "Evaluierungsprofil vervollständigen",
      openSettings: "Projekteinstellungen öffnen",
    },
    hint: {
      retryInAgentArea: "Sie können es im AI Engineer-Bereich erneut versuchen",
      pickAgents: "Markieren Sie die zu testenden AI Engineers",
      switchEnv: "Wechseln Sie die Umgebung oder prüfen Sie die Mandantenkonfiguration",
    },
    evalHint: {
      usingDefault: "Das Standardprofil des Projekts wird verwendet; ändern Sie es bei Bedarf.",
      manual: "Ein manuell ausgewähltes Evaluierungsprofil wird verwendet; ändern Sie es bei Bedarf.",
      fallback: "Es ist kein Projektstandard festgelegt. Daher wird ein Ersatzprofil verwendet; ändern Sie es bei Bedarf.",
      noDefault: "Das Projekt hat kein Standard-Evaluierungsprofil; wählen Sie zuerst eines aus.",
      generic: "Evaluierungsprofil und Bewertungs-Prompt legen fest, wie Antworten bewertet werden.",
    },
    summary: {
      project: "Projekt: {name}",
      suite: "Testsuite: {name}",
      runnable: "Ausführbare Fragen: {count}",
      skipped: "Übersprungen: {count} ({disabled} deaktivierte Fragen, {archived} archivierte Fragen, {suiteDisabled} deaktivierte Testsuite-Elemente)",
      repeat: "Wiederholungsanzahl: {count}",
      environment: "Umgebung: {name}",
      contractContext: "Aktuelle IM-Production-Route: {route}",
      contractContextEmpty: "AI Engineer-Kontext: leer (optional)",
      contractContextDisabled: "AI Engineer-Kontext: für dieses Projekt deaktiviert",
      profile: "Evaluierungsprofil: {name}",
      prompt: "Judge-Prompt: {name}{snapshot}",
      promptLibrary: "Projektbibliothek",
      promptSnapshot: " (mit temporärem Text-Snapshot)",
      promptNotApplicable: "Judge-Prompt: für Nicht-LLM-Judges nicht anwendbar",
      agents: "AI Engineers ({count}): {names}",
      estimatedCalls: "Geschätzte Aufrufe: {count} AI Engineer-Aufrufe plus dieselbe Anzahl Judge-Aufrufe",
    },
    promptSaved: "Als Projekt-Prompt „{name}“ gespeichert",
    agentContextUrl: "URL der IM-Production-Seite (optional)",
    agentContextPlaceholder: "Zum Beispiel https://im.example.com/contracts/123/clauses?clauseId=456",
    agentContextOptionalHint: "Speichert und sendet den Pfad mit der vollständigen Abfrage. IM Production löst Geschäftsentitäten und Seitenstatus auf. Keine URLs mit Token, Signaturen oder Zugangsdaten eingeben.",
    validateAgentContext: "Validieren",
    agentContextResolved: "Aktuelle Route erkannt: {route}",
    promptSaveFailed: "Prompt konnte nicht gespeichert werden: {message}",
    promptBodyRequired: "Geben Sie zuerst einen Prompt-Text zum Speichern ein",
    promptNameRequired: "Geben Sie einen Prompt-Namen ein",
    batchCreated: "Evaluierungsstapel erstellt: {id}",
    runCreated: "Evaluierungsdurchlauf erstellt: {id}",
    partialTitle: "Einige Ziele haben die Vorprüfung nicht bestanden",
    partialDescription: "Es wurde noch kein Durchlauf erstellt. Durch Bestätigen werden ungeeignete Ziele übersprungen und Durchläufe nur für ausführbare Ziele erstellt.",
    partialEligible: "{count} Ziele sind ausführbar.",
    partialNoEligible: "Derzeit kein ausführbares Ziel.",
    partialConfirm: "Ungeeignete Ziele überspringen und erstellen",
    partialCancelled: "Teilweise Erstellung abgebrochen",
    createFailed: "Durchlauf konnte nicht erstellt werden: {message}",
    suiteRefreshFailed: "Testsuite-Status konnte nicht aktualisiert werden. Versuchen Sie es erneut",
    suiteChangedWithSkipped: "Der Testsuite-Status hat sich geändert und enthält keine ausführbare Frage ({count} werden übersprungen)",
    suiteChanged: "Der Testsuite-Status hat sich geändert und enthält keine ausführbare Frage",
    confirmSkipTitle: "Ungeeignete Ziele überspringen?",
    confirmCreateTitle: "Diesen Evaluierungsdurchlauf erstellen?",
    confirmSkipDescription: "Einige Ziele haben die Vorprüfung nicht bestanden. Durch Bestätigen werden Durchläufe nur für ausführbare Ziele erstellt.",
    confirmCreateDescription: "Prüfen Sie vor dem Start die folgende Konfiguration.",
    start: "Evaluierung starten",
    leaveTitle: "Neue Testaufgabe verlassen?",
    leaveDescription: "Diese Evaluierung enthält nicht gespeicherte Änderungen. Der Entwurf geht verloren.",
    leaveConfirm: "Trotzdem verlassen",
    discardTitle: "Diese neue Evaluierung verwerfen?",
    discardDescription: "Der nicht gespeicherte Entwurf geht verloren.",
    discardConfirm: "Entwurf verwerfen",
    customThisRun: "Benutzerdefiniert für diesen Durchlauf",
    notSelected: "Nicht ausgewählt",
    backToRuns: "Zurück zu den Testaufgaben",
    step1Title: "Wo und wen testen",
    step1Hint: "Beim Wechseln der Umgebung werden die AI Engineers dieses Mandanten geladen; wählen Sie anschließend die Ziele für diesen Durchlauf aus.",
    step2Title: "Was und wie oft testen",
    step2Hint: "Wählen Sie eine Testsuite dieses Projekts und bestätigen Sie die Wiederholungsanzahl.",
    envBinding: "Umgebungsbindung",
    configureBindingFirst: "Konfigurieren Sie zuerst eine Umgebungsbindung",
    bindingUnset: "Nicht festgelegt (Umgebungsbindung auswählen)",
    agentsLabel: "AI Engineers (Mehrfachauswahl)",
    agentsAutoLoad: "Automatisch aus Umgebung „{name}“ geladen",
    agentsAfterEnv: "AI Engineers des Mandanten werden nach Auswahl einer Umgebung automatisch geladen",
    selectAll: "Alle auswählen",
    selectAllVisible: "Alle sichtbaren auswählen",
    clear: "Löschen",
    loadingAgents: "AI Engineers werden geladen…",
    loadFailed: "Laden fehlgeschlagen: {message}",
    agentSearchPlaceholder: "Name, Code oder Rolle suchen",
    agentFilterAria: "AI Engineers filtern",
    selectAgents: "AI Engineers auswählen",
    noMatchingAgents: "Kein passender AI Engineer; passen Sie den Filter an",
    selectedCount: "{selected} / {total} ausgewählt",
    willCreateRuns: "{count} separate Durchläufe werden erstellt",
    willCreateOneRun: "1 Durchlauf wird erstellt",
    selectToStart: "Markieren Sie AI Engineers, um die Evaluierung zu starten",
    selectedNone: "0 ausgewählt",
    noSuites: "Noch keine Testsuite in diesem Projekt",
    suiteUnset: "Nicht festgelegt (Testsuite auswählen)",
    repeatRuns: "Wiederholungsanzahl",
    runNameRequired: "Durchlaufname (erforderlich)",
    runNameOptional: "Durchlaufname (optional)",
    runnableCases: "Ausführbare Fragen",
    willSkip: "Wird übersprungen",
    estimatedCalls: "Geschätzte Aufrufe",
    estimatedCallsValue: "{count} AI Engineer · {count} Judge",
    pendingAgent: "AI Engineer ausstehend",
    selectedAgents: "Ausgewählte AI Engineers",
    collapseAdvanced: "Erweitert einklappen",
    change: "Ändern",
    projectDefaultSuffix: " (Projektstandard)",
    fallbackSuffix: " (Ersatz)",
    promptLabel: "Prompt",
    editedSuffix: " (vorübergehend bearbeitet)",
    viewProjectDefault: "Projektstandard anzeigen",
    setProjectDefault: "Projektstandard festlegen",
    createProfileFirst: "Erstellen Sie zuerst ein Evaluierungsprofil",
    profileUnset: "Nicht ausgewählt (kein Projektstandard)",
    noDefaultProfileHint: "Dieses Projekt hat kein Standard-Evaluierungsprofil; wählen Sie hier eines aus oder ",
    setDefaultLink: "legen Sie einen Standard fest",
    periodSuffix: ".",
    profileBlockedPrefix: "Das Evaluierungsprofil kann noch nicht starten: {issues}. ",
    goComplete: "Vervollständigen",
    profileReady: "Aktueller Evaluator: {kind}; das Profil erfüllt die Ausführungsvoraussetzungen.",
    promptMode: "Prompt-Modus",
    promptModeLibrary: "Aus Bibliothek",
    promptLibraryUnavailable: "Die Prompt-Bibliothek ist nicht verfügbar",
    noPrompts: "Noch kein Prompt in diesem Projekt",
    promptUnset: "Nicht festgelegt (Prompt auswählen)",
    profileRecommended: "Vom Profil empfohlen: {name}",
    switchToCustomHint: "Wechseln Sie zum Fortfahren zu „Benutzerdefiniert für diesen Durchlauf“.",
    promptPreview: "Vollständige Vorschau / temporäre Bearbeitung",
    promptCustomBody: "Benutzerdefinierter Prompt-Text für diesen Durchlauf",
    promptPreviewPlaceholder: "Bei Auswahl eines Projekt-Prompts wird der vollständige Text eingefügt, den Sie vor diesem Durchlauf anpassen können.",
    promptCustomPlaceholder: "Geben Sie den vollständigen Prompt ein, den LLM Judge für diesen Durchlauf verwendet.",
    promptSource: "Quelle: {name}",
    promptNotSelected: "Noch kein Projekt-Prompt ausgewählt",
    promptEditedHint: "; der Text wurde vorübergehend bearbeitet und wird nicht in die Bibliothek zurückgeschrieben.",
    promptCustomHint: "Der benutzerdefinierte Text wird nur mit diesem Durchlauf übermittelt; speichern Sie ihn zur Wiederverwendung als Projekt-Prompt.",
    saveAsProjectPrompt: "Als Projekt-Prompt speichern",
    promptNamePlaceholder: "z. B. Strenger Bewertungs-Prompt",
    preflightTitle: "Vorprüfung und Übermittlung",
    preflightDescription: "Der Server prüft, ob die AI Engineers noch vorhanden sind. Wenn einige Ziele fehlschlagen, können Sie dies bestätigen und sie überspringen.",
    canSubmit: "Bereit zur Übermittlung",
    cannotSubmit: "Nicht bereit zur Übermittlung",
    serverPrecheck: "Der Server führt nach der Übermittlung die verbindliche Vorprüfung aus",
    highVolumeConfirm: "Bestätigung für hohes Volumen: Geben Sie den Durchlaufnamen „{name}“ ein",
    highVolumeConfirmAria: "Durchlaufname zur Bestätigung für hohes Volumen",
    cancelledDraftKept: "Abgebrochen; der aktuelle Entwurf bleibt erhalten",
    nameMismatch: "Der Durchlaufname stimmt nicht überein. Daher wurde kein Durchlauf erstellt",
  },
  production: {
    pageDescription: "Systemdatensätze aus AI Engineer synchronisieren und Fragenkandidaten vor der Veröffentlichung im Fragenkatalog aufbereiten.",
    projectPrefix: "Projekt: {name}",
    tabsAria: "Arbeitsbereich für Datensynchronisierung",
    tabCandidates: "Fragenkandidaten",
    tabSync: "Synchronisierungskonfiguration",
    loadingWorkspace: "Arbeitsbereich für Produktivkonversationen wird geladen",
    loadingWorkspaceHint: "Projekt und Datengrenzen werden bestätigt.",
    feedback: {
      all: "Alle Rückmeldungen",
      negative: "Daumen nach unten",
      positive: "Daumen nach oben",
      none: "Keine Rückmeldung",
    },
    duration: {
      seconds: "{value} s",
      minutes: "{value} Min.",
      hours: "{value} Std.",
      days: "{value} T.",
    },
    totalDuration: "Gesamtdauer",
    elapsed: "Vergangen: {value}",
    remaining: "Noch etwa {value}",
    remainingUnknown: "Verbleibend: noch nicht abschätzbar",
    tenantReadFailed: "Mandanten konnten nicht gelesen werden: {message}",
    agentReadFailed: "AI Engineers konnten nicht gelesen werden: {message}",
    capabilityOk: "Prüfung der Funktion History Read bestanden",
    capabilityUnavailable: "Die Funktion History Read ist derzeit nicht verfügbar",
    capabilityFailed: "Funktionsprüfung fehlgeschlagen: {message}",
    previewFailed: "Vorschau fehlgeschlagen: {message}",
    syncJobCreated: "Synchronisierungsstapel erstellt; der Worker verarbeitet ihn aus dem Snapshot",
    syncJobCreateFailed: "Synchronisierungsstapel konnte nicht erstellt werden: {message}",
    policyUpdated: "Filterrichtlinie aktualisiert und neue Version erstellt",
    policySaved: "Filterrichtlinie gespeichert",
    policySaveFailed: "Richtlinie konnte nicht gespeichert werden: {message}",
    policyDisabled: "Filterrichtlinie deaktiviert; vorhandene Synchronisierungsstapel bleiben unverändert",
    policyDisableFailed: "Richtlinie konnte nicht deaktiviert werden: {message}",
    filterConversation: "Konversationen filtern",
    filterHint: "Die Vorschau liest nur das Remotesystem; ein Synchronisierungsstapel wird erst nach Ihrer Bestätigung erstellt.",
    savedPolicy: "Gespeicherte Richtlinie",
    temporaryFilter: "Temporärer Filter",
    temporaryFilterSuffix: " · temporärer Filter",
    policyVersionSuffix: " · Richtlinie v{version}",
    connectionHint: "Es werden nur aktivierte Verbindungen mit history_read angezeigt; Mandanten werden nach Auswahl automatisch geladen",
    connectionLabel: "Verbindung",
    connectionAria: "Verbindung",
    pleaseSelect: "Bitte auswählen",
    selectConnectionFirst: "Wählen Sie zuerst eine Verbindung aus",
    loadingTenants: "Mandanten werden geladen…",
    readFailedRetry: "Lesen fehlgeschlagen; Sie können es erneut versuchen",
    selectTenant: "Mandanten auswählen",
    noTenants: "Diese Verbindung hat keinen Mandanten",
    autoLoadFromConnection: "Automatisch mit der Verbindung geladen",
    retryTenants: "Mandanten erneut laden",
    agentOptional: "AI Engineer (optional)",
    selectTenantFirst: "Wählen Sie zuerst einen Mandanten aus",
    loadingAgents: "AI Engineers werden geladen…",
    autoLoadFromTenant: "Automatisch mit dem Mandanten geladen",
    retryAgents: "AI Engineers erneut laden",
    userFeedback: "Benutzerrückmeldung",
    startTime: "Startzeit",
    endTime: "Endzeit",
    scope: "Eigentumsbereich",
    scopeMine: "Meine",
    scopeShared: "Geteilt",
    conversationStatus: "Konversationsstatus",
    allStatuses: "Alle Status",
    statusActive: "Aktiv",
    statusRunning: "Läuft",
    statusCompleted: "Abgeschlossen",
    statusError: "Fehler",
    sourceDomain: "Quelldomäne",
    sourceDomainHint: "Nach der E-Mail-Domäne des Benutzers filtern; die Eingabe web/api liefert meist 0 Ergebnisse",
    blankMeansAll: "Leer = alle",
    syncLimit: "Synchronisierungslimit",
    syncLimitAria: "Synchronisierungsanzahl",
    syncLimitHint: "Maximale Anzahl der von diesem Stapel hinzugefügten Konversationen",
    policyName: "Richtlinienname",
    policyNamePlaceholder: "z. B. Konversationen mit Daumen nach unten der letzten 7 Tage",
    disable: "Deaktivieren",
    updatePolicy: "Richtlinie aktualisieren",
    saveAsPolicy: "Als Richtlinie speichern",
    historyReadPrefix: "History Read: ",
    notVerified: "Noch nicht geprüft",
    checkCapability: "Verbindungsfunktion prüfen",
    verifyHistoryReadFirst: "Prüfen Sie zuerst die Funktion History Read der aktuellen Verbindung und des Mandanten",
    previewing: "Vorschau wird erstellt…",
    previewSync: "Synchronisierungsvorschau",
    noHistoryReadConnection: "Dieses Projekt hat keine nutzbare history_read-Verbindung. Konfigurieren Sie die Funktion zuerst in den Verbindungseinstellungen.",
    disablePolicyTitle: "Filterrichtlinie „{name}“ deaktivieren?",
    unnamedPolicy: "Unbenannte Richtlinie",
    disablePolicyDescription: "Nach der Deaktivierung verschwindet die Richtlinie aus der Auswahlliste und kann keine neuen Stapel erstellen; vorhandene Stapel und Kandidaten bleiben unverändert.",
    currentVersion: "Aktuelle Version: v{version}",
    disablePolicyIrreversible: "Die Deaktivierung kann nicht rückgängig gemacht werden; speichern Sie bei Bedarf eine neue Richtlinie.",
    disablePolicyConfirm: "Richtlinie deaktivieren",
    disabling: "Wird deaktiviert…",
    syncPreview: "Synchronisierungsvorschau",
    syncPreviewHint: "Bestätigen Sie den Umfang, bevor Sie einen Stapel erstellen.",
    noPreview: "Noch keine Vorschau",
    noPreviewHint: "Wählen Sie die Filter und klicken Sie auf „Synchronisierungsvorschau“.",
    remoteEstimate: "Remote-Schätzung",
    discovered: "Gefunden",
    alreadySynced: "Bereits synchronisiert",
    evalSkip: "Evaluierung übersprungen",
    evalSkipTitle: "Von der Evaluierungsplattform gestartete Konversationen (einschließlich Wiederholungen)",
    plannedNew: "Neu geplant",
    incompleteWindows: "{count} Zeitfenster konnten nicht vollständig aufgelistet werden.",
    confirmSync: "{count} Konversationen synchronisieren",
    jobStatusUpdated: "Stapelstatus aktualisiert",
    actionFailed: "Aktion fehlgeschlagen: {message}",
    loadingJobs: "Synchronisierungsstapel werden geladen",
    loadingJobsHint: "Stapelstatus und Statistiken werden gelesen.",
    jobsLoadFailed: "Synchronisierungsstapel konnten nicht geladen werden",
    syncJobs: "Synchronisierungsprotokoll",
    syncJobsHint: "Verbindungsrevision und Filter-Snapshot werden bei der Erstellung eingefroren. Sortiert nach Erstellungszeit absteigend; Spaltenköpfe bieten keine Filterung oder Sortierung.",
    jobsTableLabel: "Production-Synchronisierungsstapel",
    column: {
      createdAt: "Erstellt am",
      processed: "Verarbeitet",
      duration: "Dauer",
      candidates: "Kandidaten",
      duplicate: "Dedupliziert",
      failed: "Fehlgeschlagen",
      incompleteWindows: "Unvollständige Fenster",
      filterSummary: "Filterzusammenfassung",
      attempts: "Versuche",
      error: "Fehler",
      candidate: "Kandidat",
      turns: "Runden",
      lastEdited: "Zuletzt bearbeitet",
      conversation: "Konversation",
    },
    processedTitle: "Verarbeitet = Konversationen (erfolgreich/übersprungen + fehlgeschlagen) · Remote-Treffer {remote} · Limit {limit} · Kandidaten rechts",
    dateRange: "{from} bis {to}",
    viewJobCandidates: "Kandidaten dieses Stapels anzeigen",
    collapse: "Einklappen",
    retryFailed: "Fehlgeschlagene Elemente wiederholen",
    noJobs: "Noch kein Synchronisierungsstapel",
    noJobsHint: "Erstellen und bestätigen Sie zuerst unter „Erweitert · Stichproben synchronisieren“ eine Vorschau.",
    loadingJobDetail: "Stapeldetails werden geladen",
    loadingJobDetailHint: "Eingefrorener Snapshot und Ergebnisse je Element werden gelesen.",
    jobDetailFailed: "Stapeldetails konnten nicht geladen werden",
    jobHeading: "Stapel {id}",
    createdBy: "Erstellt von",
    startedAt: "Gestartet",
    finishedAt: "Beendet",
    authTenant: "Authentifizierter Mandant",
    viewSnapshot: "Vollständigen Filter-Snapshot und Fensterstatus anzeigen",
    snapshotTitle: "Filter-Snapshot von Stapel {id}",
    snapshotDescription: "Die bei Stapelerstellung eingefrorenen Filterbedingungen und der Zustand der Fensterauflistung, schreibgeschützt.",
    jobItemsTableLabel: "Details der Konversationsverarbeitung im Stapel",
    noJobItems: "Noch keine Konversationsdetails",
    noJobItemsHint: "Das ist normal, solange der Stapel eingereiht ist; der Worker erfasst jedes Element nach dem Start.",
    cancelJobTitle: "Synchronisierungsstapel {id} abbrechen?",
    cancelJobDescription: "Der Worker nimmt die verbleibenden {count} Konversationen nicht mehr auf. Verarbeitete Elemente und erzeugte Kandidaten bleiben erhalten.",
    cancelJobProcessed: "{done} / {target} Konversationen verarbeitet",
    cancelJobCandidates: "{count} Kandidaten erzeugt",
    cancelJobIrreversible: "Der Abbruch kann nicht rückgängig gemacht werden; erstellen Sie für die verbleibenden Konversationen einen neuen Stapel.",
    cancelJobConfirm: "Stapel abbrechen",
    cancelling: "Wird abgebrochen…",
    bulk: {
      reject: "ablehnen",
      markDuplicate: "als Duplikat markieren",
      addTags: "Tags hinzufügen",
    },
    bulkPartial: "{label}: {ok} erfolgreich, {failed} fehlgeschlagen",
    bulkDone: "Massenaktion „{label}“ auf {count} Kandidaten angewendet",
    bulkFailed: "Massenaktion fehlgeschlagen: {message}",
    adoptPartial: "{ok} Production-Antworten übernommen, {failed} übersprungen oder fehlgeschlagen",
    adoptDone: "{count} Production-Antworten gesammelt übernommen; öffnen Sie den Editor zur Prüfung",
    unnamedCandidate: "Unbenannter Kandidat",
    loadingCandidates: "Kandidaten werden geladen",
    loadingCandidatesHint: "Kandidaten und ihr Vollständigkeitsstatus werden gelesen.",
    candidatesLoadFailed: "Kandidaten konnten nicht geladen werden",
    queueTitle: "Ausstehende Warteschlange",
    metricsAria: "Verarbeitungskennzahlen des Fragenkatalogs",
    pendingTitle: "Ausstehende und in Bearbeitung befindliche Kandidaten",
    pending: "Ausstehend",
    viewPending: "Ausstehende Kandidaten anzeigen",
    promotionRate: "Übernahmequote {value}%",
    promoted: "In den Fragenkatalog übernommen",
    viewPromoted: "Übernommene Fragenkandidaten anzeigen",
    jobCount: "{count} Synchronisierungsstapel",
    loadingMetrics: "Betriebskennzahlen werden geladen",
    synced: "Synchronisiert",
    viewJobs: "Synchronisierungsstapel anzeigen",
    medianDuration: "Mediandauer",
    medianDurationTitle: "Medianzeit von Synchronisierung bis manueller Freigabe",
    searchCandidates: "Kandidaten durchsuchen",
    searchPlaceholder: "Quellfrage, Antwort, Rückmeldung oder Entwurfsinhalt",
    candidateStatus: "Kandidatenstatus",
    statusActiveQueue: "Ausstehend + Bearbeitung",
    editing: "Bearbeitung",
    rejected: "Abgelehnt",
    duplicate: "Duplikat",
    completeness: "Vollständigkeit",
    completeReady: "Bereit zur Übernahme",
    missingQuestion: "Unvollständige Frage",
    missingGroundTruth: "Referenzantwort fehlt",
    attachmentUnresolved: "Anlage ausstehend",
    needsWork: "Überarbeitung nötig",
    feedbackLabel: "Rückmeldung",
    feedbackType: "Rückmeldungstyp",
    syncJob: "Synchronisierungsstapel",
    allJobs: "Alle Stapel",
    moreFilters: "Weitere Filter",
    moreFiltersCount: " ({count} aktiv)",
    ratingLevel: "Quellbewertung",
    allRatings: "Alle Bewertungen",
    stars: "{count} Sterne",
    editedFilter: "Bearbeitet",
    editedFilterAria: "Bearbeitungsstatus",
    clearSelection: "Auswahl aufheben",
    editedYes: "Bearbeitet",
    editedNo: "Nicht bearbeitet",
    editor: "Bearbeiter",
    editorPlaceholder: "Name oder Konto",
    syncedFrom: "Synchronisiert ab",
    syncedTo: "Synchronisiert bis",
    sourceCreatedFrom: "Zeitpunkt der Produktivkonversation ab",
    sourceCreatedTo: "Zeitpunkt der Produktivkonversation bis",
    editedFrom: "Zuletzt bearbeitet ab",
    editedTo: "Zuletzt bearbeitet bis",
    bulkAria: "Massenaktionen für Kandidaten",
    selectedCount: "{count} ausgewählt",
    bulkScopeHint: "Die Auswahl bleibt seitenübergreifend erhalten; Massenaktionen gelten für jedes ausgewählte Element ({count} auf dieser Seite).",
    tags: "Tags",
    adopting: "Wird übernommen…",
    adoptBulk: "Production-Antworten gesammelt übernehmen",
    duplicateTarget: "Duplikatziel",
    duplicateTargetType: "Duplikatzieltyp",
    candidateId: "Kandidaten-ID",
    questionId: "Fragen-ID",
    duplicateTargetId: "Duplikatziel-ID",
    duplicateTargetPlaceholder: "Ziel-ID im selben Projekt eingeben",
    bulkReject: "Gesammelt ablehnen",
    sortNote: "Standardsortierung: Daumen nach unten zuerst → kürzere Konversationen → zuletzt synchronisiert (fest; keine Spaltenfilterung oder -sortierung)",
    candidatesTableLabel: "Production-Kandidaten",
    selectPageAria: "Bearbeitbare Kandidaten auf dieser Seite auswählen (Auswahl bleibt seitenübergreifend erhalten)",
    selectCandidateAria: "Kandidat {title} auswählen",
    turnCount: "{count} Runden",
    noCandidates: "Kein passender Kandidat",
    noCandidatesFiltered: "Der aktuelle Filter ergab keinen Kandidaten; löschen Sie die Filter und versuchen Sie es erneut.",
    noCandidatesHint: "Synchronisieren Sie zuerst Production-Konversationen; Kandidaten werden automatisch erzeugt.",
    rejectTitle: "Die {count} ausgewählten Kandidaten ablehnen?",
    rejectDescription: "Abgelehnte Kandidaten erreichen einen Endzustand und können nicht mehr freigegeben werden; der Snapshot der Production-Quelle bleibt erhalten.",
    affectedCount: "{count} betroffen (seitenübergreifend ausgewählt, {onPage} auf dieser Seite)",
    rejectIrreversible: "Die Ablehnung kann nicht rückgängig gemacht werden; verwenden Sie sie für unbrauchbare Elemente oder nicht verarbeitbare Konversationen.",
    rejectConfirm: "Gesammelt ablehnen",
    rejecting: "Wird abgelehnt…",
    markDuplicateTitle: "{count} Kandidaten als Duplikate markieren?",
    markDuplicateDescription: "Markierte Kandidaten erreichen den Endzustand „Duplikat“ und können nicht freigegeben werden.",
    duplicateTargetSummary: "Duplikatziel: {type} {id}",
    candidateLabel: "Kandidat",
    questionLabel: "Frage",
    markDuplicateConfirm: "Als Duplikat markieren",
    marking: "Wird markiert…",
  },
  candidate: {
    draftSaved: "Kandidatenentwurf gespeichert · {time}",
    saveFailed: "Speichern fehlgeschlagen: {message}",
    splitDone: "Nach Runden in separate Kandidaten aufgeteilt; neuer Kandidat {id} wird geöffnet",
    splitFailed: "Aufteilen fehlgeschlagen: {message}",
    rejected: "Kandidat abgelehnt; falls verfügbar, wurde zum nächsten gewechselt",
    rejectFailed: "Ablehnung fehlgeschlagen: {message}",
    markedDuplicate: "Kandidat als Duplikat markiert; falls verfügbar, wurde zum nächsten gewechselt",
    markDuplicateFailed: "Markieren als Duplikat fehlgeschlagen: {message}",
    promoted: "Fragenkandidat in den Fragenkatalog übernommen",
    promoteFailed: "Übernahme fehlgeschlagen: {message}",
    noSourceAnswer: "Für diese Runde gibt es keine Production-Antwort zum Übernehmen",
    filledTurn: "Production-Antwort aus Runde {index} übernommen",
    filledAll: "{count} Production-Antworten übernommen; prüfen und speichern",
    nothingToFill: "Keine Production-Antwort zum Übernehmen",
    terminalRejected: "Dieser Kandidat wurde abgelehnt; fahren Sie mit dem nächsten fort oder kehren Sie zur Warteschlange zurück.",
    terminalDuplicate: "Dieser Kandidat wurde als Duplikat markiert; fahren Sie mit dem nächsten fort oder kehren Sie zur Warteschlange zurück.",
    terminalPromoted: "Dieser Fragenkandidat wurde in den Fragenkatalog übernommen; öffnen Sie die Frage oder fahren Sie mit dem nächsten fort.",
    terminalGeneric: "Dieser Kandidat hat einen Endzustand erreicht.",
    needOneTurn: "Behalten Sie mindestens eine Runde mit Frage und Referenzantwort.",
    completeTurns: "Vervollständigen Sie Frage und Referenzantwort jeder Runde.",
    confirmAttachment: "Bestätigen Sie, dass die Abhängigkeit von der Anlage bearbeitet wurde.",
    saveBeforePromote: "Speichern Sie den Entwurf vor der Übernahme in den Fragenkatalog.",
    handleDuplicateCandidate: "Markieren Sie ihn als Duplikat oder bearbeiten Sie zuerst den anderen Kandidaten.",
    handleDuplicateQuestion: "Markieren Sie ihn als Duplikat oder erstellen Sie aus der vorhandenen Frage eine neue Version.",
    loadingTitle: "Kandidateneditor wird geladen",
    loadingDescription: "Unveränderliche Quelle und Kandidatenentwurf werden gelesen.",
    openFailed: "Der Kandidat kann nicht geöffnet werden",
    backToCandidates: "Zurück zu den Kandidaten",
    backToQueue: "Zurück zur Kandidatenwarteschlange",
    backToQueueShort: "Zurück zur Warteschlange",
    editorTitle: "Kandidateneditor",
    editorDescription: "Die Production-Quelle links ist schreibgeschützt; nur der Inhalt rechts wird zur Referenzantwort im Fragenkatalog.",
    queuePosition: "Warteschlange {index} / {total}",
    queueNavAria: "Navigation der Kandidatenwarteschlange",
    previous: "Zurück",
    next: "Weiter",
    viewQuestion: "Frage anzeigen",
    terminalHint: "Veraltete Validierungs- und Bearbeitungssteuerelemente wurden entfernt. Die nächste Aktion befindet sich in der unteren Leiste; das Fortsetzen der Warteschlange ist dem Verbleib auf einer schreibgeschützten Seite vorzuziehen.",
    sourceTitle: "Production-Quelle",
    sourceHint: "Der bei der Synchronisierung gespeicherte unveränderliche Konversations-Snapshot",
    readOnly: "Schreibgeschützt",
    agentPrefix: "AI Engineer: {name}",
    userPrefix: "Benutzer: {name}",
    targetRound: "Zielrunde: {value}",
    targetRoundHint: "Die Zielrunde stimmte bei der Synchronisierung mit der Rückmeldung überein; Konversationen mit mehreren Runden zeigen weiterhin den vollständigen Dialog als Referenz.",
    targetRoundNote: " (Rückmeldungsrunde; die Konversation kann weitere Runden enthalten)",
    fillAllGt: "Referenzantworten für alle Runden übernehmen",
    fillAllHint: "Nach dem Übernehmen müssen Sie weiterhin prüfen und speichern.",
    userRound: "Benutzer · Runde {round}",
    productionAnswer: "Production-Antwort (nur als Referenz, keine Referenzantwort)",
    fillGt: "Referenzantwort übernehmen",
    attachmentCount: "Enthält {count} Anlagenverweise",
    draftTitle: "Kandidatenentwurf",
    draftHint: "Formulieren Sie die Frage neu und ergänzen Sie für jede Runde eine Referenzantwort.",
    splitByTurn: "In Elemente mit einer Runde aufteilen",
    titleOptional: "Titel (optional)",
    turnOrdinal: "Runde {index}",
    deleteTurn: "Runde {index} löschen",
    question: "Frage",
    groundTruth: "Referenzantwort",
    gtPlaceholder: "Referenzantwort für diese Runde eingeben",
    addTurn: "Runde hinzufügen",
    tags: "Fragen-Tags",
    note: "Bearbeitungshinweis",
    attachmentHandled: "Anlagenabhängigkeit manuell bearbeitet",
    attachmentHandledHint: "Bestätigen Sie, dass die Frage ohne die ursprüngliche Anlage verständlich ist oder dass die benötigten Informationen in der Frage enthalten sind.",
    duplicateFound: "Eine identische Frage wurde gefunden",
    officialQuestionPrefix: "Fragenkatalog: ",
    candidatePrefix: "Kandidat: ",
    duplicateTerminalHint: "Dieser Kandidat befindet sich in einem Endzustand; der Duplikatlink bleibt nur zur Nachverfolgbarkeit erhalten.",
    duplicateCandidateHint: "Öffnen Sie vor der Freigabe den Vergleich und markieren Sie ihn als Duplikat oder bearbeiten Sie zuerst den anderen Kandidaten.",
    duplicateQuestionHint: "Wählen Sie eine Option: als Duplikat markieren oder aus der vorhandenen Frage eine neue Version erstellen.",
    markDuplicate: "Als Duplikat markieren",
    newVersionFromQuestion: "Neue Version aus vorhandener Frage erstellen",
    terminalNoValidation: "Endzustand: keine weitere Validierung erforderlich",
    validationPassed: "Vollständigkeitsprüfung bestanden",
    unsaved: "Nicht gespeicherte Änderungen",
    savedAt: "Gespeichert um {time}",
    persistedAt: "Persistiert · {time}",
    reject: "Ablehnen",
    saveDraft: "Entwurf speichern",
    promoting: "Wird übernommen…",
    promote: "In den Fragenkatalog übernehmen",
    rejectTitle: "Diesen Kandidaten ablehnen?",
    rejectDescription: "Ein abgelehnter Kandidat erreicht einen Endzustand und kann nicht freigegeben werden; der Snapshot der Production-Quelle bleibt erhalten. Falls vorhanden, wechseln Sie zum nächsten Kandidaten.",
    candidateSummary: "Kandidat: {name}",
    rejectHint: "Für unbrauchbare Elemente oder nicht verarbeitbare Konversationen verwenden; die Ablehnung kann nicht rückgängig gemacht werden.",
    rejectConfirm: "Ablehnen",
    splitTitle: "Nach Runden in separate Kandidaten aufteilen?",
    splitDescription: "Aus dem aktuellen Entwurf mit mehreren Runden (etwa {count} Runden) werden neue unabhängige Kandidatenkopien erzeugt. Das Original bleibt erhalten; bearbeiten Sie beide getrennt, damit identische Inhalte nicht unbearbeitet bleiben.",
    splitHint: "Nach dem Aufteilen wird der neue Kandidat geöffnet; das Original bleibt in der Warteschlange.",
    splitConfirm: "Aufteilen",
    splitting: "Wird aufgeteilt…",
    duplicateTitle: "Als Duplikat markieren?",
    duplicateDescription: "Der Kandidat erreicht den Endzustand „Duplikat“ und wird nicht freigegeben. Falls vorhanden, wechseln Sie zum nächsten Kandidaten.",
    duplicateTargetQuestion: "Duplikatziel (Frage): {name}",
    duplicateTargetCandidate: "Duplikatziel (Kandidat): {name}",
    duplicateCompareHint: "Öffnen Sie das Duplikat vor der Bestätigung zum Vergleich.",
    discardTitle: "Nicht gespeicherte Entwurfsänderungen verwerfen?",
    discardListDescription: "Dieser Kandidat enthält nicht gespeicherte Änderungen; bei der Rückkehr zur Warteschlange werden sie verworfen.",
    discardNeighborDescription: "Dieser Kandidat enthält nicht gespeicherte Änderungen; beim Wechsel zu einem anderen Kandidaten werden sie verworfen.",
    discardHint: "Wählen Sie „Weiter bearbeiten“, um den Entwurf vor dem Verlassen zu speichern.",
    discardConfirm: "Verwerfen und verlassen",
    keepEditing: "Weiter bearbeiten",
  },
  questionBank: {
    globalDescription: "Projektübergreifend Fragen und aktuelle Versionen durchsuchen; Erstellen, Importieren und Bearbeiten erfolgen im Fragenkatalog des zugehörigen Projekts.",
    globalProjectFilterAria: "Fragenkataloge nach zugehörigem Projekt filtern",
    globalSummary: "{count} Fragen",
    globalFilteredHint: "Es werden nur Fragen angezeigt, die den aktuellen Filtern entsprechen.",
    globalNoQuestionsHint: "Noch keine Fragen verfügbar; erstellen oder importieren Sie diese im Fragenkatalog eines Projekts.",
    globalQuestionId: "Fragen-ID",
    globalCurrentVersion: "Aktuelle Version",
    openInProject: "Im Projekt anzeigen",
    backToAllBanks: "Zurück zu allen Fragenkatalogen",
    manageProjects: "Projekte verwalten",
    pickProjectTitle: "Projekt-Fragenkatalog auswählen",
    pickProjectHint: "Ohne Projektkontext können keine Fragen erstellt oder importiert werden.",
    loadingProjects: "Projekte werden geladen",
    projectsLoadFailed: "Projekte konnten nicht geladen werden",
    projectFallbackDescription: "Fragen und Versionen dieses Projekts pflegen",
    questionCount: "{count} Fragen",
    noProjects: "Noch kein Projekt verfügbar",
    noProjectsHint: "Erstellen Sie zuerst ein Projekt und fügen Sie dann Fragen zu seinem Katalog hinzu.",
    pageTitle: "{name} · Fragenkatalog",
    pageDescription: "Markieren Sie Fragen, um eine Testsuite zusammenzustellen, oder importieren Sie eine Excel-Datei. Beim Bearbeiten wird eine neue Version erstellt; vorhandene Testsuites verweisen weiterhin auf die ursprüngliche.",
    backToSuite: "Zurück zur Testsuite",
    backToContent: "Zurück zu den Inhalten",
    tagManager: "Tag-Verwaltung",
    import: "Importieren",
    newQuestion: "Neue Frage",
    editQuestion: "Frage bearbeiten",
    importStatus: {
      uploaded: "Hochgeladen",
      parsing: "Wird analysiert",
      review: "Prüfung ausstehend",
      awaitingSuiteName: "Testsuite-Name ausstehend",
      committing: "Wird geschrieben",
      completed: "Abgeschlossen",
      failed: "Fehlgeschlagen",
      cancelled: "Abgebrochen",
    },
    currentVersion: "Aktuelle Version",
    historicalVersion: "Historische Version",
    multiTurn: "Mehrere Runden · {count} Runden",
    multiTurnShort: "Mehrfach·{count}",
    singleTurn: "Eine Runde",
    conversationFilter: "Konversation",
    conversationFilterAria: "Nach Konversationstyp filtern",
    conversationAll: "Alle",
    conversationMulti: "Mehrere Runden",
    turnsFilter: "Runden",
    turnsFilterAria: "Nach Rundenanzahl filtern",
    turnsFilterAll: "Alle Gruppen mit mehreren Runden",
    turnBucket: {
      exact: "{count} Runden",
      fivePlus: "5+ Runden",
    },
    activeFiltersAria: "Aktive Filter",
    activeFilter: {
      search: "Suche: {query}",
      status: "Status: {status}",
      conversation: "Konversation: {mode}",
      turns: "Runden: {turns}",
      tag: "Tag: {tag}",
    },
    removeFilter: "Filter {label} entfernen",
    moreTags: "+{count}",
    suiteBarHintOutsideFilter: "{count} ausgewählt ({outside} außerhalb des aktuellen Filters)",
    keepVisibleSelection: "Nur sichtbare behalten",
    clearSelection: "Auswahl aufheben",
    versionTurnsAria: "Konversationsrunden von v{version}",
    turnOrdinal: "Runde {index}",
    turnId: "Runden-ID: {id}",
    userInput: "Benutzereingabe",
    groundTruth: "Referenzantwort",
    actionFailedRetry: "Aktion fehlgeschlagen. Versuchen Sie es später erneut",
    suiteNameRequired: "Geben Sie einen Testsuite-Namen ein",
    suiteNameTooLong: "Der Testsuite-Name darf höchstens {max} Zeichen lang sein",
    suiteNameDuplicate: "Eine Testsuite mit diesem Namen ist im Projekt bereits vorhanden",
    selectAtLeastOne: "Wählen Sie zuerst mindestens 1 Frage aus",
    importLoadFailed: "Importdatensatz konnte nicht geladen werden: {message}",
    questionDisabled: "Frage {code} deaktiviert",
    questionEnabled: "Frage {code} aktiviert",
    disableFailed: "Frage konnte nicht deaktiviert werden: {message}",
    enableFailed: "Frage konnte nicht aktiviert werden: {message}",
    tagReused: "Vorhandenes Tag wiederverwendet",
    tagCreated: "Projekt-Tag erstellt und ausgewählt",
    editorRequiredFields: "Füllen Sie die Fragen-ID sowie Benutzereingabe und Referenzantwort jeder Runde aus",
    savedAsNewVersion: "Frage als neue Version gespeichert",
    questionAdded: "Frage zu diesem Projekt hinzugefügt",
    saveFailed: "Frage konnte nicht gespeichert werden: {message}",
    historyLoadFailed: "Versionsverlauf konnte nicht geladen werden: {message}",
    targetProject: "Zielprojekt",
    copied: "Nach {name} kopiert; spätere Versionen bleiben unabhängig",
    copyFailed: "Frage konnte nicht kopiert werden: {message}",
    deletedWithSuites: "Frage gelöscht; {count} vorhandene Testsuites behalten die ursprüngliche Version",
    deleted: "Frage aus dem Katalog dieses Projekts gelöscht",
    deleteFailed: "Frage konnte nicht gelöscht werden: {message}",
    suiteCreated: "Testsuite erstellt: {name}. Als Nächstes können Sie eine Evaluierung starten.",
    suiteCreateFailed: "Testsuite konnte nicht erstellt werden: {message}",
    pickXlsx: ".xlsx-Datei auswählen",
    parsedWithConflicts: "Analyse abgeschlossen; {count} Konflikte müssen gelöst werden",
    parsedReady: "Analyse abgeschlossen; der Import kann übermittelt werden",
    parseFailed: "Importdatei konnte nicht analysiert werden: {message}",
    importCommitted: "Import in dieses Projekt geschrieben",
    suiteNameConflict: "Der Testsuite-Name steht in Konflikt; ändern Sie ihn und fahren Sie fort",
    importIntentConflict: "Dieser Import wurde bereits mit einer anderen Konfliktlösung geschrieben; die Seite zeigt jetzt den Datenbankstatus",
    commitFailed: "Import konnte nicht geschrieben werden: {message}",
    composeHint: "Zusammenstellungsmodus: Fragen markieren, unten einen Testsuite-Namen eingeben und erstellen; die Testsuite verwendet die aktuellen Fragenversionen.",
    locatedPrefix: "Frage gefunden ",
    locatedSuffix: " und Filter entfernt, die sie ausblenden könnten.",
    closeLocation: "Fundstelle schließen",
    questionMissing: "Die Frage im Link gehört nicht zu diesem Projekt oder wurde gelöscht.",
    closeNotice: "Hinweis schließen",
    tagFilters: "Tag-Filter",
    recentImports: "Letzte Importe",
    rowCount: "{count} Zeilen",
    noImports: "Noch kein Importdatensatz",
    newImport: "Neuer Import",
    searchPlaceholder: "Fragen-ID oder Frage suchen",
    clearSearch: "Suche löschen",
    questionStatus: "Fragenstatus",
    questionStatusFilterAria: "Nach Fragenstatus filtern",
    statusActive: "Aktiviert",
    statusDisabled: "Deaktiviert",
    statusArchived: "Archiviert",
    refreshBank: "Fragenkatalog aktualisieren",
    listSummary: "{range} von {total} angezeigt",
    selectedSuffix: " · {count} ausgewählt",
    listSummaryTail: " · Alle auswählen gilt nur für diese Seite · sortiert nach {sort}",
    defaultSort: "Aktualisierungszeit, neueste zuerst",
    sortLabel: "Sortieren",
    sortAria: "Sortierung der Fragenliste",
    sortContentUpdatedDesc: "Zuletzt bearbeitet",
    sortCodeAsc: "Fragen-ID aufsteigend",
    selectedCount: "{count} ausgewählt",
    loadingBank: "Fragenkatalog wird geladen",
    bankLoadFailed: "Fragenkatalog konnte nicht geladen werden",
    noMatching: "Keine passende Frage",
    noMatchingHint: "Die Filter bleiben erhalten; löschen Sie sie und versuchen Sie es erneut.",
    noQuestions: "Dieses Projekt enthält noch keine Frage",
    noQuestionsHint: "Fügen Sie eine Frage hinzu, importieren Sie eine Excel-Datei oder kopieren Sie aus einem anderen Projekt.",
    importExcel: "Excel importieren",
    selectPageAria: "Alle aktivierten Fragen auf dieser Seite auswählen",
    selectPageTitle: "Nur aktivierte Fragen auf dieser Seite werden ausgewählt",
    selectQuestion: "{code} auswählen",
    disabledCannotSelect: "Die Frage ist deaktiviert und kann keiner Testsuite hinzugefügt werden",
    fromProduction: "Aus Production",
    disableQuestionAria: "Frage {code} deaktivieren",
    enableQuestionAria: "Frage {code} aktivieren",
    disabling: "Wird deaktiviert…",
    enabling: "Wird aktiviert…",
    history: "Verlauf",
    copyToProject: "In anderes Projekt kopieren",
    noOtherProjects: "Kein anderes Projekt verfügbar",
    suiteBarAria: "Testsuite aus ausgewählten Fragen erstellen",
    suiteBarHint: "{count} Fragen ausgewählt; geben Sie einen Namen ein, um eine Testsuite mit den aktuellen Versionen zu erstellen.",
    suiteNameLabel: "Testsuite-Name *",
    suiteNamePlaceholder: "z. B. Testsuite für Bestandsregression",
    suiteNameValid: "Der Name ist gültig; eine Testsuite mit {count} Fragen kann erstellt werden",
    createSuiteButton: "Testsuite erstellen ({count})",
    importTitle: "In dieses Projekt importieren",
    importDescription: "Eine Vorlage deckt Fragen mit einer oder mehreren Runden ab: Fragen haben Tags, Runden Benutzereingabe und Referenzantwort.",
    importProgress: "{phase}, vergangen: {elapsed}",
    parsingFile: "Datei wird analysiert",
    writing: "Wird geschrieben",
    importMode: "Importmodus",
    importModeAria: "Importmodus",
    importModeBank: "Nur Fragenkatalog",
    importModeSuite: "Importieren und Testsuite erstellen",
    importSuiteNameAria: "Testsuite-Name für den Import",
    suiteNameHelp: "Höchstens {max} Zeichen, innerhalb des Projekts eindeutig.",
    excelFile: "Excel-Datei",
    pickExcelAria: "Excel-Datei auswählen",
    downloadTemplate: "Excel-Vorlage herunterladen",
    reparse: "Erneut analysieren und prüfen",
    parseStep: "1. Analysieren und prüfen",
    unitQuestions: "Fragen",
    unitTurns: "Runden",
    unitMultiTurn: "mehrere Runden",
    unitNew: "neu",
    unitReused: "wiederverwendet",
    unitBlocking: "blockierende Konflikte",
    recoveryTitle: "Fragen geschrieben, Testsuite noch nicht erstellt",
    recoveryHint: "Der ursprüngliche Name „{name}“ ist vergeben. Geben Sie oben einen neuen Testsuite-Namen ein; Fragen werden nicht doppelt erstellt.",
    committingTitle: "Fragen bereits geschrieben",
    committingHint: "Die Testsuite wird mit dem gesperrten Namen „{name}“ erstellt; Fragen werden nicht doppelt erstellt.",
    suiteNameRecheck: "Ändern Sie oben den Testsuite-Namen; das Backend validiert ihn bei der Übermittlung erneut.",
    column: {
      codeVersion: "Fragen-ID / Version",
      conversation: "Konversation",
      row: "Zeile",
      codeQuestion: "Fragen-ID / Frage",
      suggestion: "Vorschlag",
      conflict: "Konflikt",
      resolution: "Lösung",
    },
    action: {
      create: "Erstellen",
      reuse: "Wiederverwenden",
      updateTags: "Tags aktualisieren",
      review: "Prüfung erforderlich",
    },
    noConflict: "Kein Konflikt",
    autoReuse: "Automatisch wiederverwenden",
    autoUpdateTags: "Tags automatisch aktualisieren",
    autoCreate: "Automatisch erstellen",
    footerCompleted: "Der Import ist abgeschlossen.",
    footerNeedNewName: "Geben Sie einen vom ursprünglichen Namen abweichenden Namen ein.",
    footerNameAvailable: "Der neue Name ist verfügbar; Sie können die Testsuite erstellen.",
    footerCommitting: "Fragen wurden geschrieben; Sie können die Testsuite erstellen und den Import abschließen.",
    footerLocked: "Der aktuelle Importstatus kann nicht fortgesetzt werden; aktualisieren Sie den Datensatz oder wenden Sie sich an einen Administrator.",
    footerUnresolved: "{count} blockierende Konflikte benötigen noch eine Lösung.",
    footerReady: "Alle blockierenden Konflikte sind gelöst; bereit zur Übermittlung.",
    viewSuite: "Testsuite anzeigen",
    continueWithNewName: "Mit neuem Namen fortfahren",
    continueImport: "Import abschließen",
    commitStep: "3. Bestätigen und schreiben",
    editorDescription: "Eine Runde bedeutet eine einzelne Runde; mehrere Runden werden nacheinander ausgeführt. Tags gelten für die gesamte Frage, Bewertungsregeln werden in der Evaluierung konfiguriert.",
    saveNewVersion: "Neue Version speichern",
    createQuestion: "Frage erstellen",
    codeHelp: "Die eindeutige Kennung der Frage innerhalb des Projekts.",
    codeRequired: "Fragen-ID ist erforderlich.",
    codeRequiredLabel: "Fragen-ID *",
    moveUp: "Nach oben",
    moveDown: "Nach unten",
    moveUpAria: "Runde {index} nach oben verschieben",
    moveDownAria: "Runde {index} nach unten verschieben",
    userInputRequired: "Benutzereingabe *",
    userInputHelp: "Die in dieser Runde an das zu testende System gesendete Eingabe.",
    userInputRequiredError: "Benutzereingabe ist erforderlich.",
    groundTruthRequired: "Referenzantwort *",
    groundTruthHelp: "Die erwartete Antwort, die als Bewertungsreferenz verwendet wird.",
    groundTruthRequiredError: "Referenzantwort ist erforderlich.",
    hidePreview: "Vorschau ausblenden",
    showPreview: "Konversationsvorschau",
    currentSingleTurn: "Aktuell eine Frage mit einer Runde",
    currentMultiTurn: "Aktuell eine Konversation mit {count} Runden",
    previewUserTurn: "Benutzer · Runde {index}",
    notFilled: "(noch nicht ausgefüllt)",
    loadingTags: "Verfügbare Tags werden geladen",
    tagsLoadFailed: "Tags konnten nicht geladen werden; der Frageninhalt bleibt erhalten.",
    discardTitle: "Nicht gespeicherte Änderungen verwerfen?",
    discardDescription: "Beim Schließen des Editors gehen die eingegebene Fragen-ID, Runden und Tags verloren.",
    discardConfirm: "Änderungen verwerfen",
    historyTitle: "{code} · Versionsverlauf",
    historyDescription: "Jede Bearbeitung erstellt eine schreibgeschützte historische Version, sodass Testsuite-Referenzen unverändert bleiben.",
    loadingHistory: "Verlauf wird geladen",
    copyTitle: "Frage in ein anderes Projekt kopieren",
    copyDescription: "Nur die aktuelle Version wird kopiert; das Zielprojekt erhält eine unabhängige Frage und einen unabhängigen Versionsverlauf.",
    copyQuestion: "Frage kopieren",
    targetProjectRequired: "Zielprojekt *",
    pleaseSelectProject: "Projekt auswählen",
    targetCodeRequired: "Ziel-Fragen-ID *",
    targetCodeHelp: "Die Fragenkennung innerhalb des Zielprojekts.",
    targetCodeRequiredError: "Ziel-Fragen-ID ist erforderlich.",
    disableTitle: "Diese Frage deaktivieren?",
    disableDescription: "Neue Testaufgaben überspringen die Frage anschließend; vorhandene Testsuites, Versionen und historische Durchläufe werden nicht gelöscht. Bereits erstellte Durchläufe bleiben unverändert.",
    disableNote: "Nach der Deaktivierung wird die Frage auch aus der aktuellen Testsuite-Auswahl entfernt; sie kann jederzeit erneut aktiviert werden.",
    disableConfirm: "Deaktivieren",
    deleteTitle: "Diese Frage löschen?",
    deleteDescription: "Die Frage wird im Katalog dieses Projekts ausgeblendet; Versionsverlauf und Referenzen in vorhandenen Testsuites und Berichten bleiben erhalten.",
    deleteNote: "Nach dem Löschen kann die Frage nicht in neuen Testsuites verwendet werden; vorhandene Evaluierungsdaten bleiben unverändert.",
    deleteConfirm: "Frage löschen",
    deleting: "Wird gelöscht…",
    resolveConflictAria: "Konflikt {id} lösen",
    resolution: {
      reuse: "Katalogversion wiederverwenden",
      createVersion: "Neue Fragenversion erstellen",
      newQuestion: "Als neue Frage importieren",
      skip: "Diese Zeile überspringen",
    },
  },
  reportComparison: {
    back: "Zurück zu Berichten", scope: "Fester Testumfang", multipleSuites: "Mehrere Testsuiten", selectedCount: "{count} Berichte ausgewählt", adjust: "Berichte anpassen",
    tabsAria: "Berichtsvergleich", tabs: { overview: "Übersicht", questions: "Fragenunterschiede", snapshots: "Laufzeit-Snapshots" },
    viewAria: "Diagrammansicht", horizontal: "Berichtsvergleich", timeline: "Zeitverlauf", loading: "Berichts-Snapshots werden geladen…", needTwo: "Wählen Sie mindestens 2 verfügbare Berichte aus.",
    metrics: { platform: "Plattformstabilität", platformHint: "Erfolgsquote je Bericht", stability: "Berichtsübergreifende Antwortkonsistenz", stabilityHint: "Antwortkonsistenz über Berichte derselben Testsuite hinweg", experience: "Nutzererlebnis", experienceHint: "Vollständige Antwort P50", cost: "Kosten", costHint: "Token pro erfolgreicher Frage", quality: "Antwortqualität", qualityHint: "Qualitätswert gültiger Antworten je Bericht" },
    higherBetter: "Höher ist besser", lowerBetter: "Niedriger ist besser", latestChanges: "Letzte Fragenänderungen", latestChangesHint: "Die letzten zwei zeitlich benachbarten Berichte", questionDifferences: "Wichtige Fragenunterschiede", questionDifferencesHint: "Spanne zwischen höchstem und niedrigstem Wert", viewAll: "Alle anzeigen", spread: "Spanne", noCommonQuestions: "Keine gemeinsam gültigen Fragen verfügbar.",
    question: "Frage", snapshotField: "Snapshot-Feld", releaseVersion: "Release version", releaseShort: "Release", agentVersion: "AI Engineer-Version", promptVersion: "Prompt-Version", agent: "AI Engineer", environment: "Umgebung", repeat: "Wiederholungen", notRecorded: "Nicht erfasst",
    selectorTitle: "Verglichene Berichte anpassen", selectorDescription: "{count} verfügbare Berichte. Wählen Sie mindestens 2; es gibt kein festes Maximum.", apply: "Auswahl anwenden", searchPlaceholder: "Bericht, AI Engineer oder Version suchen", historyAction: "Verlauf anzeigen", compareSelected: "Auswahl vergleichen ({count})",
    questionTableHint: "Frage anklicken für Antwortdetails · Alle {count} Berichte werden angezeigt · Spanne ist die letzte Spalte", questionTableScrollHint: "Horizontal scrollen für weitere Berichte", questionDetail: "Fragenvergleich", questionDetailDescription: "Antworten aus {count} Berichten vergleichen. Wiederholte Antworten lassen sich je Bericht wechseln.", previousQuestion: "Zurück", nextQuestion: "Weiter", standardAnswer: "Standardantwort", repeatAnswers: "Wiederholte Antworten", repeatNumber: "Antwort {count}", duration: "Dauer", judgeFindings: "Judge-Ergebnis",
  },
  crossEvaluation: {
    title: "Quervergleich", description: "Dieselben Bewertungsfragen auf angemeldeten KI-Plattformen ausführen. Jede Frage kann eine oder mehrere aufeinanderfolgende Runden enthalten.",
    navAria: "Navigation Quervergleich", nav: { tasks: "Vergleichsaufgaben", sources: "Datenquellen" }, configureSources: "Quellen konfigurieren", newBatch: "Neuer Vergleich",
    createTitle: "Neuer plattformübergreifender Vergleich", createHint: "Projektsuite und mindestens zwei Webplattformen wählen. Runden derselben Frage teilen eine Konversation; verschiedene Fragen bleiben getrennt.",
    batchName: "Vergleichsname", batchNamePlaceholder: "Beispiel: Plattformübergreifender Benchmark zur Vertragsprüfung", selectProject: "Projekt wählen", selectSuite: "Testsuite wählen", selectSources: "Plattformen wählen", evaluationProfile: "Evaluierungsprofil", selectProfile: "Evaluierungsprofil wählen", loadingProfiles: "Evaluierungsprofile werden geladen…",
    noActiveSources: "Keine aktive Quelle verfügbar. Zuerst Datenquellenverbindung und Webplattformen konfigurieren.",
    creating: "Wird erstellt…", start: "Vergleich starten", created: "„{name}“ erstellt", createFailed: "Vergleich konnte nicht erstellt werden: {message}",
    blockerName: "Vergleichsname eingeben.", blockerProject: "Projekt wählen.", blockerSuite: "Testsuite wählen.", blockerProfile: "Ein Evaluierungsprofil für die echte Judge-Bewertung wählen.", blockerSources: "Mindestens 2 echte Quellen wählen; aktuell {count}.", readySources: "{count} echte Quellen gewählt. Der Vergleich kann gestartet werden.",
    batchList: "Vergleichsaufgaben", batchListHint: "Echten Erfassungsfortschritt, Teilfehler und Berichte verfolgen.", loading: "Vergleiche werden geladen", loadingHint: "Unveränderliche Snapshots und Plattformstatus werden gelesen.",
    loadFailed: "Vergleiche konnten nicht geladen werden", emptyTitle: "Noch keine Vergleichsaufgaben", emptyHint: "Quellen konfigurieren und einen Vergleich mit geordneten Fragen erstellen.",
    filteredEmptyTitle: "Keine Ergebnisse für diese Filter", filteredEmptyHint: "Projekt-, Status-, Plattform- oder Stichwortfilter anpassen.", searchPlaceholder: "Name, Aufgaben-ID oder Testsuite-ID suchen", sortLabel: "Sortierung", sortNewest: "Erstellt: neueste zuerst", sortOldest: "Erstellt: älteste zuerst", tableAria: "Liste der Quervergleiche", batch: "Vergleich", progress: "Ausführungsfortschritt", progressValue: "{completed} / {total} abgeschlossen",
    sourcesTitle: "Datenquellen", sourcesDescription: "Browser-Recherche-Agent, KI-Plattformsitzungen und versionierte Erfassungsanweisungen konfigurieren.",
    configLoading: "Erfassungskonfiguration wird geladen", configLoadingHint: "Verbindungen, Quellen und aktiver Prompt werden gelesen.",
    connectionTitle: "Browser-Recherche-Agent", connectionHint: "Der Agent steuert angemeldete Browsersitzungen über einen nur schreibbaren API-Schlüssel, der nie in Lese-APIs, Prompts, Snapshots oder Protokollen erscheint.",
    connectionName: "Verbindungsname", apiBaseUrl: "API Base URL", apiKey: "API-Schlüssel", apiKeyHint: "Nur beim Speichern übertragen; danach wird nur angezeigt, ob ein Schlüssel vorhanden ist.", apiKeySavedPlaceholder: "Leer lassen, um den gespeicherten Schlüssel zu behalten", createConnection: "Verbindung erstellen",
    connectionModalTitle: "Datenquellenverbindung erstellen", connectionEditTitle: "Datenquellenverbindung bearbeiten", connectionModalHint: "Alle Webquellen können diese Verbindung wiederverwenden. Der API-Schlüssel wird als nur schreibbares Secret gespeichert.", connectionCountOne: "1 Verbindung", connectionCount: "{count} Verbindungen", connectionLoadFailed: "Verbindungen konnten nicht geladen werden",
    connectionCreated: "Verbindung erstellt", connectionUpdated: "Verbindung aktualisiert", connectionCreateFailed: "Verbindung konnte nicht erstellt werden: {message}", connectionUpdateFailed: "Verbindung konnte nicht aktualisiert werden: {message}", connectionDeleted: "Verbindung gelöscht", connectionDeleteFailed: "Verbindung konnte nicht gelöscht werden: {message}", noConnections: "Noch keine Verbindung", noConnectionsHint: "Vor Webquellen eine Workspace-Verbindung erstellen.",
    disableConnection: "Deaktivieren", enableConnection: "Aktivieren", connectionDeleteTitle: "Diese Verbindung löschen?", connectionDeleteDescription: "„{name}“ wird dauerhaft gelöscht. Zuerst alle verwendenden Quellen entfernen oder neu zuweisen.",
    secretConfigured: "API-Schlüssel konfiguriert", probe: "Verbindung prüfen", probing: "Wird geprüft…", probeSuccess: "Der Web-Erfassungskanal ist online", probeWarning: "Der Web-Erfassungskanal ist derzeit offline", probeFailed: "Verbindungsprüfung fehlgeschlagen: {message}",
    probeStatusReady: "Verbindung bereit", probeDetailReady: "Dienst, API-Schlüssel und Browser-Erweiterung wurden erfolgreich geprüft.",
    probeStatusExtensionOffline: "Browser-Erweiterung nicht verbunden", probeDetailExtensionOffline: "Dienst und API-Schlüssel sind gültig. Browser-Erweiterung starten oder erneut verbinden.",
    probeStatusServiceUnreachable: "Agent-Dienst nicht erreichbar", probeDetailServiceUnreachable: "Dienst-URL, Netzwerk und Bereitstellungsstatus prüfen und erneut versuchen.",
    probeStatusApiKeyMissing: "API-Schlüssel nicht konfiguriert", probeDetailApiKeyMissing: "API-Schlüssel konfigurieren und die Verbindung erneut prüfen.",
    probeStatusApiKeyInvalid: "API-Schlüssel ungültig", probeDetailApiKeyInvalid: "API-Schlüssel aktualisieren und die Verbindung erneut prüfen.",
    probeStatusConfigurationInvalid: "Verbindungskonfiguration ungültig", probeDetailConfigurationInvalid: "Agent-API-URL und Verbindungseinstellungen prüfen und erneut versuchen.",
    probeStatusServiceResponseInvalid: "Unerwartete Dienstantwort", probeDetailServiceResponseInvalid: "Der Dienst hat unerwartete Daten zurückgegeben. Dienstversion und API-URL prüfen.",
    probeStatusServiceError: "Dienstanfrage fehlgeschlagen", probeDetailServiceError: "Der Dienst hat geantwortet, aber die Prüfung ist fehlgeschlagen. Dienstprotokolle prüfen und erneut versuchen.",
    sourceTitle: "KI-Plattform-Quellen", sourceHint: "Jede Quelle definiert einen Plattformzugang und plattformspezifische Interaktionsanweisungen für den Browser-Recherche-Agenten.",
    sourceName: "Quellenname", platformCode: "Plattformcode", platformCodeImmutableHint: "Dient zur Zuordnung der Plattform-Anmeldedaten und kann nach dem Erstellen nicht geändert werden.", publicUrl: "Plattform-URL", targetUrl: "Agent-Zugriffs-URL", selectConnection: "Datenquellenverbindung wählen", createSource: "Quelle erstellen",
    platformLogin: "Plattformanmeldung", platformLoginEnabled: "Anmeldung für diese Plattform konfigurieren", platformLoginOptional: "Optional. Der Browser Research Agent speichert die Zugangsdaten sicher; dieser Dienst behält keine Kopie.", platformUsername: "Benutzername", platformPassword: "Passwort", platformPasswordSaved: "Leer lassen, um das gespeicherte Passwort beizubehalten", platformPasswordRequired: "Für ein neues Konto oder beim Wechsel der Agent-Verbindung ist ein Passwort erforderlich.", platformPasswordOptional: "Leer lassen, um das gespeicherte Passwort weiterzuverwenden.",
    sourceModalTitle: "KI-Plattform-Quelle erstellen", sourceEditTitle: "KI-Plattform-Quelle bearbeiten", sourceModalHint: "Jede Quelle steht für eine angemeldete Plattformsitzung und verwendet die ausgewählte Datenquellenverbindung.", sourceCount: "{count} Quellen", sourceNeedsConnection: "Eine Datenquellenverbindung ist erforderlich", sourceNeedsConnectionHint: "Jede Webquelle muss auf eine verfügbare Systemverbindung verweisen.",
    sourceCreated: "Webquelle erstellt", sourceUpdated: "Quelle aktualisiert", sourceDeleted: "Quelle gelöscht", sourceCreateFailed: "Quelle konnte nicht erstellt werden: {message}", sourceUpdateFailed: "Quelle konnte nicht aktualisiert werden: {message}", sourceDeleteFailed: "Quelle konnte nicht gelöscht werden: {message}", sourceDeleteTitle: "Diese Quelle löschen?", sourceDeleteDescription: "„{name}“ und ihre wiederverwendbaren Erfassungsaufgaben werden dauerhaft gelöscht. Historische Vergleiche müssen zuerst gelöscht werden.", sourceLoadFailed: "Quellen konnten nicht geladen werden", noSources: "Noch keine Webquellen", noSourcesHint: "Angemeldete ChatGPT-, Gemini- und ContractIQ-Websitzungen hinzufügen.", sourceTableAria: "Quellenliste Quervergleich", disableSource: "Deaktivieren", enableSource: "Aktivieren",
    interactionPrompt: "Plattformspezifische Interaktionsanweisungen", interactionPromptHint: "Navigation, semantische Bedienelemente, Konversationsregeln und Abschlusssignale beschreiben; das gemeinsame JSON-Ergebnisformat hier nicht neu definieren.",
    advancedConfiguration: "Erweiterte Konfiguration", promptTitle: "Erfassungs-Prompt", promptHint: "Die Vorlage steuert geordnete Fragen, wartet auf vollständige Antworten und fordert versioniertes JSON. Jeder Batch friert die Vorlage ein.", promptBody: "Prompt-Vorlage",
    promptContractHint: "Die sechs Doppelklammer-Variablen collection_task_id, source_id, platform_code, source_name, platform_instructions und questions_json müssen erhalten bleiben. JSON v2 validiert Aufgaben- und Plattformidentität, Runden, Reihenfolge, Text, Status und beobachtete Zeiten.",
    promptSaved: "Erfassungs-Prompt gespeichert", promptSaveFailed: "Prompt konnte nicht gespeichert werden: {message}", restorePrompt: "Standard wiederherstellen", promptRestored: "Standard-Prompt wiederhergestellt", promptRestoreFailed: "Prompt konnte nicht wiederhergestellt werden: {message}", promptLoadFailed: "Prompt konnte nicht geladen werden",
    deleteEvaluationTitle: "Diesen Vergleich löschen?", deleteEvaluationDescription: "„{name}“ sowie alle Erfassungsläufe, Antworten, Bewertungen und Ereignisse werden dauerhaft gelöscht.", evaluationDeleted: "Vergleich gelöscht", evaluationDeleteFailed: "Vergleich konnte nicht gelöscht werden: {message}",
    backToList: "Zurück zu Vergleichen", detailLoading: "Vergleichsdetails werden geladen", detailLoadingHint: "Plattformläufe, Antworten und Statusereignisse werden gelesen.", detailLoadFailed: "Vergleichsdetails konnten nicht geladen werden",
    profileSnapshot: "Snapshot der echten Bewertung: {name} · v{version}",
    detailDescription: "Projekt {project} · Testsuite {suite}", stop: "Aufgabe stoppen", stopping: "Wird gestoppt…", stopRequested: "Stopp angefordert", stopFailed: "Aufgabe konnte nicht gestoppt werden: {message}", stopConfirmTitle: "Diesen Vergleich stoppen?", stopConfirmDescription: "Die aktive Plattformerfassung wird gestoppt. Bereits erfasste Antworten bleiben verfügbar.", confirmStop: "Vergleich stoppen",
    retryFailedSources: "Fehlgeschlagene Plattformen wiederholen", retrying: "Wird wiederholt…", retryQueued: "Fehlgeschlagene Plattformen neu eingereiht", retryFailed: "Wiederholung fehlgeschlagen: {message}", viewReport: "Bericht anzeigen", partialFailureNotice: "Einige Plattformen sind fehlgeschlagen. Erfolgreiche echte Antworten bleiben verfügbar; fehlgeschlagene Plattformen können einzeln wiederholt werden.",
    statusHint: "Aggregierter Batchstatus", sourcesCompleted: "Abgeschlossene Plattformen", sourcesFailed: "Fehlgeschlagene Plattformen", platformResults: "Plattformergebnisse", platformResultsHint: "Abgeschlossen / Teilweise / Fehlgeschlagen", platformTotal: "Ausgewählte Plattformen", questionsCaptured: "Echte Antworten", sourceRuns: "Plattformläufe", sourceRunsHint: "Jede Plattform läuft unabhängig. Jede Frage nutzt eine wiederverwendbare Erfassungsaufgabe; jeder Aufruf behält einen eigenen Ausführungsdatensatz.",
    collectionQuestion: "Frage {order}", turnCount: "{count} aufeinanderfolgende Runden", executionDetails: "Ausführungsdetails", previousAttempts: "Frühere Versuche ({count})", collectionExecutionId: "Erfassungs-Ausführungs-ID", executionAttempt: "Ausführungsversuch", mispTaskId: "Erfassungsaufgaben-ID", queueEntryId: "Ausführungswarteschlangen-ID", attempt: "Worker-Versuche", attemptValue: "{current} / {max}", capturedAnswers: "Echt erfasste Antworten", capturedAnswersHint: "Antworten werden nach Frage und Runde gespeichert; die rohe Erfassungsausgabe bleibt zur Neuanalyse erhalten.",
    viewRawOutput: "Rohausgabe anzeigen", hideRawOutput: "Rohausgabe ausblenden", rawOutputLoading: "Rohe Erfassungsausgabe wird bei Bedarf geladen…", rawOutputLoadFailed: "Rohausgabe konnte nicht geladen werden: {message}", rawOutputEmpty: "Für diese Ausführung ist keine Rohausgabe verfügbar.", rawOutputSafetyNotice: "Sensible Daten maskiert: {redacted} · Inhalt gekürzt: {truncated}",
    answersPending: "Warten auf echte Antworten", answersPendingHint: "Der Browser-Recherche-Agent schließt die Plattformsitzung ab. Diese Seite wird automatisch aktualisiert.", noAnswers: "Keine Antworten anzuzeigen", noAnswersHint: "Plattformfehler und Ereignisse prüfen, dann fehlgeschlagene Quellen wiederholen.",
    assessmentStatus: "Bewertungsstatus", assessmentPending: "Wartet auf Bewertung", assessmentRunning: "Bewertung läuft", assessmentSkipped: "Keine bewertbare Antwort", assessmentFailed: "Bewertung fehlgeschlagen: {message}", assessmentFailedShort: "Bewertung fehlgeschlagen",
    answerTableAria: "Echte Antworten des Quervergleichs", order: "Reihenfolge", question: "Frage", platform: "Plattform", answer: "Antwort", assessment: "Bewertung", emptyAnswer: "Keine Antwort erfasst", timingUnavailable: "Beobachtete Dauer nicht verfügbar", notAssessed: "Nicht bewertet",
    events: "Aktivitätsverlauf", eventCount: "{count} Ereignisse", eventsHint: "Wichtige Batch- und Plattformänderungen ohne API-Schlüssel.", eventsLoadFailed: "Ereignisse konnten nicht geladen werden", noEvents: "Noch keine Ereignisse", noEventsHint: "Ereignisse erscheinen nach dem Start.",
    backToDetail: "Zurück zu Vergleichsdetails", reportLoading: "Vergleichsbericht wird erstellt", reportLoadingHint: "Fragen, Plattformen, echte Antworten und Bewertungen werden kombiniert.", reportLoadFailed: "Vergleichsbericht konnte nicht geladen werden",
    reportTitle: "{name} · Vergleichsbericht", reportDescription: "Echte Webantworten, beobachtete Zeiten und Bewertungen je Frage vergleichen.", downloadJson: "JSON herunterladen", downloadMarkdown: "Bericht herunterladen", printPdf: "Drucken / Als PDF speichern",
    horizontalComparison: "Vergleich je Frage", horizontalComparisonHint: "Plattformantworten stehen nebeneinander. Runden einer Frage behalten Kontext; verschiedene Fragen bleiben getrennt.", reportEmpty: "Noch keine Antworten im Bericht", reportEmptyHint: "Warten, bis mindestens eine Plattform die Erfassung abschließt.",
    coverage: "Antwortabdeckung", coverageHint: "{captured} erfasst / {expected} erwartet", sourceSuccessFailure: "Plattformen erfolgreich / fehlgeschlagen", successFailureHint: "Nach echten Endzuständen der Plattformläufe", averageDuration: "Durchschnittliche Messdauer", measuredCount: "Basierend auf {count} Antworten mit Browser-Messzeit", averageAnswerLength: "Durchschnittliche Antwortlänge", characterUnit: "Zeichen, nur echte erfasste Antworten", averageScore: "Durchschnittliche Qualitätsbewertung", scoredAnswerCount: "Basierend auf {count} bewerteten Antworten", reportMatrixAria: "Fragen-Plattform-Antwortmatrix",
    questionOrder: "Frage {order}", groundTruth: "Standardantwort: {answer}", sourceNoAnswer: "Diese Plattform hat für diese Frage keine Antwort geliefert.", viewFullAnswer: "Vollständige Antwort", answerDetailTitle: "Antwortdetails", answerDetailDescription: "Frage {order} · {source}", answerDetailNavigation: "Navigation der Antwortdetails", previousQuestion: "Vorherige Frage", nextQuestion: "Nächste Frage", answerLength: "Antwortlänge", answerLengthValue: "{count} Zeichen", noAnswerDetailHint: "Zur vorherigen oder nächsten Frage wechseln, um weitere Erfassungen dieser Plattform zu prüfen.",
  },
};
